export const ZEN_LEXICON = [
  {
    "id": "n5v001",
    "kana": "あう",
    "kanji": "会う",
    "romaji": "au",
    "en": "to meet",
    "bn": "দেখা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v002",
    "kana": "あおい",
    "kanji": "青い",
    "romaji": "aoi",
    "en": "blue",
    "bn": "নীল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v003",
    "kana": "あかい",
    "kanji": "赤い",
    "romaji": "akai",
    "en": "red",
    "bn": "লাল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v004",
    "kana": "あかるい",
    "kanji": "明るい",
    "romaji": "akarui",
    "en": "bright",
    "bn": "উজ্জ্বল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v005",
    "kana": "あき",
    "kanji": "秋",
    "romaji": "aki",
    "en": "autumn",
    "bn": "শরৎ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v006",
    "kana": "あける",
    "kanji": "開ける",
    "romaji": "akeru",
    "en": "to open",
    "bn": "খোলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v007",
    "kana": "あげる",
    "kanji": "上げる",
    "romaji": "ageru",
    "en": "to give",
    "bn": "দেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v008",
    "kana": "あさ",
    "kanji": "朝",
    "romaji": "asa",
    "en": "morning",
    "bn": "সকাল",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v009",
    "kana": "いま",
    "kanji": "今",
    "romaji": "ima",
    "en": "now",
    "bn": "এখন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v010",
    "kana": "いみ",
    "kanji": "意味",
    "romaji": "imi",
    "en": "meaning",
    "bn": "অর্থ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v011",
    "kana": "いもうと",
    "kanji": "妹",
    "romaji": "imouto",
    "en": "younger sister",
    "bn": "ছোট বোন",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v012",
    "kana": "いや",
    "kanji": "嫌",
    "romaji": "iya",
    "en": "disagreeable / unpleasant / unpleasant / no / unpleasant / disagreeable",
    "bn": "অপ্রিয় / অপ্রীতিকর",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v013",
    "kana": "いりぐち",
    "kanji": "入口",
    "romaji": "iriguchi",
    "en": "entrance",
    "bn": "প্রবেশদ্বার / প্রবেশপথ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v014",
    "kana": "いる",
    "kanji": "居る",
    "romaji": "iru",
    "en": "to exist (animate)",
    "bn": "আছে / থাকা (জীবন্ত)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v015",
    "kana": "いる",
    "kanji": "要る",
    "romaji": "iru",
    "en": "to need",
    "bn": "প্রয়োজন / প্রয়োজন হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v016",
    "kana": "いれる",
    "kanji": "入れる",
    "romaji": "ireru",
    "en": "to put in",
    "bn": "ভেতরে রাখা / ঢোকানো / রাখা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v017",
    "kana": "いろ",
    "kanji": "色",
    "romaji": "iro",
    "en": "color",
    "bn": "রং / রঙ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v018",
    "kana": "いろいろ",
    "kanji": null,
    "romaji": "iroiro",
    "en": "various",
    "bn": "বিভিন্ন",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v019",
    "kana": "うえ",
    "kanji": "上",
    "romaji": "ue",
    "en": "above / on top / up/above / up / above / top / above / top / on",
    "bn": "উপরে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v020",
    "kana": "うしろ",
    "kanji": "後ろ",
    "romaji": "ushiro",
    "en": "behind / back / behind",
    "bn": "পেছনে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v021",
    "kana": "うすい",
    "kanji": "薄い",
    "romaji": "usui",
    "en": "thin / weak (taste/color) / thin/weak / thin / weak (taste, color)",
    "bn": "পাতলা / পাতলা / হালকা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v022",
    "kana": "うた",
    "kanji": "歌",
    "romaji": "uta",
    "en": "song / song / singing",
    "bn": "গান",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v023",
    "kana": "うたう",
    "kanji": "歌う",
    "romaji": "utau",
    "en": "to sing",
    "bn": "গান গাওয়া / গান গাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v024",
    "kana": "うち",
    "kanji": "家",
    "romaji": "uchi",
    "en": "house / home / house/home",
    "bn": "বাড়ি",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v025",
    "kana": "うまれる",
    "kanji": "生まれる",
    "romaji": "umareru",
    "en": "to be born",
    "bn": "জন্মগ্রহণ করা / জন্মানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v026",
    "kana": "うみ",
    "kanji": "海",
    "romaji": "umi",
    "en": "sea / ocean / sea/ocean",
    "bn": "সমুদ্র",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v027",
    "kana": "うる",
    "kanji": "売る",
    "romaji": "uru",
    "en": "to sell",
    "bn": "বিক্রি করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v028",
    "kana": "うるさい",
    "kanji": null,
    "romaji": "urusai",
    "en": "noisy / annoying",
    "bn": "কোলাহলপূর্ণ / শব্দবহুল / বিরক্তিকর",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v029",
    "kana": "うわぎ",
    "kanji": "上着",
    "romaji": "uwagi",
    "en": "jacket / coat / jacket/coat",
    "bn": "জ্যাকেট / জ্যাকেট / কোট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v030",
    "kana": "え",
    "kanji": "絵",
    "romaji": "e",
    "en": "picture / drawing / picture/painting / picture / painting",
    "bn": "ছবি / ছবি / অঙ্কন",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v031",
    "kana": "えいが",
    "kanji": "映画",
    "romaji": "eiga",
    "en": "movie / movie / film",
    "bn": "চলচ্চিত্র / সিনেমা / সিনেমা / চলচ্চিত্র",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v032",
    "kana": "えいがかん",
    "kanji": "映画館",
    "romaji": "eigakan",
    "en": "movie theater",
    "bn": "সিনেমা হল",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v033",
    "kana": "えいご",
    "kanji": "英語",
    "romaji": "eigo",
    "en": "English language",
    "bn": "ইংরেজি ভাষা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v034",
    "kana": "ええ",
    "kanji": null,
    "romaji": "ee",
    "en": "yes (informal) / yes (casual) / yes / yeah (casual)",
    "bn": "হ্যাঁ",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v035",
    "kana": "えき",
    "kanji": "駅",
    "romaji": "eki",
    "en": "station",
    "bn": "স্টেশন",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v036",
    "kana": "えれべーたー",
    "kanji": "エレベーター",
    "romaji": "erebe-ta-",
    "en": "elevator",
    "bn": "লিফট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v037",
    "kana": "えん",
    "kanji": "円",
    "romaji": "en",
    "en": "yen / Yen / Yen / circle / yen / circle",
    "bn": "ইয়েন / ইয়েন / বৃত্ত / ইয়েন / বৃত্ত",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v038",
    "kana": "えんぴつ",
    "kanji": "鉛筆",
    "romaji": "enpitsu",
    "en": "pencil",
    "bn": "পেন্সিল",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v039",
    "kana": "おいしい",
    "kanji": null,
    "romaji": "oishii",
    "en": "delicious / delicious / tasty",
    "bn": "সুস্বাদু",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v040",
    "kana": "おおい",
    "kanji": "多い",
    "romaji": "ooi",
    "en": "many / frequent / many / a lot of",
    "bn": "অনেক / অনেক / প্রচুর",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v041",
    "kana": "おおきい",
    "kanji": "大きい",
    "romaji": "ookii",
    "en": "big / large",
    "bn": "বড়",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v042",
    "kana": "おおぜい",
    "kanji": "大勢",
    "romaji": "oozei",
    "en": "many people / crowd of people / great number of people",
    "bn": "অনেক মানুষ / অনেক লোক / জনসমাবেশ",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v043",
    "kana": "おかあさん",
    "kanji": "お母さん",
    "romaji": "okaasan",
    "en": "mother / mother (polite)",
    "bn": "মা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v044",
    "kana": "おかね",
    "kanji": "お金",
    "romaji": "okane",
    "en": "money",
    "bn": "টাকা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v045",
    "kana": "おきる",
    "kanji": "起きる",
    "romaji": "okiru",
    "en": "to wake up / get up / to get up / wake up / to happen/occur",
    "bn": "জেগে ওঠা / জাগা / ঘটা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v046",
    "kana": "おく",
    "kanji": "置く",
    "romaji": "oku",
    "en": "to put / place / to put/place",
    "bn": "রাখা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v047",
    "kana": "おくさん",
    "kanji": "奥さん",
    "romaji": "okusan",
    "en": "wife (someone else's) / someone's wife / wife (polite)",
    "bn": "স্ত্রী / কারো স্ত্রী",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v048",
    "kana": "おさけ",
    "kanji": "お酒",
    "romaji": "osake",
    "en": "alcohol / sake / alcohol/sake",
    "bn": "মদ / মদ / সাকে",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v049",
    "kana": "おさら",
    "kanji": "お皿",
    "romaji": "osara",
    "en": "plate / dish / plate/dish",
    "bn": "থালা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v050",
    "kana": "おじいさん",
    "kanji": null,
    "romaji": "ojiisan",
    "en": "grandfather / old man",
    "bn": "দাদা / নানা / দাদা/নানা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v051",
    "kana": "おしえる",
    "kanji": "教える",
    "romaji": "oshieru",
    "en": "to teach / tell / to teach/tell / to teach / inform",
    "bn": "শেখানো / শেখানো / বলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v052",
    "kana": "おじさん",
    "kanji": null,
    "romaji": "ojisan",
    "en": "uncle / middle-aged man",
    "bn": "চাচা / মামা / কাকা / মামা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v053",
    "kana": "おす",
    "kanji": "押す",
    "romaji": "osu",
    "en": "to push / to push / press",
    "bn": "ধাক্কা দেওয়া / ধাক্কা দেওয়া / চাপা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v054",
    "kana": "おそい",
    "kanji": "遅い",
    "romaji": "osoi",
    "en": "late / slow / slow/late / slow / late",
    "bn": "দেরি / ধীর / ধীর/দেরি / ধীর / দেরি",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v055",
    "kana": "おちゃ",
    "kanji": "お茶",
    "romaji": "ocha",
    "en": "tea / green tea",
    "bn": "চা",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v056",
    "kana": "おてあらい",
    "kanji": "お手洗い",
    "romaji": "otearai",
    "en": "bathroom / toilet / bathroom/toilet / restroom / toilet",
    "bn": "টয়লেট / শৌচাগার",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v057",
    "kana": "おとうさん",
    "kanji": "お父さん",
    "romaji": "otousan",
    "en": "father / father (polite)",
    "bn": "বাবা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v058",
    "kana": "おとうと",
    "kanji": "弟",
    "romaji": "otouto",
    "en": "younger brother",
    "bn": "ছোট ভাই",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v080",
    "kana": "エレベーター",
    "kanji": null,
    "romaji": "erebeetaa",
    "en": "elevator / elevator / lift",
    "bn": "লিফট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v082",
    "kana": "お～",
    "kanji": "御～",
    "romaji": "o-",
    "en": "honorific prefix",
    "bn": "সম্মানজনক উপসর্গ",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v088",
    "kana": "おかし",
    "kanji": "お菓子",
    "romaji": "okashi",
    "en": "sweets / sweets/candy / sweets / snacks / sweets / candy",
    "bn": "মিষ্টি / মিষ্টি / জলখাবার",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v095",
    "kana": "おじさん",
    "kanji": "伯父/叔父さん",
    "romaji": "ojisan",
    "en": "uncle",
    "bn": "চাচা/মামা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v096",
    "kana": "おじいさん",
    "kanji": "お祖父さん",
    "romaji": "ojiisan",
    "en": "grandfather / grandfather / old man",
    "bn": "দাদা/নানা / দাদা / নানা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v101",
    "kana": "おと",
    "kanji": "音",
    "romaji": "oto",
    "en": "sound / sound / noise",
    "bn": "শব্দ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v102",
    "kana": "おとこ",
    "kanji": "男",
    "romaji": "otoko",
    "en": "man / man / male",
    "bn": "পুরুষ / মানুষ/পুরুস",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v103",
    "kana": "おとこのこ",
    "kanji": "男の子",
    "romaji": "otokonoko",
    "en": "boy",
    "bn": "ছেলে",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v104",
    "kana": "おととい",
    "kanji": "一昨日",
    "romaji": "ototoi",
    "en": "day before yesterday",
    "bn": "গত পরশু / গতকালের আগের দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v105",
    "kana": "おととし",
    "kanji": "一昨年",
    "romaji": "ototoshi",
    "en": "year before last",
    "bn": "গত বছর / গত বছরের আগের বছর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v106",
    "kana": "おとな",
    "kanji": "大人",
    "romaji": "otona",
    "en": "adult",
    "bn": "প্রাপ্তবয়স্ক / প্রাপ্তবয়স্ক",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v107",
    "kana": "おなか",
    "kanji": null,
    "romaji": "onaka",
    "en": "stomach",
    "bn": "পেট",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v108",
    "kana": "おなじ",
    "kanji": "同じ",
    "romaji": "onaji",
    "en": "same",
    "bn": "একই",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v109",
    "kana": "おにいさん",
    "kanji": "お兄さん",
    "romaji": "oniisan",
    "en": "older brother / older brother (polite)",
    "bn": "বড় ভাই / বড় ভাই",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v110",
    "kana": "おねえさん",
    "kanji": "お姉さん",
    "romaji": "oneesan",
    "en": "older sister / older sister (polite)",
    "bn": "বড় বোন / বড় বোন",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v111",
    "kana": "おばあさん",
    "kanji": "お祖母さん",
    "romaji": "obaasan",
    "en": "grandmother / grandmother / old woman",
    "bn": "দাদী / নানী / দাদি / নানি",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v112",
    "kana": "おばさん",
    "kanji": "伯母/叔母さん",
    "romaji": "obasan",
    "en": "aunt",
    "bn": "চাচী / মামি",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v113",
    "kana": "おふろ",
    "kanji": "お風呂",
    "romaji": "ofuro",
    "en": "bath",
    "bn": "স্নান / গোসল",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v114",
    "kana": "おべんとう",
    "kanji": "お弁当",
    "romaji": "obentou",
    "en": "lunch box / boxed lunch / lunch box / bento",
    "bn": "লাঞ্চ বক্স / টিফিন",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v115",
    "kana": "おぼえる",
    "kanji": "覚える",
    "romaji": "oboeru",
    "en": "to remember / to remember / memorize / to remember / learn",
    "bn": "মনে রাখা / মনে রাখা / মুখস্থ করা / স্মরণ করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v116",
    "kana": "おまわりさん",
    "kanji": null,
    "romaji": "omawarisan",
    "en": "policeman (colloquial)",
    "bn": "পুলিশ (কথ্য)",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v117",
    "kana": "おもい",
    "kanji": "重い",
    "romaji": "omoi",
    "en": "heavy",
    "bn": "ভারী / ভারি",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v118",
    "kana": "おもしろい",
    "kanji": null,
    "romaji": "omoshiroi",
    "en": "interesting",
    "bn": "মজার",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v119",
    "kana": "およぐ",
    "kanji": "泳ぐ",
    "romaji": "oyogu",
    "en": "to swim",
    "bn": "সাঁতার কাটা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v120",
    "kana": "おりる",
    "kanji": "降りる",
    "romaji": "oriru",
    "en": "to get off / to get off / descend / to get off / disembark / to descend / get off",
    "bn": "নেমে যাওয়া / নামা / নামা (যানবাহন থেকে)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v121",
    "kana": "おわる",
    "kanji": "終わる",
    "romaji": "owaru",
    "en": "to finish / to finish / end / to end / finish",
    "bn": "শেষ করা / শেষ করা / শেষ হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v122",
    "kana": "おんがく",
    "kanji": "音楽",
    "romaji": "ongaku",
    "en": "music",
    "bn": "সঙ্গীত / গান / সঙ্গীত",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v123",
    "kana": "おんな",
    "kanji": "女",
    "romaji": "onna",
    "en": "woman / female / woman",
    "bn": "নারী / নারী / মহিলা",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v124",
    "kana": "おんなのこ",
    "kanji": "女の子",
    "romaji": "onnanoko",
    "en": "girl",
    "bn": "মেয়ে / মেয়ে",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v125",
    "kana": "〜かい",
    "kanji": "〜階",
    "romaji": "-kai",
    "en": "floor (counter) / counter for floors",
    "bn": "তলা (গণক)",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v126",
    "kana": "がいこく",
    "kanji": "外国",
    "romaji": "gaikoku",
    "en": "foreign country",
    "bn": "বিদেশ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v127",
    "kana": "がいこくじん",
    "kanji": "外国人",
    "romaji": "gaikokujin",
    "en": "foreigner",
    "bn": "বিদেশী / বিদেশী মানুষ / বিদেশী লোক",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v128",
    "kana": "かいしゃ",
    "kanji": "会社",
    "romaji": "kaisha",
    "en": "company / company / corporation / company / office",
    "bn": "কোম্পানি / অফিস",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v129",
    "kana": "かいだん",
    "kanji": "階段",
    "romaji": "kaidan",
    "en": "stairs / stairs / stairway",
    "bn": "সিঁড়ি / সিঁড়ি",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v130",
    "kana": "かいもの",
    "kanji": "買い物",
    "romaji": "kaimono",
    "en": "shopping",
    "bn": "কেনাকাটা",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v131",
    "kana": "かう",
    "kanji": "買う",
    "romaji": "kau",
    "en": "to buy",
    "bn": "কেনা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v132",
    "kana": "かえす",
    "kanji": "返す",
    "romaji": "kaesu",
    "en": "to return (something)",
    "bn": "ফেরত দেওয়া / ফেরত দেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v133",
    "kana": "かえる",
    "kanji": "帰る",
    "romaji": "kaeru",
    "en": "to return (home) / to go home / return",
    "bn": "ফিরে আসা / বাড়ি ফেরা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v134",
    "kana": "かかる",
    "kanji": null,
    "romaji": "kakaru",
    "en": "to take (time/money)",
    "bn": "সময়/টাকা লাগা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v135",
    "kana": "かぎ",
    "kanji": null,
    "romaji": "kagi",
    "en": "key",
    "bn": "চাবি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v136",
    "kana": "かく",
    "kanji": "書く",
    "romaji": "kaku",
    "en": "to write",
    "bn": "লেখা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v137",
    "kana": "がくせい",
    "kanji": "学生",
    "romaji": "gakusei",
    "en": "student",
    "bn": "ছাত্র / ছাত্র / ছাত্রী",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v138",
    "kana": "かける",
    "kanji": "掛ける",
    "romaji": "kakeru",
    "en": "to hang / to make a call / to hang / put on (glasses, etc) / to hang/call / to hang / call / wear",
    "bn": "ঝুলানো / ফোন করা / ঝোলানো / পরা (চশমা) / ঝুলানো/কল করা / ঝোলানো / ফোন করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v139",
    "kana": "かさ",
    "kanji": "傘",
    "romaji": "kasa",
    "en": "umbrella",
    "bn": "ছাতা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v140",
    "kana": "かす",
    "kanji": "貸す",
    "romaji": "kasu",
    "en": "to lend",
    "bn": "ধার দেওয়া / ধার দেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v141",
    "kana": "かぜ",
    "kanji": "風",
    "romaji": "kaze",
    "en": "wind / wind / breeze",
    "bn": "বাতাস",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v142",
    "kana": "かぜ",
    "kanji": "風邪",
    "romaji": "kaze",
    "en": "cold (illness) / colds / flu / cold / flu",
    "bn": "ঠান্ডা (রোগ) / সর্দি / জ্বর",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v143",
    "kana": "かぞく",
    "kanji": "家族",
    "romaji": "kazoku",
    "en": "family",
    "bn": "পরিবার",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v144",
    "kana": "かた",
    "kanji": "方",
    "romaji": "kata",
    "en": "person (polite) / person / way of (polite) / way of / person (polite)",
    "bn": "ব্যক্তি (বিনয়ী) / ব্যক্তি / উপায় / উপায় / ব্যক্তি",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v145",
    "kana": "〜がつ",
    "kanji": "〜月",
    "romaji": "-gatsu",
    "en": "month of the year",
    "bn": "মাসের নাম",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v146",
    "kana": "がっこう",
    "kanji": "学校",
    "romaji": "gakkou",
    "en": "school",
    "bn": "স্কুল / স্কুল / বিদ্যালয়",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v147",
    "kana": "カップ",
    "kanji": null,
    "romaji": "kappu",
    "en": "cup",
    "bn": "কাপ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v148",
    "kana": "かど",
    "kanji": "角",
    "romaji": "kado",
    "en": "corner",
    "bn": "কোণ / কোণ / মোড়",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v149",
    "kana": "かばん",
    "kanji": null,
    "romaji": "kaban",
    "en": "bag / bag / briefcase",
    "bn": "ব্যাগ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v150",
    "kana": "かびん",
    "kanji": "花瓶",
    "romaji": "kabin",
    "en": "flower vase",
    "bn": "ফুলের ফুলদানি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v151",
    "kana": "かみ",
    "kanji": "紙",
    "romaji": "kami",
    "en": "paper",
    "bn": "কাগজ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v152",
    "kana": "カメラ",
    "kanji": null,
    "romaji": "kamera",
    "en": "camera",
    "bn": "ক্যামেরা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v153",
    "kana": "かようび",
    "kanji": "火曜日",
    "romaji": "kayoubi",
    "en": "Tuesday",
    "bn": "মঙ্গলবার",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v154",
    "kana": "からい",
    "kanji": "辛い",
    "romaji": "karai",
    "en": "spicy / spicy / hot",
    "bn": "ঝাল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v155",
    "kana": "かりる",
    "kanji": "借りる",
    "romaji": "kariru",
    "en": "to borrow",
    "bn": "ধার করা / ধার নেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v156",
    "kana": "かるい",
    "kanji": "軽い",
    "romaji": "karui",
    "en": "light (weight)",
    "bn": "হালকা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v157",
    "kana": "カレンダー",
    "kanji": null,
    "romaji": "karendaa",
    "en": "calendar",
    "bn": "ক্যালেন্ডার",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v158",
    "kana": "かわ",
    "kanji": "川",
    "romaji": "kawa",
    "en": "river",
    "bn": "নদী",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v159",
    "kana": "かわいい",
    "kanji": null,
    "romaji": "kawaii",
    "en": "cute / cute / sweet",
    "bn": "প্রিয়দর্শন / কিউট / সুন্দর",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v160",
    "kana": "かんじ",
    "kanji": "漢字",
    "romaji": "kanji",
    "en": "kanji / kanji characters",
    "bn": "কাঞ্জি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v161",
    "kana": "き",
    "kanji": "木",
    "romaji": "ki",
    "en": "tree / tree / wood",
    "bn": "গাছ / গাছ / কাঠ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v162",
    "kana": "きいろい",
    "kanji": "黄色い",
    "romaji": "kiiroi",
    "en": "yellow",
    "bn": "হলুদ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v163",
    "kana": "きえる",
    "kanji": "消える",
    "romaji": "kieru",
    "en": "to disappear / to go out / vanish / to go out/vanish / to vanish / go out",
    "bn": "অদৃশ্য হওয়া / অদৃশ্য হওয়া / নিভে যাওয়া / নিভে যাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v164",
    "kana": "きく",
    "kanji": "聞く",
    "romaji": "kiku",
    "en": "to listen/ask / to hear / listen / ask",
    "bn": "শোনা/জিজ্ঞাসা করা / শোনা / জিজ্ঞাসা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v165",
    "kana": "きた",
    "kanji": "北",
    "romaji": "kita",
    "en": "north",
    "bn": "উত্তর",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v166",
    "kana": "ギター",
    "kanji": null,
    "romaji": "gitaa",
    "en": "guitar",
    "bn": "গিটার",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v167",
    "kana": "きたない",
    "kanji": "汚い",
    "romaji": "kitanai",
    "en": "dirty / dirty / messy",
    "bn": "নোংরা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v168",
    "kana": "きっさてん",
    "kanji": "喫茶店",
    "romaji": "kissaten",
    "en": "coffee shop / coffee shop / cafe",
    "bn": "কফি শপ / কফিশপ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v169",
    "kana": "きって",
    "kanji": "切手",
    "romaji": "kitte",
    "en": "postage stamp",
    "bn": "ডাকটিকিট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v170",
    "kana": "きっぷ",
    "kanji": "切符",
    "romaji": "kippu",
    "en": "ticket",
    "bn": "টিকিট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v171",
    "kana": "きのう",
    "kanji": "昨日",
    "romaji": "kinou",
    "en": "yesterday",
    "bn": "গতকাল",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v172",
    "kana": "ぎゅうにゅう",
    "kanji": "牛乳",
    "romaji": "gyuunyuu",
    "en": "milk / cow milk",
    "bn": "দুধ / গরুর দুধ",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v173",
    "kana": "きょう",
    "kanji": "今日",
    "romaji": "kyou",
    "en": "today",
    "bn": "আজ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v174",
    "kana": "きょうしつ",
    "kanji": "教室",
    "romaji": "kyoushitsu",
    "en": "classroom",
    "bn": "শ্রেণীকক্ষ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v175",
    "kana": "きょうだい",
    "kanji": "兄弟",
    "romaji": "kyoudai",
    "en": "siblings",
    "bn": "ভাইবোন",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v176",
    "kana": "きょねん",
    "kanji": "去年",
    "romaji": "kyonen",
    "en": "last year",
    "bn": "গত বছর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v177",
    "kana": "きらい",
    "kanji": "嫌い",
    "romaji": "kirai",
    "en": "dislike / dislike / hate",
    "bn": "অপছন্দ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v178",
    "kana": "きる",
    "kanji": "切る",
    "romaji": "kiru",
    "en": "to cut",
    "bn": "কাটা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v179",
    "kana": "きる",
    "kanji": "着る",
    "romaji": "kiru",
    "en": "to wear / to wear (upper body)",
    "bn": "পরা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v180",
    "kana": "きれい",
    "kanji": null,
    "romaji": "kirei",
    "en": "beautiful/clean / beautiful / clean",
    "bn": "সুন্দর/পরিষ্কার / সুন্দর / পরিষ্কার",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v181",
    "kana": "ぎんこう",
    "kanji": "銀行",
    "romaji": "ginkou",
    "en": "bank",
    "bn": "ব্যাংক",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v182",
    "kana": "きんようび",
    "kanji": "金曜日",
    "romaji": "kinyoubi",
    "en": "Friday",
    "bn": "শুক্রবার",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v183",
    "kana": "くず",
    "kanji": "薬",
    "romaji": "kusuri",
    "en": "medicine",
    "bn": "ওষুধ",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v184",
    "kana": "ください",
    "kanji": null,
    "romaji": "kudasai",
    "en": "please give me",
    "bn": "অনুগ্রহ করে দিন / দয়া করে দিন",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v185",
    "kana": "くだもの",
    "kanji": "果物",
    "romaji": "kudamono",
    "en": "fruit",
    "bn": "ফল",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v186",
    "kana": "くち",
    "kanji": "口",
    "romaji": "kuchi",
    "en": "mouth",
    "bn": "মুখ / মুখ / প্রবেশপথ",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v187",
    "kana": "くつ",
    "kanji": "靴",
    "romaji": "kutsu",
    "en": "shoes",
    "bn": "জুতা / জুতো",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v188",
    "kana": "くつした",
    "kanji": "靴下",
    "romaji": "kutsushita",
    "en": "socks",
    "bn": "মজা / মোজা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v189",
    "kana": "くに",
    "kanji": "国",
    "romaji": "kuni",
    "en": "country",
    "bn": "দেশ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v190",
    "kana": "くもり",
    "kanji": "曇り",
    "romaji": "kumori",
    "en": "cloudy / cloudy weather",
    "bn": "মেঘলা",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v191",
    "kana": "くらい",
    "kanji": "暗い",
    "romaji": "kurai",
    "en": "dark",
    "bn": "অন্ধকার",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v192",
    "kana": "〜くらい/ぐらい",
    "kanji": null,
    "romaji": "-kurai",
    "en": "about/approximately",
    "bn": "প্রায়",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v193",
    "kana": "クラス",
    "kanji": null,
    "romaji": "kurasu",
    "en": "class",
    "bn": "ক্লাস",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v194",
    "kana": "グラム",
    "kanji": null,
    "romaji": "guramu",
    "en": "gram",
    "bn": "গ্রাম",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v195",
    "kana": "くる",
    "kanji": "来る",
    "romaji": "kuru",
    "en": "to come",
    "bn": "আসা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v196",
    "kana": "くるま",
    "kanji": "車",
    "romaji": "kuruma",
    "en": "car / car / vehicle",
    "bn": "গাড়ি / গাড়ি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v197",
    "kana": "くろい",
    "kanji": "黒い",
    "romaji": "kuroi",
    "en": "black",
    "bn": "কালো",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v198",
    "kana": "けいかん",
    "kanji": "警官",
    "romaji": "keikan",
    "en": "policeman / police officer",
    "bn": "পুলিশ",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v199",
    "kana": "けさ",
    "kanji": "今朝",
    "romaji": "kesa",
    "en": "this morning",
    "bn": "আজ সকালে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v200",
    "kana": "けす",
    "kanji": "消す",
    "romaji": "kesu",
    "en": "to turn off/erase / to erase / turn off",
    "bn": "বন্ধ করা/মুছে ফেলা / নেভানো / মোছা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v201",
    "kana": "けっこう",
    "kanji": "結構",
    "romaji": "kekkou",
    "en": "splendid/enough / fine / nice / sufficient / splendid / enough",
    "bn": "চমৎকার/যথেষ্ট / বেশ / ঠিক আছে",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v202",
    "kana": "けっこん",
    "kanji": "結婚",
    "romaji": "kekkon",
    "en": "marriage",
    "bn": "বিবাহ / বিয়ে",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v203",
    "kana": "げつようび",
    "kanji": "月曜日",
    "romaji": "getsuyoubi",
    "en": "Monday",
    "bn": "সোমবার",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v204",
    "kana": "げんかん",
    "kanji": "玄関",
    "romaji": "genkan",
    "en": "entrance",
    "bn": "প্রবেশপথ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v205",
    "kana": "げんき",
    "kanji": "元気",
    "romaji": "genki",
    "en": "healthy/energetic / health / vitality",
    "bn": "সুস্থ/উদ্যমী / সুস্থতা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v206",
    "kana": "～こ",
    "kanji": "～個",
    "romaji": "-ko",
    "en": "counter for small objects",
    "bn": "ছোট জিনিসের গণক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v207",
    "kana": "ご",
    "kanji": "五",
    "romaji": "go",
    "en": "five",
    "bn": "পাঁচ",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v208",
    "kana": "～ご",
    "kanji": "～語",
    "romaji": "-go",
    "en": "language",
    "bn": "ভাষা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v209",
    "kana": "こうえん",
    "kanji": "公園",
    "romaji": "kouen",
    "en": "park",
    "bn": "পার্ক / পার্ক / বাগান",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v210",
    "kana": "こうさてん",
    "kanji": "交差点",
    "romaji": "kousaten",
    "en": "intersection",
    "bn": "মোড়",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v211",
    "kana": "こうちゃ",
    "kanji": "紅茶",
    "romaji": "koucha",
    "en": "black tea",
    "bn": "লাল চা",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v212",
    "kana": "こうばん",
    "kanji": "交番",
    "romaji": "kouban",
    "en": "police box",
    "bn": "পুলিশ বক্স",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v213",
    "kana": "こえ",
    "kanji": "声",
    "romaji": "koe",
    "en": "voice",
    "bn": "কণ্ঠস্বর",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v214",
    "kana": "ここ",
    "kanji": null,
    "romaji": "koko",
    "en": "here",
    "bn": "এখানে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v215",
    "kana": "ごご",
    "kanji": "午後",
    "romaji": "gogo",
    "en": "afternoon/P.M. / afternoon / P.M. / PM",
    "bn": "বিকাল/পি.এম.",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v216",
    "kana": "ここのか",
    "kanji": "九日",
    "romaji": "kokonoka",
    "en": "9th day / ninth day of the month",
    "bn": "৯ম দিন / নয় তারিখ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v217",
    "kana": "ここのつ",
    "kanji": "九つ",
    "romaji": "kokonotsu",
    "en": "nine things / nine (things)",
    "bn": "নয়টি জিনিস / নয়টি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v218",
    "kana": "ごぜん",
    "kanji": "午前",
    "romaji": "gozen",
    "en": "morning/A.M. / morning / A.M.",
    "bn": "সকাল/এ.এম.",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v219",
    "kana": "こたえる",
    "kanji": "答える",
    "romaji": "kotaeru",
    "en": "to answer",
    "bn": "উত্তর দেওয়া / উত্তর দেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v220",
    "kana": "こちら",
    "kanji": null,
    "romaji": "kochira",
    "en": "this way (polite) / this way / this person (polite)",
    "bn": "এই দিকে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v221",
    "kana": "こっち",
    "kanji": null,
    "romaji": "kotchi",
    "en": "this way / this way (casual)",
    "bn": "এই দিকে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v222",
    "kana": "コップ",
    "kanji": null,
    "romaji": "koppu",
    "en": "glass/cup / cup / glass",
    "bn": "গ্লাস/কাপ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v223",
    "kana": "ことし",
    "kanji": "今年",
    "romaji": "kotoshi",
    "en": "this year",
    "bn": "এই বছর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v224",
    "kana": "ことば",
    "kanji": "言葉",
    "romaji": "kotoba",
    "en": "word/language / word / language",
    "bn": "শব্দ/ভাষা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v225",
    "kana": "こども",
    "kanji": "子供",
    "romaji": "kodomo",
    "en": "child",
    "bn": "শিশু / শিশু/সন্তান",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v226",
    "kana": "この",
    "kanji": null,
    "romaji": "kono",
    "en": "this / this (followed by noun)",
    "bn": "এই",
    "category": "pronouns",
    "level": "N5"
  },
  {
    "id": "n5v227",
    "kana": "ごはん",
    "kanji": "ご飯",
    "romaji": "gohan",
    "en": "meal/rice / cooked rice / meal",
    "bn": "খাবার/ভাত / ভাত / খাবার",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v228",
    "kana": "コピー",
    "kanji": null,
    "romaji": "kopii",
    "en": "copy",
    "bn": "কপি",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v229",
    "kana": "こまる",
    "kanji": "困る",
    "romaji": "komaru",
    "en": "to be in trouble",
    "bn": "অসুবিধায় পড়া / অসুবিধায় পড়া / বিপদে পড়া/অসুবিধায় পড়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v230",
    "kana": "これ",
    "kanji": null,
    "romaji": "kore",
    "en": "this / this one",
    "bn": "এটি",
    "category": "pronouns",
    "level": "N5"
  },
  {
    "id": "n5v231",
    "kana": "～ころ／～ごろ",
    "kanji": null,
    "romaji": "-koro",
    "en": "around/about",
    "bn": "সময়/প্রায়",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v232",
    "kana": "こんげつ",
    "kanji": "今月",
    "romaji": "kongetsu",
    "en": "this month",
    "bn": "এই মাস",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v233",
    "kana": "こんしゅう",
    "kanji": "今週",
    "romaji": "konshuu",
    "en": "this week",
    "bn": "এই সপ্তাহ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v234",
    "kana": "こんな",
    "kanji": null,
    "romaji": "konna",
    "en": "this kind of / such / like this / this sort of",
    "bn": "এই ধরনের / এই ধরণের",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v235",
    "kana": "こんばん",
    "kanji": "今晩",
    "romaji": "konban",
    "en": "tonight / this evening",
    "bn": "আজ রাত",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v236",
    "kana": "さあ",
    "kanji": null,
    "romaji": "saa",
    "en": "well/now / well / now",
    "bn": "আচ্ছা/এখন / বেশ / আসা যাক",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v237",
    "kana": "～さい",
    "kanji": "～歳",
    "romaji": "-sai",
    "en": "counter for age",
    "bn": "বয়সের গণক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v238",
    "kana": "さいふ",
    "kanji": "財布",
    "romaji": "saifu",
    "en": "wallet",
    "bn": "মানিব্যাগ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v239",
    "kana": "さかな",
    "kanji": "魚",
    "romaji": "sakana",
    "en": "fish",
    "bn": "মাছ",
    "category": "animals",
    "level": "N5"
  },
  {
    "id": "n5v240",
    "kana": "さき",
    "kanji": "先",
    "romaji": "saki",
    "en": "earlier/future / earlier / ahead",
    "bn": "আগে/ভবিষ্যৎ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v241",
    "kana": "さく",
    "kanji": "咲く",
    "romaji": "saku",
    "en": "to bloom",
    "bn": "ফোটা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v242",
    "kana": "さくぶん",
    "kanji": "作文",
    "romaji": "sakubun",
    "en": "composition / composition / essay",
    "bn": "রচনা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v243",
    "kana": "さす",
    "kanji": "差す",
    "romaji": "sasu",
    "en": "to open (umbrella) / to hold (an umbrella)",
    "bn": "খোলা (ছাতা) / ছাতা ধরা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v244",
    "kana": "～さつ",
    "kanji": "～冊",
    "romaji": "-satsu",
    "en": "counter for books",
    "bn": "বইয়ের গণক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v245",
    "kana": "ざっし",
    "kanji": "雑誌",
    "romaji": "zasshi",
    "en": "magazine",
    "bn": "ম্যাগাজিন / সাময়িকী",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v246",
    "kana": "さとう",
    "kanji": "砂糖",
    "romaji": "satou",
    "en": "sugar",
    "bn": "চিনি",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v247",
    "kana": "さむい",
    "kanji": "寒い",
    "romaji": "samui",
    "en": "cold (weather)",
    "bn": "শীতল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v290",
    "kana": "～すぎ",
    "kanji": null,
    "romaji": "-sugi",
    "en": "past/over",
    "bn": "অতীত",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v291",
    "kana": "すくない",
    "kanji": "少ない",
    "romaji": "sukunai",
    "en": "few/little / a few/little",
    "bn": "অল্প",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v292",
    "kana": "すぐ",
    "kanji": null,
    "romaji": "sugu",
    "en": "immediately",
    "bn": "অবিলম্বে",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v293",
    "kana": "すこし",
    "kanji": "少し",
    "romaji": "sukoshi",
    "en": "a little",
    "bn": "সামান্য / একটু",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v294",
    "kana": "すずしい",
    "kanji": "涼しい",
    "romaji": "suzushii",
    "en": "cool (weather)",
    "bn": "শীতল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v295",
    "kana": "～ずつ",
    "kanji": null,
    "romaji": "-zutsu",
    "en": "each",
    "bn": "প্রতিটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v296",
    "kana": "ストーブ",
    "kanji": null,
    "romaji": "sutoobu",
    "en": "stove/heater",
    "bn": "চুলা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v297",
    "kana": "スプーン",
    "kanji": null,
    "romaji": "supuun",
    "en": "spoon",
    "bn": "চামচ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v298",
    "kana": "スポーツ",
    "kanji": null,
    "romaji": "supootsu",
    "en": "sport",
    "bn": "খেলাধুলা",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v299",
    "kana": "ズボン",
    "kanji": null,
    "romaji": "zubon",
    "en": "trousers",
    "bn": "প্যান্ট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v300",
    "kana": "すむ",
    "kanji": "住む",
    "romaji": "sumu",
    "en": "to live",
    "bn": "বাস করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v301",
    "kana": "すわる",
    "kanji": "座る",
    "romaji": "suwaru",
    "en": "to sit",
    "bn": "বসা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v302",
    "kana": "せい",
    "kanji": "背",
    "romaji": "sei",
    "en": "height/stature",
    "bn": "উচ্চতা",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v303",
    "kana": "せいと",
    "kanji": "生徒",
    "romaji": "seito",
    "en": "student",
    "bn": "ছাত্র",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v304",
    "kana": "セーター",
    "kanji": null,
    "romaji": "seetaa",
    "en": "sweater",
    "bn": "সোয়েটার",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v305",
    "kana": "せっけん",
    "kanji": "石鹸",
    "romaji": "sekken",
    "en": "soap",
    "bn": "সাবান",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v306",
    "kana": "せびろ",
    "kanji": "背広",
    "romaji": "sebiro",
    "en": "business suit",
    "bn": "ব্যবসায়িক স্যুট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v307",
    "kana": "せまい",
    "kanji": "狭い",
    "romaji": "semai",
    "en": "narrow",
    "bn": "সংকীর্ণ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v308",
    "kana": "ぜんぶ",
    "kanji": "全部",
    "romaji": "zenbu",
    "en": "all",
    "bn": "সব",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v309",
    "kana": "せいかつ",
    "kanji": "生活",
    "romaji": "seikatsu",
    "en": "life/living",
    "bn": "জীবনযাপন",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v310",
    "kana": "せいじ",
    "kanji": "政治",
    "romaji": "seiji",
    "en": "politics",
    "bn": "রাজনীতি",
    "category": "education",
    "level": "N5"
  },
  {
    "id": "n5v311",
    "kana": "せいよう",
    "kanji": "西洋",
    "romaji": "seiyou",
    "en": "the West / Western countries",
    "bn": "পাশ্চাত্য",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v312",
    "kana": "せかい",
    "kanji": "世界",
    "romaji": "sekai",
    "en": "world",
    "bn": "পৃথিবী",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v313",
    "kana": "ぜんぜん",
    "kanji": "全然",
    "romaji": "zenzen",
    "en": "not at all",
    "bn": "একেবারেই না",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v314",
    "kana": "せんそう",
    "kanji": "戦争",
    "romaji": "sensou",
    "en": "war",
    "bn": "যুদ্ধ",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v315",
    "kana": "せんぱい",
    "kanji": "先輩",
    "romaji": "senpai",
    "en": "senior",
    "bn": "সিনিয়র / বড়/সিনিয়র",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v316",
    "kana": "せん",
    "kanji": "千",
    "romaji": "sen",
    "en": "thousand",
    "bn": "হাজার",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v317",
    "kana": "せんげつ",
    "kanji": "先月",
    "romaji": "sengetsu",
    "en": "last month",
    "bn": "গত মাস",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v318",
    "kana": "せんしゅう",
    "kanji": "先週",
    "romaji": "senshuu",
    "en": "last week",
    "bn": "গত সপ্তাহ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v319",
    "kana": "せんせい",
    "kanji": "先生",
    "romaji": "sensei",
    "en": "teacher",
    "bn": "শিক্ষক",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v320",
    "kana": "せんたく",
    "kanji": "洗濯",
    "romaji": "sentaku",
    "en": "washing/laundry",
    "bn": "ধোয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v322",
    "kana": "そうじ",
    "kanji": "掃除",
    "romaji": "souji",
    "en": "cleaning",
    "bn": "পরিষ্কার করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v323",
    "kana": "そうして",
    "kanji": null,
    "romaji": "soushite",
    "en": "and then",
    "bn": "এবং তারপর",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v324",
    "kana": "そこ",
    "kanji": null,
    "romaji": "soko",
    "en": "there",
    "bn": "সেখানে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v325",
    "kana": "そちら",
    "kanji": null,
    "romaji": "sochira",
    "en": "that way/there",
    "bn": "ওদিকে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v326",
    "kana": "そっち",
    "kanji": null,
    "romaji": "socchi",
    "en": "that way",
    "bn": "ওদিকে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v327",
    "kana": "そと",
    "kanji": "外",
    "romaji": "soto",
    "en": "outside",
    "bn": "বাইরে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v328",
    "kana": "そば",
    "kanji": null,
    "romaji": "soba",
    "en": "near/beside",
    "bn": "পাশে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v329",
    "kana": "そら",
    "kanji": "空",
    "romaji": "sora",
    "en": "sky",
    "bn": "আকাশ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v330",
    "kana": "それ",
    "kanji": null,
    "romaji": "sore",
    "en": "that",
    "bn": "সেটি",
    "category": "pronouns",
    "level": "N5"
  },
  {
    "id": "n5v331",
    "kana": "それから",
    "kanji": null,
    "romaji": "sorekara",
    "en": "after that",
    "bn": "তারপরে",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v332",
    "kana": "それでは",
    "kanji": null,
    "romaji": "soredewa",
    "en": "well then",
    "bn": "তাহলে",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v333",
    "kana": "だいいち",
    "kanji": "第一",
    "romaji": "daiichi",
    "en": "first",
    "bn": "প্রথম",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v334",
    "kana": "だいがく",
    "kanji": "大学",
    "romaji": "daigaku",
    "en": "university",
    "bn": "বিশ্ববিদ্যালয়",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v335",
    "kana": "たいし",
    "kanji": "大使",
    "romaji": "taishi",
    "en": "ambassador",
    "bn": "রাষ্ট্রদূত",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v336",
    "kana": "たいしかん",
    "kanji": "大使館",
    "romaji": "taishikan",
    "en": "embassy",
    "bn": "দূতাবাস",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v337",
    "kana": "だいじ",
    "kanji": "大事",
    "romaji": "daiji",
    "en": "important / important/valuable",
    "bn": "গুরুত্বপূর্ণ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v338",
    "kana": "だいじょうぶ",
    "kanji": "大丈夫",
    "romaji": "daijoubu",
    "en": "all right",
    "bn": "ঠিক আছে",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v339",
    "kana": "だいすき",
    "kanji": "大好き",
    "romaji": "daisuki",
    "en": "love",
    "bn": "খুব পছন্দ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v340",
    "kana": "たいせつ",
    "kanji": "大切",
    "romaji": "taisetsu",
    "en": "important/precious",
    "bn": "মূল্যবান",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v418",
    "kana": "どっち",
    "kanji": null,
    "romaji": "dotchi",
    "en": "which (casual)",
    "bn": "কোনটি",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v419",
    "kana": "とても",
    "kanji": null,
    "romaji": "totemo",
    "en": "very",
    "bn": "খুব",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v420",
    "kana": "どなた",
    "kanji": null,
    "romaji": "donata",
    "en": "who (polite)",
    "bn": "কে",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v421",
    "kana": "となり",
    "kanji": "隣",
    "romaji": "tonari",
    "en": "next to",
    "bn": "পাশে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v422",
    "kana": "どの",
    "kanji": null,
    "romaji": "dono",
    "en": "which",
    "bn": "কোন",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v423",
    "kana": "とぶ",
    "kanji": "飛ぶ",
    "romaji": "tobu",
    "en": "to fly/jump",
    "bn": "ওড়া/লাফানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v424",
    "kana": "とまる",
    "kanji": "止まる",
    "romaji": "tomaru",
    "en": "to stop",
    "bn": "থামা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v425",
    "kana": "ともだち",
    "kanji": "友達",
    "romaji": "tomodachi",
    "en": "friend",
    "bn": "বন্ধু",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v426",
    "kana": "どようび",
    "kanji": "土曜日",
    "romaji": "doyoubi",
    "en": "Saturday",
    "bn": "শনিবার",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v427",
    "kana": "とり",
    "kanji": "鳥",
    "romaji": "tori",
    "en": "bird",
    "bn": "পাখি",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v428",
    "kana": "とりにく",
    "kanji": "鶏肉",
    "romaji": "toriniku",
    "en": "chicken meat",
    "bn": "মুরগির মাংস",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v429",
    "kana": "とる",
    "kanji": "撮る",
    "romaji": "toru",
    "en": "to take (photo)",
    "bn": "ছবি তোলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v430",
    "kana": "とる",
    "kanji": "取る",
    "romaji": "toru",
    "en": "to take/pick up",
    "bn": "নেওয়া/তোলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v431",
    "kana": "どれ",
    "kanji": null,
    "romaji": "dore",
    "en": "which one",
    "bn": "কোনটি",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v432",
    "kana": "どのくらい",
    "kanji": null,
    "romaji": "dono kurai",
    "en": "how long/how much",
    "bn": "কতক্ষণ/কতটা",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v433",
    "kana": "どんな",
    "kanji": null,
    "romaji": "donna",
    "en": "what kind of",
    "bn": "কি ধরণের",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v434",
    "kana": "ない",
    "kanji": null,
    "romaji": "nai",
    "en": "none/doesn't exist / none/non-existent",
    "bn": "নেই",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v435",
    "kana": "なか",
    "kanji": "中",
    "romaji": "naka",
    "en": "inside/middle",
    "bn": "ভিতরে/মধ্যে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v436",
    "kana": "ながい",
    "kanji": "長い",
    "romaji": "nagai",
    "en": "long",
    "bn": "লম্বা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v437",
    "kana": "なく",
    "kanji": "鳴く",
    "romaji": "naku",
    "en": "to chirp/bark",
    "bn": "ডাকা (পাখি/প্রাণী)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v438",
    "kana": "なくす",
    "kanji": "無くす",
    "romaji": "nakusu",
    "en": "to lose something",
    "bn": "হারানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v439",
    "kana": "なぜ",
    "kanji": null,
    "romaji": "naze",
    "en": "why",
    "bn": "কেন",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v440",
    "kana": "なつ",
    "kanji": "夏",
    "romaji": "natsu",
    "en": "summer",
    "bn": "গ্রীষ্ম / গ্রীষ্মকাল",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v441",
    "kana": "なつやすみ",
    "kanji": "夏休み",
    "romaji": "natsuyasumi",
    "en": "summer vacation",
    "bn": "গ্রীষ্মকালীন ছুটি / গ্রীষ্মের ছুটি",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v442",
    "kana": "など",
    "kanji": null,
    "romaji": "nado",
    "en": "and so on",
    "bn": "ইত্যাদি",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v443",
    "kana": "ななつ",
    "kanji": "七つ",
    "romaji": "nanatsu",
    "en": "seven items / seven (things)",
    "bn": "সাতটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v444",
    "kana": "なな",
    "kanji": "七",
    "romaji": "nana",
    "en": "seven",
    "bn": "সাত",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v445",
    "kana": "なに/なん",
    "kanji": "何",
    "romaji": "nani/nan",
    "en": "what",
    "bn": "কি",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v446",
    "kana": "なのか",
    "kanji": "七日",
    "romaji": "nanoka",
    "en": "seventh day of month / seven days/7th day",
    "bn": "মাসের সপ্তম দিন / সাত দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v447",
    "kana": "なまえ",
    "kanji": "名前",
    "romaji": "namae",
    "en": "name",
    "bn": "নাম",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v448",
    "kana": "ならう",
    "kanji": "習う",
    "romaji": "narau",
    "en": "to learn",
    "bn": "শেখা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v449",
    "kana": "ならぶ",
    "kanji": "並ぶ",
    "romaji": "narabu",
    "en": "to line up",
    "bn": "লাইনে দাঁড়ানো / সারিবদ্ধ হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v450",
    "kana": "ならべる",
    "kanji": "並べる",
    "romaji": "naraberu",
    "en": "to set up/arrange / to set up/line up",
    "bn": "সাজানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v451",
    "kana": "なる",
    "kanji": null,
    "romaji": "naru",
    "en": "to become",
    "bn": "হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v452",
    "kana": "なん～",
    "kanji": "何〜",
    "romaji": "nan-",
    "en": "what-",
    "bn": "কি-",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v453",
    "kana": "に",
    "kanji": "二",
    "romaji": "ni",
    "en": "two",
    "bn": "দুই",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v454",
    "kana": "にぎやか",
    "kanji": "賑やか",
    "romaji": "nigiyaka",
    "en": "lively/busy / bustling/lively",
    "bn": "কোলাহলপূর্ণ / মুখরিত",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v455",
    "kana": "にくい",
    "kanji": null,
    "romaji": "nikui",
    "en": "difficult to...",
    "bn": "কঠিন...",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v456",
    "kana": "にく",
    "kanji": "肉",
    "romaji": "niku",
    "en": "meat",
    "bn": "মাংস",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v457",
    "kana": "にし",
    "kanji": "西",
    "romaji": "nishi",
    "en": "west",
    "bn": "পশ্চিম",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v458",
    "kana": "〜にち",
    "kanji": "〜日",
    "romaji": "-nichi",
    "en": "day of the month",
    "bn": "তারিখ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v459",
    "kana": "にちようび",
    "kanji": "日曜日",
    "romaji": "nichiyoubi",
    "en": "Sunday",
    "bn": "রবিবার",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v460",
    "kana": "にじ",
    "kanji": "二次",
    "romaji": "niji",
    "en": "secondary",
    "bn": "মাধ্যমিক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v461",
    "kana": "にづくり",
    "kanji": "荷造り",
    "romaji": "nizukuri",
    "en": "packing",
    "bn": "প্যাকিং",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v462",
    "kana": "にちじょう",
    "kanji": "日常",
    "romaji": "nichijou",
    "en": "daily",
    "bn": "দৈনন্দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v463",
    "kana": "にっき",
    "kanji": "日記",
    "romaji": "nikki",
    "en": "diary",
    "bn": "ডায়েরি / দিনলিপি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v464",
    "kana": "にわ",
    "kanji": "庭",
    "romaji": "niwa",
    "en": "garden",
    "bn": "বাগান",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v465",
    "kana": "〜にん",
    "kanji": "〜人",
    "romaji": "-nin",
    "en": "people (counter)",
    "bn": "জন (গণক)",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v466",
    "kana": "ぬぐ",
    "kanji": "脱ぐ",
    "romaji": "nugu",
    "en": "to take off (clothes)",
    "bn": "খোলা (কাপড়) / খোলা (পোশাক) / পোশাক খোলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v467",
    "kana": "ぬるい",
    "kanji": "温い",
    "romaji": "nurui",
    "en": "lukewarm",
    "bn": "কুসুম গরম / ঈষদুষ্ণ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v468",
    "kana": "ねこ",
    "kanji": "猫",
    "romaji": "neko",
    "en": "cat",
    "bn": "বিড়াল",
    "category": "animals",
    "level": "N5"
  },
  {
    "id": "n5v469",
    "kana": "ねる",
    "kanji": "寝る",
    "romaji": "neru",
    "en": "to sleep / to sleep/lie down",
    "bn": "ঘুমানো / ঘুমানো/শুয়ে পড়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v470",
    "kana": "～ねん",
    "kanji": "～年",
    "romaji": "-nen",
    "en": "year (counter)",
    "bn": "বছর (গণক)",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v471",
    "kana": "のぼる",
    "kanji": "登る",
    "romaji": "noboru",
    "en": "to climb",
    "bn": "আরোহণ করা / চড়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v472",
    "kana": "のみもの",
    "kanji": "飲み物",
    "romaji": "nomimono",
    "en": "drink/beverage / beverage / drink",
    "bn": "পানীয় / পানীয়",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v473",
    "kana": "のむ",
    "kanji": "飲む",
    "romaji": "nomu",
    "en": "to drink",
    "bn": "পান করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v474",
    "kana": "のる",
    "kanji": "乗る",
    "romaji": "noru",
    "en": "to ride/board / to ride / board / to ride/get on",
    "bn": "চড়া / চড়া (যানবাহনে)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v475",
    "kana": "は",
    "kanji": "歯",
    "romaji": "ha",
    "en": "tooth",
    "bn": "দাঁত",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v476",
    "kana": "パーティー",
    "kanji": null,
    "romaji": "paatii",
    "en": "party",
    "bn": "পার্টি",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v477",
    "kana": "はい",
    "kanji": null,
    "romaji": "hai",
    "en": "yes",
    "bn": "হ্যাঁ",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v478",
    "kana": "～はい",
    "kanji": "～杯",
    "romaji": "-hai",
    "en": "counter for cups/glasses",
    "bn": "কাপের গণক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v479",
    "kana": "はいしゃ",
    "kanji": "歯医者",
    "romaji": "haisha",
    "en": "dentist",
    "bn": "দন্তচিকিৎসক",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v480",
    "kana": "はいる",
    "kanji": "入る",
    "romaji": "hairu",
    "en": "to enter / to enter / go in",
    "bn": "প্রবেশ করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v481",
    "kana": "はがき",
    "kanji": "葉書",
    "romaji": "hagaki",
    "en": "postcard",
    "bn": "পোস্টকার্ড",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v482",
    "kana": "はく",
    "kanji": "履く",
    "romaji": "haku",
    "en": "to wear (pants/shoes) / to wear (shoes/socks) / to wear (lower body)",
    "bn": "পরা (নিচের অংশ) / পরা (জুতো/মোজা)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v483",
    "kana": "はこ",
    "kanji": "箱",
    "romaji": "hako",
    "en": "box",
    "bn": "বাক্স",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v484",
    "kana": "はし",
    "kanji": "橋",
    "romaji": "hashi",
    "en": "bridge",
    "bn": "সেতু",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v485",
    "kana": "はし",
    "kanji": "箸",
    "romaji": "hashi",
    "en": "chopsticks",
    "bn": "চপস্টিক",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v486",
    "kana": "はじまる",
    "kanji": "始まる",
    "romaji": "hajimaru",
    "en": "to begin",
    "bn": "শুরু হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v487",
    "kana": "はじめ",
    "kanji": "初め",
    "romaji": "hajime",
    "en": "beginning",
    "bn": "শুরু",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v488",
    "kana": "はじめて",
    "kanji": "初めて",
    "romaji": "hajimete",
    "en": "for the first time",
    "bn": "প্রথমবারের মতো",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v489",
    "kana": "はしる",
    "kanji": "走る",
    "romaji": "hashiru",
    "en": "to run",
    "bn": "দৌড়ানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v490",
    "kana": "バス",
    "kanji": null,
    "romaji": "basu",
    "en": "bus",
    "bn": "বাস",
    "category": "transport",
    "level": "N5"
  },
  {
    "id": "n5v491",
    "kana": "バター",
    "kanji": null,
    "romaji": "bataa",
    "en": "butter",
    "bn": "মাখন",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v492",
    "kana": "はたち",
    "kanji": "二十歳",
    "romaji": "hatachi",
    "en": "20 years old",
    "bn": "২০ বছর বয়স",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v493",
    "kana": "はたらく",
    "kanji": "働く",
    "romaji": "hataraku",
    "en": "to work",
    "bn": "কাজ করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v494",
    "kana": "はち",
    "kanji": "八",
    "romaji": "hachi",
    "en": "eight",
    "bn": "আট",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v495",
    "kana": "はつか",
    "kanji": "二十日",
    "romaji": "hatsuka",
    "en": "20th day of the month",
    "bn": "২০ তারিখ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v496",
    "kana": "はな",
    "kanji": "花",
    "romaji": "hana",
    "en": "flower",
    "bn": "ফুল",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v497",
    "kana": "はな",
    "kanji": "鼻",
    "romaji": "hana",
    "en": "nose",
    "bn": "নাক",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v498",
    "kana": "はなし",
    "kanji": "話",
    "romaji": "hanashi",
    "en": "talk/story / talk / story",
    "bn": "কথা/গল্প / গল্প / কথা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v499",
    "kana": "はなす",
    "kanji": "話す",
    "romaji": "hanasu",
    "en": "to speak",
    "bn": "কথা বলা / বলি / কথা বলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v500",
    "kana": "はは",
    "kanji": "母",
    "romaji": "haha",
    "en": "mother (my own)",
    "bn": "মা",
    "category": "family",
    "level": "N5"
  },
  {
    "id": "n5v501",
    "kana": "はやい",
    "kanji": "早い",
    "romaji": "hayai",
    "en": "early",
    "bn": "তাড়াতাড়ি / আগে/তাড়াতাড়ি",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v502",
    "kana": "はやい",
    "kanji": "速い",
    "romaji": "hayai",
    "en": "fast / fast / quick",
    "bn": "দ্রুত",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v503",
    "kana": "はる",
    "kanji": "春",
    "romaji": "haru",
    "en": "spring",
    "bn": "বসন্ত",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v504",
    "kana": "はる",
    "kanji": "貼る",
    "romaji": "haru",
    "en": "to stick/paste / to stick / paste / to stick/put up",
    "bn": "আটকানো / আটকানো / লাগানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v505",
    "kana": "はれ",
    "kanji": "晴れ",
    "romaji": "hare",
    "en": "sunny weather",
    "bn": "রৌদ্রোজ্জ্বল আবহাওয়া / রোদ ঝলমলে আকাশ",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v506",
    "kana": "はれる",
    "kanji": "晴れる",
    "romaji": "hareru",
    "en": "to clear up",
    "bn": "পরিষ্কার হওয়া (আকাশ)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v507",
    "kana": "はん",
    "kanji": "半",
    "romaji": "han",
    "en": "half",
    "bn": "অর্ধেক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v508",
    "kana": "ばん",
    "kanji": "晩",
    "romaji": "ban",
    "en": "evening / evening / night",
    "bn": "সন্ধ্যা / সন্ধ্যা / রাত",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v509",
    "kana": "〜ばん",
    "kanji": "〜番",
    "romaji": "-ban",
    "en": "number... / number ...",
    "bn": "... নম্বর",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v510",
    "kana": "パン",
    "kanji": null,
    "romaji": "pan",
    "en": "bread",
    "bn": "রুটি",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v511",
    "kana": "ハンバーグ",
    "kanji": null,
    "romaji": "hanbaagu",
    "en": "hamburger steak",
    "bn": "হ্যামবার্গার স্টেক",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v512",
    "kana": "ばんごう",
    "kanji": "番号",
    "romaji": "bangou",
    "en": "number",
    "bn": "নম্বর",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v513",
    "kana": "ばんごはん",
    "kanji": "晩御飯",
    "romaji": "bangohan",
    "en": "dinner",
    "bn": "রাতের খাবার",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v514",
    "kana": "はんぶん",
    "kanji": "半分",
    "romaji": "hanbun",
    "en": "half minute/half amount",
    "bn": "অর্ধেক পরিমাণ",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v515",
    "kana": "ひがし",
    "kanji": "東",
    "romaji": "higashi",
    "en": "east",
    "bn": "পূর্ব",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v516",
    "kana": "〜ひき",
    "kanji": "〜匹",
    "romaji": "-hiki",
    "en": "counter for small animals",
    "bn": "ছোট প্রাণীর গণক / প্রাণীর সংখ্যা",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v517",
    "kana": "ひく",
    "kanji": "引く",
    "romaji": "hiku",
    "en": "to pull / to draw (a line)",
    "bn": "টানা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v518",
    "kana": "ひく",
    "kanji": "弾く",
    "romaji": "hiku",
    "en": "to play (instrument) / to play (piano / guitar) / to play (string instrument)",
    "bn": "বাজানো (যন্ত্র)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v519",
    "kana": "ひくい",
    "kanji": "低い",
    "romaji": "hikui",
    "en": "low/short / low / short / low / short (height)",
    "bn": "নিচু/খাটো / নিচু / খাটো",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v520",
    "kana": "ひこうき",
    "kanji": "飛行機",
    "romaji": "hikouki",
    "en": "airplane",
    "bn": "বিমান",
    "category": "transport",
    "level": "N5"
  },
  {
    "id": "n5v521",
    "kana": "ひだり",
    "kanji": "左",
    "romaji": "hidari",
    "en": "left",
    "bn": "বাম",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v522",
    "kana": "ひと",
    "kanji": "人",
    "romaji": "hito",
    "en": "person",
    "bn": "ব্যক্তি / মানুষ",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v523",
    "kana": "ひとつ",
    "kanji": "一つ",
    "romaji": "hitotsu",
    "en": "one (object) / one (thing)",
    "bn": "একটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v524",
    "kana": "ひとつき",
    "kanji": "一月",
    "romaji": "hitotsuki",
    "en": "one month",
    "bn": "এক মাস",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v525",
    "kana": "ひとり",
    "kanji": "一人",
    "romaji": "hitori",
    "en": "one person/alone",
    "bn": "একজন/একা",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v526",
    "kana": "ひま",
    "kanji": "暇",
    "romaji": "hima",
    "en": "free time / free time / leisure",
    "bn": "অবসর সময়",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v527",
    "kana": "ひゃく",
    "kanji": "百",
    "romaji": "hyaku",
    "en": "hundred",
    "bn": "শত / একশো",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v528",
    "kana": "びょういん",
    "kanji": "病院",
    "romaji": "byouin",
    "en": "hospital",
    "bn": "হাসপাতাল",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v529",
    "kana": "びょうき",
    "kanji": "病気",
    "romaji": "byouki",
    "en": "illness/sickness / illness / sickness",
    "bn": "অসুখ / অসুস্থতা",
    "category": "body",
    "level": "N5"
  },
  {
    "id": "n5v530",
    "kana": "ひらがな",
    "kanji": "平仮名",
    "romaji": "hiragana",
    "en": "hiragana / Hiragana",
    "bn": "হিরাগানা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v531",
    "kana": "ひる",
    "kanji": "昼",
    "romaji": "hiru",
    "en": "noon/daytime / noon / daytime",
    "bn": "দুপুর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v532",
    "kana": "ひるごはん",
    "kanji": "昼御飯",
    "romaji": "hirugohan",
    "en": "lunch",
    "bn": "দুপুরের খাবার",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v533",
    "kana": "ひろい",
    "kanji": "広い",
    "romaji": "hiroi",
    "en": "wide/spacious / wide / spacious",
    "bn": "প্রশস্ত",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v534",
    "kana": "フィルム",
    "kanji": null,
    "romaji": "firumu",
    "en": "film",
    "bn": "ফিল্ম",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v535",
    "kana": "ふうとう",
    "kanji": "封筒",
    "romaji": "fuutou",
    "en": "envelope",
    "bn": "খাম",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v536",
    "kana": "プール",
    "kanji": null,
    "romaji": "puuru",
    "en": "swimming pool",
    "bn": "সাঁতার কাটার পুল / সুইমিং পুল",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v537",
    "kana": "フォーク",
    "kanji": null,
    "romaji": "fouku",
    "en": "fork",
    "bn": "কাঁটাচামচ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v538",
    "kana": "ふく",
    "kanji": "吹く",
    "romaji": "fuku",
    "en": "to blow (wind)",
    "bn": "বহা / বওয়া (বাতাস) / বাতাস বওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v539",
    "kana": "ふく",
    "kanji": "服",
    "romaji": "fuku",
    "en": "clothes",
    "bn": "পোশাক",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v540",
    "kana": "ふたつ",
    "kanji": "二つ",
    "romaji": "futatsu",
    "en": "two (objects) / two (things)",
    "bn": "দুটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v541",
    "kana": "ぶたにく",
    "kanji": "豚肉",
    "romaji": "butaniku",
    "en": "pork",
    "bn": "শূকরের মাংস",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v542",
    "kana": "ふたり",
    "kanji": "二人",
    "romaji": "futari",
    "en": "two people",
    "bn": "দুজন",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v543",
    "kana": "ふつか",
    "kanji": "二日",
    "romaji": "futsuka",
    "en": "second day of the month / second day / two days",
    "bn": "দুই তারিখ / দ্বিতীয় দিন / দুদিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v544",
    "kana": "ふとい",
    "kanji": "太い",
    "romaji": "futoi",
    "en": "fat/thick / thick / fat",
    "bn": "পুরু/মোটা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v545",
    "kana": "ふゆ",
    "kanji": "冬",
    "romaji": "fuyu",
    "en": "winter",
    "bn": "শীতকাল",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v546",
    "kana": "ふる",
    "kanji": "降る",
    "romaji": "furu",
    "en": "to fall (rain/snow) / to fall (rain / snow)",
    "bn": "পড়া (বৃষ্টি/তুষার) / পড়া (বৃষ্টি / তুষার) / ঝরা/পড়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v547",
    "kana": "ふるい",
    "kanji": "古い",
    "romaji": "furui",
    "en": "old (not people)",
    "bn": "পুরানো",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v548",
    "kana": "〜ふん / 〜ぷん",
    "kanji": "〜分",
    "romaji": "-fun / -pun",
    "en": "minute(s) / minutes",
    "bn": "মিনিট",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v549",
    "kana": "ぶんしょう",
    "kanji": "文章",
    "romaji": "bunshou",
    "en": "sentence/text / sentence / text",
    "bn": "বাক্য",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v550",
    "kana": "へ",
    "kanji": null,
    "romaji": "he",
    "en": "to (direction)",
    "bn": "দিকে",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v551",
    "kana": "へた",
    "kanji": "下手",
    "romaji": "heta",
    "en": "unskillful",
    "bn": "অদক্ষ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v552",
    "kana": "ベッド",
    "kanji": null,
    "romaji": "beddo",
    "en": "bed",
    "bn": "বিছানা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v553",
    "kana": "ペット",
    "kanji": null,
    "romaji": "petto",
    "en": "pet",
    "bn": "গৃহপালিত প্রাণী / পোষা প্রাণী",
    "category": "animals",
    "level": "N5"
  },
  {
    "id": "n5v554",
    "kana": "へや",
    "kanji": "部屋",
    "romaji": "heya",
    "en": "room",
    "bn": "ঘর",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v555",
    "kana": "へん",
    "kanji": "辺",
    "romaji": "hen",
    "en": "area/vicinity / area / vicinity",
    "bn": "এলাকা",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v556",
    "kana": "ペン",
    "kanji": null,
    "romaji": "pen",
    "en": "pen",
    "bn": "কলম",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v557",
    "kana": "べんきょう",
    "kanji": "勉強",
    "romaji": "benkyou",
    "en": "study",
    "bn": "পড়াশোনা (-suru)",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v558",
    "kana": "べんり",
    "kanji": "便利",
    "romaji": "benri",
    "en": "convenient",
    "bn": "সুবিধাজনক",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v559",
    "kana": "ほう",
    "kanji": "方",
    "romaji": "hou",
    "en": "direction/side / direction / side",
    "bn": "দিক/পাশ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v560",
    "kana": "ぼうし",
    "kanji": "帽子",
    "romaji": "boushi",
    "en": "hat / hat / cap",
    "bn": "টুপি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v561",
    "kana": "ボールペン",
    "kanji": null,
    "romaji": "boorupen",
    "en": "ballpoint pen",
    "bn": "বলপয়েন্ট কলম / বলপেন",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v562",
    "kana": "ほか",
    "kanji": "他",
    "romaji": "hoka",
    "en": "other/else",
    "bn": "অন্যান্য",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v563",
    "kana": "ぼく",
    "kanji": "僕",
    "romaji": "boku",
    "en": "I (male)",
    "bn": "আমি (পুরুষ)",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v564",
    "kana": "ほそい",
    "kanji": "細い",
    "romaji": "hosoi",
    "en": "thin/slender / thin / slender",
    "bn": "সরু/চিকন / সরু / চিকন",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v565",
    "kana": "ボタン",
    "kanji": null,
    "romaji": "botan",
    "en": "button",
    "bn": "বোতাম",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v566",
    "kana": "ホテル",
    "kanji": null,
    "romaji": "hoteru",
    "en": "hotel",
    "bn": "হোটেল",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v567",
    "kana": "ほん",
    "kanji": "本",
    "romaji": "hon",
    "en": "book",
    "bn": "বই",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v568",
    "kana": "〜ほん",
    "kanji": "〜本",
    "romaji": "-hon",
    "en": "counter for long cylindrical objects",
    "bn": "লম্বা বস্তুর গণক",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v569",
    "kana": "ほんだな",
    "kanji": "本棚",
    "romaji": "hondana",
    "en": "bookshelf",
    "bn": "বইয়ের তাক / বইয়ের তাক",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v570",
    "kana": "ほんとう",
    "kanji": "本当",
    "romaji": "hontou",
    "en": "truth/real / truth / real",
    "bn": "সত্য / সত্য / আসল",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v571",
    "kana": "〜まい",
    "kanji": "〜枚",
    "romaji": "-mai",
    "en": "counter for flat objects",
    "bn": "চ্যাপ্টা বস্তুর গণক / পাতলা জিনিসের সংখ্যা",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v572",
    "kana": "まいあさ",
    "kanji": "毎朝",
    "romaji": "maiasa",
    "en": "every morning",
    "bn": "প্রতিদিন সকালে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v573",
    "kana": "まいげつ / まいつき",
    "kanji": "毎月",
    "romaji": "maigetsu / maitsuki",
    "en": "every month",
    "bn": "প্রতি মাসে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v574",
    "kana": "まいしゅう",
    "kanji": "毎週",
    "romaji": "maishuu",
    "en": "every week",
    "bn": "প্রতি সপ্তাহে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v575",
    "kana": "まいにち",
    "kanji": "毎日",
    "romaji": "mainichi",
    "en": "every day",
    "bn": "প্রতিদিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v576",
    "kana": "まいねん / まいとし",
    "kanji": "毎年",
    "romaji": "mainen / maitoshi",
    "en": "every year",
    "bn": "প্রতি বছর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v578",
    "kana": "まいばん",
    "kanji": "毎晩",
    "romaji": "maiban",
    "en": "every evening",
    "bn": "প্রতিদিন সন্ধ্যায় / প্রতি সন্ধ্যা",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v579",
    "kana": "まえ",
    "kanji": "前",
    "romaji": "mae",
    "en": "before/in front of / front / before",
    "bn": "আগে/সামনে / সামনে / আগে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v580",
    "kana": "〜まえ",
    "kanji": "〜前",
    "romaji": "-mae",
    "en": "before/ago / before / -ago",
    "bn": "আগে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v581",
    "kana": "まがる",
    "kanji": "曲がる",
    "romaji": "magaru",
    "en": "to turn/bend",
    "bn": "ঘোরা/বাঁকা হওয়া / মোড় নেওয়া / বাঁক নেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v582",
    "kana": "まずい",
    "kanji": null,
    "romaji": "mazui",
    "en": "unpleasant/distasteful / unappetizing / bad tasting",
    "bn": "অস্বাদের/খারাপ / বিস্বাদ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v583",
    "kana": "また",
    "kanji": null,
    "romaji": "mata",
    "en": "again/also / again / and then",
    "bn": "আবার/আরও",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v584",
    "kana": "まだ",
    "kanji": null,
    "romaji": "mada",
    "en": "yet/still / yet / still",
    "bn": "এখনো",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v585",
    "kana": "まち",
    "kanji": "町",
    "romaji": "machi",
    "en": "town/city",
    "bn": "শহর/নগর",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v586",
    "kana": "まつ",
    "kanji": "待つ",
    "romaji": "matsu",
    "en": "to wait",
    "bn": "অপেক্ষা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v587",
    "kana": "まっすぐ",
    "kanji": null,
    "romaji": "massugu",
    "en": "straight ahead",
    "bn": "সরাসরি সামনে",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v588",
    "kana": "マッチ",
    "kanji": null,
    "romaji": "matchi",
    "en": "match",
    "bn": "দেশলাই / দিয়াশলাই",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v589",
    "kana": "まど",
    "kanji": "窓",
    "romaji": "mado",
    "en": "window",
    "bn": "জানালা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v590",
    "kana": "まるい",
    "kanji": "丸い",
    "romaji": "marui",
    "en": "round/circular",
    "bn": "গোল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v591",
    "kana": "まん",
    "kanji": "万",
    "romaji": "man",
    "en": "ten thousand",
    "bn": "দশ হাজার",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v592",
    "kana": "まんねんひつ",
    "kanji": "万年筆",
    "romaji": "mannenhitsu",
    "en": "fountain pen",
    "bn": "ফাউন্টেন পেন / ঝরনা কলম",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v593",
    "kana": "みがく",
    "kanji": "磨く",
    "romaji": "migaku",
    "en": "to brush/polish / to polish/brush / to polish / brush (teeth)",
    "bn": "মাজা/ব্রাশ করা / মাজা (দাঁত) / মাজা / পালিশ করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v594",
    "kana": "みぎ",
    "kanji": "右",
    "romaji": "migi",
    "en": "right",
    "bn": "ডান",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v595",
    "kana": "みじかい",
    "kanji": "短い",
    "romaji": "mijikai",
    "en": "short",
    "bn": "ছোট/সংক্ষিপ্ত / সংক্ষিপ্ত / খাটো",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v596",
    "kana": "みず",
    "kanji": "水",
    "romaji": "mizu",
    "en": "water",
    "bn": "জল/পানি / জল / পানি",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v597",
    "kana": "みせ",
    "kanji": "店",
    "romaji": "mise",
    "en": "shop/store / shop / store",
    "bn": "দোকান",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v598",
    "kana": "みせる",
    "kanji": "見せる",
    "romaji": "miseru",
    "en": "to show",
    "bn": "দেখানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v599",
    "kana": "みち",
    "kanji": "道",
    "romaji": "michi",
    "en": "road/path / road / street",
    "bn": "রাস্তা",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v600",
    "kana": "みっか",
    "kanji": "三日",
    "romaji": "mikka",
    "en": "3rd day of the month / third day / three days",
    "bn": "তিন তারিখ / তৃতীয় দিন / তিন দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v601",
    "kana": "みっつ",
    "kanji": "三つ",
    "romaji": "mittsu",
    "en": "three / three (things)",
    "bn": "তিনটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v602",
    "kana": "みどり",
    "kanji": "緑",
    "romaji": "midori",
    "en": "green",
    "bn": "সবুজ",
    "category": "colors",
    "level": "N5"
  },
  {
    "id": "n5v603",
    "kana": "みなみ",
    "kanji": "南",
    "romaji": "minami",
    "en": "south",
    "bn": "দক্ষিণ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v604",
    "kana": "みみ",
    "kanji": "耳",
    "romaji": "mimi",
    "en": "ear",
    "bn": "কান",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v605",
    "kana": "みる",
    "kanji": "見る",
    "romaji": "miru",
    "en": "to see/watch",
    "bn": "দেখা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v606",
    "kana": "みんな",
    "kanji": null,
    "romaji": "minna",
    "en": "everyone / everyone / all",
    "bn": "সবাই",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v607",
    "kana": "むいか",
    "kanji": "六日",
    "romaji": "muika",
    "en": "6th day of the month / sixth day / six days",
    "bn": "ছয় তারিখ / ষষ্ঠ দিন / ছয় দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v608",
    "kana": "むこう",
    "kanji": "向こう",
    "romaji": "mukou",
    "en": "over there / over there / opposite side",
    "bn": "ঐখানে / ঐ দিকে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v609",
    "kana": "むずかしい",
    "kanji": "難しい",
    "romaji": "muzukashii",
    "en": "difficult",
    "bn": "কঠিন",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v610",
    "kana": "むっつ",
    "kanji": "六つ",
    "romaji": "muttsu",
    "en": "six (things)",
    "bn": "ছয়টি / ছয়টি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v611",
    "kana": "むら",
    "kanji": "村",
    "romaji": "mura",
    "en": "village",
    "bn": "গ্রাম",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v612",
    "kana": "め",
    "kanji": "目",
    "romaji": "me",
    "en": "eye",
    "bn": "চোখ",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v613",
    "kana": "メートル",
    "kanji": null,
    "romaji": "meetoru",
    "en": "metre / meter",
    "bn": "মিটার",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v614",
    "kana": "めがね",
    "kanji": "眼鏡",
    "romaji": "megane",
    "en": "glasses",
    "bn": "চশমা",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v615",
    "kana": "もう",
    "kanji": null,
    "romaji": "mou",
    "en": "already / more",
    "bn": "ইতিমধ্যে / আরও",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v616",
    "kana": "もういちど",
    "kanji": "もう一度",
    "romaji": "mou ichido",
    "en": "once more",
    "bn": "আরও একবার / আরেকবার",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v617",
    "kana": "もくようび",
    "kanji": "木曜日",
    "romaji": "mokuyoubi",
    "en": "Thursday",
    "bn": "বৃহস্পতিবার",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v618",
    "kana": "もしもし",
    "kanji": null,
    "romaji": "moshimoshi",
    "en": "hello (on phone)",
    "bn": "হ্যালো",
    "category": "expressions",
    "level": "N5"
  },
  {
    "id": "n5v619",
    "kana": "もつ",
    "kanji": "持つ",
    "romaji": "motsu",
    "en": "to hold/have / to hold / carry",
    "bn": "ধরা/থাকা / ধরা / বহন করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v620",
    "kana": "もっと",
    "kanji": null,
    "romaji": "motto",
    "en": "more",
    "bn": "আরও",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v621",
    "kana": "もの",
    "kanji": "物",
    "romaji": "mono",
    "en": "thing/object / thing / object",
    "bn": "জিনিস",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v622",
    "kana": "もん",
    "kanji": "門",
    "romaji": "mon",
    "en": "gate",
    "bn": "গেট / দরজা / গেট",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v623",
    "kana": "もんだい",
    "kanji": "問題",
    "romaji": "mondai",
    "en": "problem / problem / question",
    "bn": "সমস্যা / সমস্যা / প্রশ্ন",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v624",
    "kana": "やおや",
    "kanji": "八百屋",
    "romaji": "yaoya",
    "en": "greengrocer",
    "bn": "সবজি বিক্রেতা",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v625",
    "kana": "やさい",
    "kanji": "野菜",
    "romaji": "yasai",
    "en": "vegetable",
    "bn": "সবজি",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v626",
    "kana": "やさしい",
    "kanji": "易しい",
    "romaji": "yasashii",
    "en": "easy / easy / simple",
    "bn": "সহজ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v627",
    "kana": "やすい",
    "kanji": "安い",
    "romaji": "yasui",
    "en": "cheap / cheap / inexpensive",
    "bn": "সস্তা",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v628",
    "kana": "やすみ",
    "kanji": "休み",
    "romaji": "yasumi",
    "en": "rest/holiday / rest / holiday / absence",
    "bn": "ছুটি/বিশ্রাম / ছুটি / বিশ্রাম",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v629",
    "kana": "やすむ",
    "kanji": "休む",
    "romaji": "yasumu",
    "en": "to rest / to rest / take a day off",
    "bn": "বিশ্রাম করা / বিশ্রাম নেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v630",
    "kana": "やっつ",
    "kanji": "八つ",
    "romaji": "yattsu",
    "en": "eight / eight (things)",
    "bn": "আটটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v631",
    "kana": "やま",
    "kanji": "山",
    "romaji": "yama",
    "en": "mountain",
    "bn": "পাহাড়",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v632",
    "kana": "やる",
    "kanji": null,
    "romaji": "yaru",
    "en": "to do / to do/give / to do / give (to inferior)",
    "bn": "করা / করা/দেওয়া / করা / দেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v633",
    "kana": "ゆうがた",
    "kanji": "夕方",
    "romaji": "yuugata",
    "en": "evening",
    "bn": "সন্ধ্যা",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v634",
    "kana": "ゆうはん",
    "kanji": "夕飯",
    "romaji": "yuuhan",
    "en": "dinner",
    "bn": "রাতের খাবার",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v635",
    "kana": "ゆうびんきょく",
    "kanji": "郵便局",
    "romaji": "yuubinkyoku",
    "en": "post office",
    "bn": "ডাকঘর",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v636",
    "kana": "ゆうべ",
    "kanji": "夕べ",
    "romaji": "yuube",
    "en": "last night",
    "bn": "গতরাত",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v637",
    "kana": "ゆうめい",
    "kanji": "有名",
    "romaji": "yuumei",
    "en": "famous",
    "bn": "বিখ্যাত",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v638",
    "kana": "ゆき",
    "kanji": "雪",
    "romaji": "yuki",
    "en": "snow",
    "bn": "তুষার / বরফ / তুষার",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v639",
    "kana": "ゆっくり",
    "kanji": null,
    "romaji": "yukkuri",
    "en": "slowly / slowly / at ease",
    "bn": "ধীরে ধীরে",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v640",
    "kana": "ようか",
    "kanji": "八日",
    "romaji": "youka",
    "en": "8th day of month / eight days / eighth day of the month / eighth day / eight days",
    "bn": "আট তারিখ / আট দিন / মাসের অষ্টম দিন / অষ্টম দিন / আট দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v641",
    "kana": "ようふく",
    "kanji": "洋服",
    "romaji": "youfuku",
    "en": "Western clothes / Western-style clothes",
    "bn": "পাশ্চাত্য পোশাক / পশ্চিমা পোশাক",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v642",
    "kana": "よく",
    "kanji": null,
    "romaji": "yoku",
    "en": "well/often / often / well",
    "bn": "ভালোভাবে/প্রায়ই / প্রায়ই / ভালো করে",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v643",
    "kana": "よこ",
    "kanji": "横",
    "romaji": "yoko",
    "en": "side/beside / side / beside / horizontal",
    "bn": "পাশে / পাশ / পাশে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v644",
    "kana": "よっか",
    "kanji": "四日",
    "romaji": "yokka",
    "en": "4th day of month / four days / fourth day of the month / fourth day / four days",
    "bn": "চার তারিখ / চার দিন / মাসের চতুর্থ দিন / চতুর্থ দিন / চার দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v645",
    "kana": "よっつ",
    "kanji": "四つ",
    "romaji": "yottsu",
    "en": "four (things)",
    "bn": "চারটি",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v646",
    "kana": "よぶ",
    "kanji": "呼ぶ",
    "romaji": "yobu",
    "en": "to call / to call / invite",
    "bn": "ডাকা / ডাকা / আমন্ত্রণ জানানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v647",
    "kana": "よむ",
    "kanji": "読む",
    "romaji": "yomu",
    "en": "to read",
    "bn": "পড়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v648",
    "kana": "よる",
    "kanji": "夜",
    "romaji": "yoru",
    "en": "night",
    "bn": "রাত",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v649",
    "kana": "よわい",
    "kanji": "弱い",
    "romaji": "yowai",
    "en": "weak",
    "bn": "দুর্বল",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v650",
    "kana": "らいげつ",
    "kanji": "来月",
    "romaji": "raigetsu",
    "en": "next month",
    "bn": "আগামী মাস",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v651",
    "kana": "らいしゅう",
    "kanji": "来週",
    "romaji": "raishuu",
    "en": "next week",
    "bn": "আগামী সপ্তাহ",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v652",
    "kana": "らいねん",
    "kanji": "来年",
    "romaji": "rainen",
    "en": "next year",
    "bn": "আগামী বছর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v653",
    "kana": "ラジオ",
    "kanji": null,
    "romaji": "rajio",
    "en": "radio",
    "bn": "রেডিও",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v654",
    "kana": "りっぱ",
    "kanji": "立派",
    "romaji": "rippa",
    "en": "splendid / splendid / fine",
    "bn": "চমৎকার / চমৎকার / দুর্দান্ত",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v655",
    "kana": "りゅうがくせい",
    "kanji": "留学生",
    "romaji": "ryuugakusei",
    "en": "foreign student / overseas student / international student",
    "bn": "বিদেশী ছাত্র / বিদেশি ছাত্র",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v656",
    "kana": "りょうり",
    "kanji": "料理",
    "romaji": "ryouri",
    "en": "cooking / cuisine / cooking",
    "bn": "রান্না / রান্না / খাবার",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v657",
    "kana": "りょこう",
    "kanji": "旅行",
    "romaji": "ryokou",
    "en": "travel / travel / trip",
    "bn": "ভ্রমণ",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v658",
    "kana": "りんご",
    "kanji": null,
    "romaji": "ringo",
    "en": "apple",
    "bn": "আপেল",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v659",
    "kana": "れいぞうこ",
    "kanji": "冷蔵庫",
    "romaji": "reizouko",
    "en": "refrigerator",
    "bn": "রেফ্রিজারেটর",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v660",
    "kana": "レコード",
    "kanji": null,
    "romaji": "rekoudo",
    "en": "record",
    "bn": "রেকর্ড",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v661",
    "kana": "レストラン",
    "kanji": null,
    "romaji": "resutoran",
    "en": "restaurant",
    "bn": "রেস্তোরাঁ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v662",
    "kana": "れんしゅう",
    "kanji": "練習",
    "romaji": "renshuu",
    "en": "practice",
    "bn": "অনুশীলন",
    "category": "activities",
    "level": "N5"
  },
  {
    "id": "n5v663",
    "kana": "ろうか",
    "kanji": "廊下",
    "romaji": "rouka",
    "en": "corridor / corridor / hallway",
    "bn": "বারান্দা / করিডোর",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v664",
    "kana": "ろく",
    "kanji": "六",
    "romaji": "roku",
    "en": "six",
    "bn": "ছয় / ছয়",
    "category": "numbers",
    "level": "N5"
  },
  {
    "id": "n5v665",
    "kana": "わかい",
    "kanji": "若い",
    "romaji": "wakai",
    "en": "young",
    "bn": "তরুণ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v666",
    "kana": "わかる",
    "kanji": "分かる",
    "romaji": "wakaru",
    "en": "to understand",
    "bn": "বোঝা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v667",
    "kana": "わすれる",
    "kanji": "忘れる",
    "romaji": "wasureru",
    "en": "to forget",
    "bn": "ভুলে যাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v668",
    "kana": "わたし",
    "kanji": "私",
    "romaji": "watashi",
    "en": "me/I / I / me",
    "bn": "আমি",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v669",
    "kana": "わたす",
    "kanji": "渡す",
    "romaji": "watasu",
    "en": "to hand over",
    "bn": "হস্তান্তর করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v670",
    "kana": "わたる",
    "kanji": "渡る",
    "romaji": "wataru",
    "en": "to cross / to go across / to cross (bridge, street)",
    "bn": "পার হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v671",
    "kana": "わるい",
    "kanji": "悪い",
    "romaji": "warui",
    "en": "bad",
    "bn": "খারাপ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v675",
    "kana": "ナイフ",
    "kanji": null,
    "romaji": "naifu",
    "en": "knife",
    "bn": "ছুরি",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v676",
    "kana": "あらう",
    "kanji": "洗う",
    "romaji": "arau",
    "en": "to wash",
    "bn": "ধোয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v680",
    "kana": "じしょ",
    "kanji": "辞書",
    "romaji": "jisho",
    "en": "dictionary",
    "bn": "অভিধান",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v683",
    "kana": "くすり",
    "kanji": "薬",
    "romaji": "kusuri",
    "en": "medicine",
    "bn": "ওষুধ",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v684",
    "kana": "からだ",
    "kanji": "体",
    "romaji": "karada",
    "en": "body",
    "bn": "শরীর",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v685",
    "kana": "あたま",
    "kanji": "頭",
    "romaji": "atama",
    "en": "head",
    "bn": "মাথা",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v686",
    "kana": "うで",
    "kanji": "腕",
    "romaji": "ude",
    "en": "arm",
    "bn": "হাত/বাহু",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v687",
    "kana": "あし",
    "kanji": "足",
    "romaji": "ashi",
    "en": "leg/foot",
    "bn": "পা",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v691",
    "kana": "こころ",
    "kanji": "心",
    "romaji": "kokoro",
    "en": "heart/mind / heart / mind / heart/spirit",
    "bn": "মন / হৃদয়/মন / হৃদয়",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v692",
    "kana": "きんきょく",
    "kanji": "近曲",
    "romaji": "kinkyoku",
    "en": "neighborhood",
    "bn": "আশেপাশে",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v693",
    "kana": "じゅんび",
    "kanji": "準備",
    "romaji": "junbi",
    "en": "preparation",
    "bn": "প্রস্তুতি",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v694",
    "kana": "えらぶ",
    "kanji": "選ぶ",
    "romaji": "erabu",
    "en": "to choose",
    "bn": "বেছে নেওয়া / নির্বাচন করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v695",
    "kana": "はらう",
    "kanji": "払う",
    "romaji": "harau",
    "en": "to pay",
    "bn": "পরিশোধ করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v696",
    "kana": "わらう",
    "kanji": "笑う",
    "romaji": "warau",
    "en": "to laugh / to laugh / smile",
    "bn": "হাসা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v697",
    "kana": "おこる",
    "kanji": "怒る",
    "romaji": "okoru",
    "en": "to get angry",
    "bn": "রাগ করা / রাগান্বিত হওয়া / রাগান্বিত হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v698",
    "kana": "なく",
    "kanji": "泣く",
    "romaji": "naku",
    "en": "to cry",
    "bn": "কাঁদা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v699",
    "kana": "よろこぶ",
    "kanji": "喜ぶ",
    "romaji": "yorokobu",
    "en": "to be happy",
    "bn": "খুশি হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v700",
    "kana": "おどろく",
    "kanji": "驚く",
    "romaji": "odoroku",
    "en": "to be surprised",
    "bn": "অবাক হওয়া / অবাক হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v701",
    "kana": "さがす",
    "kanji": "探す",
    "romaji": "sagasu",
    "en": "to look for",
    "bn": "খোঁজা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v702",
    "kana": "なおす",
    "kanji": "直す",
    "romaji": "naosu",
    "en": "to fix/repair / to repair/fix",
    "bn": "মেরামত করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v703",
    "kana": "なげる",
    "kanji": "投げる",
    "romaji": "nageru",
    "en": "to throw",
    "bn": "ফেলা / ফেলা/নিক্ষেপ করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v704",
    "kana": "ぬすむ",
    "kanji": "盗む",
    "romaji": "nusumu",
    "en": "to steal",
    "bn": "চুরি করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v705",
    "kana": "ぬる",
    "kanji": "塗る",
    "romaji": "nuru",
    "en": "to paint/plaster",
    "bn": "রং করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v706",
    "kana": "ぬれる",
    "kanji": "濡れる",
    "romaji": "nureru",
    "en": "to get wet",
    "bn": "ভেজা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v707",
    "kana": "ねがう",
    "kanji": "願う",
    "romaji": "negau",
    "en": "to wish/desire / to desire/wish",
    "bn": "কামনা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v708",
    "kana": "のこる",
    "kanji": "残る",
    "romaji": "nokoru",
    "en": "to remain",
    "bn": "অবশিষ্ট থাকা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v710",
    "kana": "はこぶ",
    "kanji": "運ぶ",
    "romaji": "hakobu",
    "en": "to carry / to travel/carry",
    "bn": "বহন করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v716",
    "kana": "ひろう",
    "kanji": "拾う",
    "romaji": "hirou",
    "en": "to pick up",
    "bn": "কুড়ানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v719",
    "kana": "まける",
    "kanji": "負ける",
    "romaji": "makeru",
    "en": "to lose (a game)",
    "bn": "হেরে যাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v720",
    "kana": "まにあう",
    "kanji": "間に合う",
    "romaji": "maniau",
    "en": "to be in time",
    "bn": "ঠিক সময়ে পৌঁছানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v721",
    "kana": "まわす",
    "kanji": "回す",
    "romaji": "mawasu",
    "en": "to turn/rotate",
    "bn": "ঘোরানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v723",
    "kana": "みつける",
    "kanji": "見つける",
    "romaji": "mitsukeru",
    "en": "to find",
    "bn": "খুঁজে পাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v724",
    "kana": "むかえる",
    "kanji": "迎える",
    "romaji": "mukaeru",
    "en": "to welcome",
    "bn": "অভ্যর্থনা জানানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v725",
    "kana": "むすぶ",
    "kanji": "結ぶ",
    "romaji": "musubu",
    "en": "to tie",
    "bn": "বাঁধা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v726",
    "kana": "めぐりあう",
    "kanji": "巡り会う",
    "romaji": "meguriau",
    "en": "to meet by chance",
    "bn": "দৈবক্রমে দেখা হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v727",
    "kana": "もうしあげます",
    "kanji": "申し上げます",
    "romaji": "moushiagemasu",
    "en": "to say (humble)",
    "bn": "বলা (বিনীত)",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v728",
    "kana": "もどる",
    "kanji": "戻る",
    "romaji": "modoru",
    "en": "to return",
    "bn": "ফিরে আসা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v729",
    "kana": "もらう",
    "kanji": null,
    "romaji": "morau",
    "en": "to receive",
    "bn": "পাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v730",
    "kana": "やく",
    "kanji": "焼く",
    "romaji": "yaku",
    "en": "to bake/grill",
    "bn": "শেঁকা/ভাজা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v731",
    "kana": "やくだつ",
    "kanji": "役立つ",
    "romaji": "yakudatsu",
    "en": "to be useful",
    "bn": "উপকারী হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v732",
    "kana": "やせる",
    "kanji": "痩せる",
    "romaji": "yaseru",
    "en": "to lose weight",
    "bn": "রোগা হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v733",
    "kana": "やめる",
    "kanji": "辞める",
    "romaji": "yameru",
    "en": "to quit",
    "bn": "ছেড়ে দেওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v734",
    "kana": "ゆう",
    "kanji": "言う",
    "romaji": "yuu",
    "en": "to say",
    "bn": "বলা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v735",
    "kana": "ゆるす",
    "kanji": "許す",
    "romaji": "yurusu",
    "en": "to forgive",
    "bn": "ক্ষমা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v736",
    "kana": "ゆれる",
    "kanji": "揺れる",
    "romaji": "yureru",
    "en": "to shake/sway",
    "bn": "কাঁপা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v737",
    "kana": "よごす",
    "kanji": "汚す",
    "romaji": "yogosu",
    "en": "to make dirty",
    "bn": "নোংরা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v738",
    "kana": "よこぎる",
    "kanji": "横切る",
    "romaji": "yokogiru",
    "en": "to cross",
    "bn": "পার হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v740",
    "kana": "よる",
    "kanji": "寄る",
    "romaji": "yoru",
    "en": "to stop by",
    "bn": "যোওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v741",
    "kana": "わかれる",
    "kanji": "分かれる",
    "romaji": "wakareru",
    "en": "to split/divide",
    "bn": "বিভক্ত হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v744",
    "kana": "われる",
    "kanji": "割れる",
    "romaji": "wareru",
    "en": "to break",
    "bn": "ভেঙে যাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v745",
    "kana": "おもう",
    "kanji": "思う",
    "romaji": "omou",
    "en": "to think",
    "bn": "মনে করা / চিন্তা করা",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v748",
    "kana": "しぬ",
    "kanji": "死ぬ",
    "romaji": "shinu",
    "en": "to die",
    "bn": "মারা যাওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v749",
    "kana": "たたく",
    "kanji": "叩く",
    "romaji": "tataku",
    "en": "to strike/beat",
    "bn": "পেটানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v751",
    "kana": "なる",
    "kanji": "成る",
    "romaji": "naru",
    "en": "to become",
    "bn": "হওয়া",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v760",
    "kana": "はる",
    "kanji": "張る",
    "romaji": "haru",
    "en": "to stretch/put up / to stick/paste",
    "bn": "টানানো/লাগানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v780",
    "kana": "あたたかい",
    "kanji": "温かい",
    "romaji": "atatakai",
    "en": "warm (thing)",
    "bn": "উষ্ণ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v781",
    "kana": "あたたかい",
    "kanji": "暖かい",
    "romaji": "atatakai",
    "en": "warm (weather)",
    "bn": "উষ্ণ",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v782",
    "kana": "あたらしい",
    "kanji": "新しい",
    "romaji": "atarashii",
    "en": "new",
    "bn": "নতুন",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v783",
    "kana": "あつい",
    "kanji": "暑い",
    "romaji": "atsui",
    "en": "hot (weather)",
    "bn": "গরম",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v784",
    "kana": "あつい",
    "kanji": "熱い",
    "romaji": "atsui",
    "en": "hot (thing)",
    "bn": "গরম",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v785",
    "kana": "あつい",
    "kanji": "厚い",
    "romaji": "atsui",
    "en": "thick / thick / deep",
    "bn": "পুরু / পুরু / ঘন",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v786",
    "kana": "あぶない",
    "kanji": "危ない",
    "romaji": "abunai",
    "en": "dangerous",
    "bn": "বিপজ্জনক",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v787",
    "kana": "あまい",
    "kanji": "甘い",
    "romaji": "amai",
    "en": "sweet",
    "bn": "মিষ্টি",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v788",
    "kana": "あまり",
    "kanji": null,
    "romaji": "amari",
    "en": "not much / not very / not much (with negative)",
    "bn": "খুব একটা বেশি না / খুব একটা না",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v789",
    "kana": "いい",
    "kanji": "良い",
    "romaji": "ii",
    "en": "good",
    "bn": "ভালো",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v790",
    "kana": "いそがしい",
    "kanji": "忙しい",
    "romaji": "isogashii",
    "en": "busy",
    "bn": "ব্যস্ত",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v791",
    "kana": "いたい",
    "kanji": "痛い",
    "romaji": "itai",
    "en": "painful / painful / sore",
    "bn": "ব্যথা/কষ্টদায়ক",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v792",
    "kana": "いちばん",
    "kanji": "一番",
    "romaji": "ichiban",
    "en": "most/best / number one / best",
    "bn": "সবচেয়ে বেশি / সেরা / প্রথম / সেরা / এক নম্বর",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v793",
    "kana": "いつ",
    "kanji": null,
    "romaji": "itsu",
    "en": "when",
    "bn": "কখন",
    "category": "question",
    "level": "N5"
  },
  {
    "id": "n5v794",
    "kana": "いっしょ",
    "kanji": "一緒",
    "romaji": "issho",
    "en": "together",
    "bn": "একত্রে / একসাথে",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v795",
    "kana": "いつも",
    "kanji": null,
    "romaji": "itsumo",
    "en": "always",
    "bn": "সব সময় / সবসময়",
    "category": "adverbs",
    "level": "N5"
  },
  {
    "id": "n5v805",
    "kana": "うるさい",
    "kanji": "煩い",
    "romaji": "urusai",
    "en": "noisy/annoying",
    "bn": "কোলাহলপূর্ণ/জ্বালাতন",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v813",
    "kana": "えれべーたー",
    "kanji": null,
    "romaji": "erebeetaa",
    "en": "elevator",
    "bn": "লিফট",
    "category": "objects",
    "level": "N5"
  },
  {
    "id": "n5v816",
    "kana": "お",
    "kanji": "御",
    "romaji": "o",
    "en": "honorific prefix",
    "bn": "সম্মানসূচক উপসর্গ",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v817",
    "kana": "おいしい",
    "kanji": "美味しい",
    "romaji": "oishii",
    "en": "delicious / delicious / tasty",
    "bn": "সুস্বাদু",
    "category": "adjectives",
    "level": "N5"
  },
  {
    "id": "n5v827",
    "kana": "おくる",
    "kanji": "送る",
    "romaji": "okuru",
    "en": "to send",
    "bn": "পাঠানো",
    "category": "verbs",
    "level": "N5"
  },
  {
    "id": "n5v847",
    "kana": "おばあさん",
    "kanji": null,
    "romaji": "obaasan",
    "en": "grandmother",
    "bn": "দাদি/নানি / দাদি / নানি",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v848",
    "kana": "おばさん",
    "kanji": null,
    "romaji": "obasan",
    "en": "aunt",
    "bn": "খালা/ফুফু / খালা / ফুফু",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v854",
    "kana": "よい",
    "kanji": "良い",
    "romaji": "yoi",
    "en": "good",
    "bn": "ভালো",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v860",
    "kana": "よにん",
    "kanji": "四人",
    "romaji": "yonin",
    "en": "four people",
    "bn": "চার জন",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v861",
    "kana": "よん",
    "kanji": "四",
    "romaji": "yon",
    "en": "four",
    "bn": "চার",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v872",
    "kana": "れい",
    "kanji": "零",
    "romaji": "rei",
    "en": "zero",
    "bn": "শূন্য",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v879",
    "kana": "ワイシャツ",
    "kanji": null,
    "romaji": "waishatsu",
    "en": "white shirt / dress shirt",
    "bn": "শার্ট",
    "category": "clothing",
    "level": "N5"
  },
  {
    "id": "n5v881",
    "kana": "分かる",
    "romaji": "wakaru",
    "en": "to understand",
    "bn": "বুঝতে পারা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v882",
    "kana": "忘れる",
    "romaji": "wasureru",
    "en": "to forget",
    "bn": "ভুলে যাওয়া",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v885",
    "kana": "私",
    "romaji": "watashi",
    "en": "I / me",
    "bn": "আমি",
    "category": "pronoun",
    "level": "N5"
  },
  {
    "id": "n5v887",
    "kana": "あがる",
    "kanji": "上がる",
    "romaji": "agaru",
    "en": "to rise / go up",
    "bn": "উপরে ওঠা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v888",
    "kana": "あける",
    "kanji": "空ける",
    "romaji": "akeru",
    "en": "to empty / clear out",
    "bn": "খালি করা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v889",
    "kana": "あげる",
    "kanji": "挙げる",
    "romaji": "ageru",
    "en": "to give / raise",
    "bn": "দেওয়া / তোলা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v890",
    "kana": "あそぶ",
    "kanji": "遊ぶ",
    "romaji": "asobu",
    "en": "to play",
    "bn": "খেলা করা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v892",
    "kana": "あっち",
    "kanji": null,
    "romaji": "acchi",
    "en": "over there (casual)",
    "bn": "ওদিকে",
    "category": "position",
    "level": "N5"
  },
  {
    "id": "n5v893",
    "kana": "あと",
    "kanji": "後",
    "romaji": "ato",
    "en": "after / later",
    "bn": "পরে",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v894",
    "kana": "あなた",
    "kanji": null,
    "romaji": "anata",
    "en": "you",
    "bn": "আপনি / তুমি",
    "category": "pronoun",
    "level": "N5"
  },
  {
    "id": "n5v895",
    "kana": "あに",
    "kanji": "兄",
    "romaji": "ani",
    "en": "older brother",
    "bn": "বড় ভাই",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v896",
    "kana": "あね",
    "kanji": "姉",
    "romaji": "ane",
    "en": "older sister",
    "bn": "বড় বোন",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v897",
    "kana": "あの",
    "kanji": null,
    "romaji": "ano",
    "en": "that (over there)",
    "bn": "ওই",
    "category": "pronoun",
    "level": "N5"
  },
  {
    "id": "n5v898",
    "kana": "アパート",
    "kanji": null,
    "romaji": "apa-to",
    "en": "apartment",
    "bn": "অ্যাপার্টমেন্ট",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v899",
    "kana": "あびる",
    "kanji": "浴びる",
    "romaji": "abiru",
    "en": "to bathe / shower",
    "bn": "গোসল করা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v903",
    "kana": "あめ",
    "kanji": "雨",
    "romaji": "ame",
    "en": "rain",
    "bn": "বৃষ্টি",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v904",
    "kana": "あめ",
    "kanji": "飴",
    "romaji": "ame",
    "en": "candy",
    "bn": "ক্যান্ডি / লজেন্স",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v906",
    "kana": "ある",
    "kanji": null,
    "romaji": "aru",
    "en": "to exist (inanimate)",
    "bn": "থাকা (নির্জীব)",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v907",
    "kana": "あるく",
    "kanji": "歩く",
    "romaji": "aruku",
    "en": "to walk",
    "bn": "হাঁটা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v908",
    "kana": "あれ",
    "kanji": null,
    "romaji": "are",
    "en": "that (over there) / that / over there",
    "bn": "ওটা / তা / ওইটি",
    "category": "pronoun",
    "level": "N5"
  },
  {
    "id": "n5v910",
    "kana": "いいえ",
    "kanji": null,
    "romaji": "iie",
    "en": "no",
    "bn": "না",
    "category": "basic",
    "level": "N5"
  },
  {
    "id": "n5v911",
    "kana": "いう",
    "kanji": "言う",
    "romaji": "iu",
    "en": "to say",
    "bn": "বলা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v912",
    "kana": "いえ",
    "kanji": "家",
    "romaji": "ie",
    "en": "house / home",
    "bn": "বাড়ি",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v913",
    "kana": "いかが",
    "kanji": null,
    "romaji": "ikaga",
    "en": "how / in what way",
    "bn": "কেমন",
    "category": "adverb",
    "level": "N5"
  },
  {
    "id": "n5v914",
    "kana": "いく",
    "kanji": "行く",
    "romaji": "iku",
    "en": "to go",
    "bn": "যাওয়া",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v915",
    "kana": "いくつ",
    "kanji": null,
    "romaji": "ikutsu",
    "en": "how many / how old",
    "bn": "কয়টি / কত বয়স",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v916",
    "kana": "いくら",
    "kanji": null,
    "romaji": "ikura",
    "en": "how much (price)",
    "bn": "কত দাম / কত (দাম)",
    "category": "money",
    "level": "N5"
  },
  {
    "id": "n5v917",
    "kana": "いけ",
    "kanji": "池",
    "romaji": "ike",
    "en": "pond",
    "bn": "পুকুর",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v918",
    "kana": "いしゃ",
    "kanji": "医者",
    "romaji": "isha",
    "en": "doctor",
    "bn": "ডাক্তার",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v919",
    "kana": "いす",
    "kanji": "椅子",
    "romaji": "isu",
    "en": "chair",
    "bn": "চেয়ার / চেয়ার",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v922",
    "kana": "いち",
    "kanji": "一",
    "romaji": "ichi",
    "en": "one",
    "bn": "এক",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v923",
    "kana": "いちにち",
    "kanji": "一日",
    "romaji": "ichinichi",
    "en": "one day",
    "bn": "একদিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v926",
    "kana": "いつか",
    "kanji": "五日",
    "romaji": "itsuka",
    "en": "five days / fifth day of the month / fifth day / five days",
    "bn": "পাঁচ দিন / মাসের ৫ তারিখ / পঞ্চম দিন / পাঁচ দিন",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v928",
    "kana": "いつつ",
    "kanji": "五つ",
    "romaji": "itsutsu",
    "en": "five / five (things)",
    "bn": "পাঁচটি",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v930",
    "kana": "いぬ",
    "kanji": "犬",
    "romaji": "inu",
    "en": "dog",
    "bn": "কুকুর",
    "category": "animal",
    "level": "N5"
  },
  {
    "id": "n5v935",
    "kana": "いりぐち",
    "kanji": "入り口",
    "romaji": "iriguchi",
    "en": "entrance",
    "bn": "প্রবেশপথ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v946",
    "kana": "うちに",
    "kanji": null,
    "romaji": "uchi ni",
    "en": "while / during",
    "bn": "মধ্যে / চলাকালীন",
    "category": "abstract",
    "level": "N5"
  },
  {
    "id": "n5v977",
    "kana": "おじさん",
    "kanji": "叔父さん",
    "romaji": "ojisan",
    "en": "uncle / middle-aged man",
    "bn": "কাকা / মামা",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v994",
    "kana": "おばさん",
    "kanji": "伯母さん",
    "romaji": "obasan",
    "en": "aunt / middle-aged woman",
    "bn": "খালা / ফুফু",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v995",
    "kana": "おふる",
    "kanji": "お風呂",
    "romaji": "ofuro",
    "en": "bath",
    "bn": "গোসল",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v999",
    "kana": "おもしろい",
    "kanji": "面白い",
    "romaji": "omoshiroi",
    "en": "interesting / funny",
    "bn": "মজার",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1006",
    "kana": "〜がい",
    "kanji": "〜回",
    "romaji": "-kai",
    "en": "counter for times / frequency",
    "bn": "বার",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1007",
    "kana": "〜がい",
    "kanji": "〜階",
    "romaji": "-kai",
    "en": "counter for floors",
    "bn": "তলা",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1016",
    "kana": "かきとめ",
    "kanji": "書留",
    "romaji": "kakitome",
    "en": "registered mail",
    "bn": "রেজিস্টার্ড মেইল",
    "category": "communication",
    "level": "N5"
  },
  {
    "id": "n5v1020",
    "kana": "〜かげつ",
    "kanji": "〜ヶ月",
    "romaji": "-kagetsu",
    "en": "counter for months / months (duration)",
    "bn": "মাস (গণনা) / মাস (সময়কাল)",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1028",
    "kana": "かな",
    "kanji": null,
    "romaji": "kana",
    "en": "kana characters",
    "bn": "কানা অক্ষর",
    "category": "language",
    "level": "N5"
  },
  {
    "id": "n5v1029",
    "kana": "かならず",
    "kanji": "必ず",
    "romaji": "kanarazu",
    "en": "without fail / always / certainly",
    "bn": "অবশ্যই / সব সময়",
    "category": "adverb",
    "level": "N5"
  },
  {
    "id": "n5v1030",
    "kana": "かなしい",
    "kanji": "悲しい",
    "romaji": "kanashii",
    "en": "sad",
    "bn": "দুঃখিত",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1031",
    "kana": "かね",
    "kanji": "金",
    "romaji": "kane",
    "en": "money / metal",
    "bn": "টাকা / ধাতু",
    "category": "money",
    "level": "N5"
  },
  {
    "id": "n5v1034",
    "kana": "かぶる",
    "kanji": null,
    "romaji": "kaburu",
    "en": "to put on (a hat)",
    "bn": "পরা (টুপি)",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1041",
    "kana": "〜がる",
    "kanji": null,
    "romaji": "-garu",
    "en": "suffix for feeling / appearance",
    "bn": "অনুভব করা (সাফিক্স)",
    "category": "grammar",
    "level": "N5"
  },
  {
    "id": "n5v1043",
    "kana": "カレー",
    "kanji": null,
    "romaji": "kare-",
    "en": "curry",
    "bn": "কারি / তরকারি",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v1046",
    "kana": "〜かわ",
    "kanji": "〜側",
    "romaji": "-kawa",
    "en": "side",
    "bn": "দিক / পার্শ্ব",
    "category": "position",
    "level": "N5"
  },
  {
    "id": "n5v1049",
    "kana": "かんたん",
    "kanji": "簡単",
    "romaji": "kantan",
    "en": "easy / simple",
    "bn": "সহজ",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1051",
    "kana": "きいろ",
    "kanji": "黄色",
    "romaji": "kiiro",
    "en": "yellow",
    "bn": "হলুদ",
    "category": "color",
    "level": "N5"
  },
  {
    "id": "n5v1062",
    "kana": "きゅう",
    "kanji": "九",
    "romaji": "kyuu",
    "en": "nine",
    "bn": "নয়",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v1072",
    "kana": "きんじょ",
    "kanji": "近所",
    "romaji": "kinjo",
    "en": "neighborhood",
    "bn": "আশেপাশে / পাড়া / আশেপাশ/প্রতিবেশ",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v1075",
    "kana": "く",
    "kanji": "九",
    "romaji": "ku",
    "en": "nine",
    "bn": "নয়",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v1084",
    "kana": "くもる",
    "kanji": "曇る",
    "romaji": "kumoru",
    "en": "to become cloudy",
    "bn": "মেঘ করা / মেঘলা হওয়া",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1086",
    "kana": "〜くらい",
    "kanji": null,
    "romaji": "-kurai",
    "en": "about / approximately",
    "bn": "প্রায় / মতো",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1091",
    "kana": "くろ",
    "kanji": "黒",
    "romaji": "kuro",
    "en": "black",
    "bn": "কালো",
    "category": "color",
    "level": "N5"
  },
  {
    "id": "n5v1102",
    "kana": "〜ご",
    "kanji": "〜語",
    "romaji": "-go",
    "en": "language",
    "bn": "ভাষা",
    "category": "language",
    "level": "N5"
  },
  {
    "id": "n5v1106",
    "kana": "コート",
    "kanji": null,
    "romaji": "koo-to",
    "en": "coat",
    "bn": "কোট",
    "category": "clothing",
    "level": "N5"
  },
  {
    "id": "n5v1107",
    "kana": "コーヒー",
    "kanji": null,
    "romaji": "koo-hii",
    "en": "coffee",
    "bn": "কফি",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v1122",
    "kana": "コピーする",
    "kanji": null,
    "romaji": "kopii suru",
    "en": "to copy",
    "bn": "কপি করা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1125",
    "kana": "〜ころ / 〜ごろ",
    "kanji": null,
    "romaji": "-koro / -goro",
    "en": "around (time)",
    "bn": "প্রায় (সময়)",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v1131",
    "kana": "〜さい",
    "kanji": "〜歳",
    "romaji": "-sai",
    "en": "years old",
    "bn": "বছর বয়স",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1138",
    "kana": "〜さつ",
    "kanji": "〜冊",
    "romaji": "-satsu",
    "en": "counter for books",
    "bn": "বইয়ের সংখ্যা",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1142",
    "kana": "さようなら",
    "kanji": null,
    "romaji": "sayounara",
    "en": "goodbye",
    "bn": "বিদায়",
    "category": "greetings",
    "level": "N5"
  },
  {
    "id": "n5v1143",
    "kana": "さら",
    "kanji": "皿",
    "romaji": "sara",
    "en": "plate / dish",
    "bn": "থালা",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1146",
    "kana": "ラジカセ",
    "kanji": null,
    "romaji": "rajikase",
    "en": "radio cassette player",
    "bn": "রেডিও ক্যাসেট",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1151",
    "kana": "しお",
    "kanji": "塩",
    "romaji": "shio",
    "en": "salt",
    "bn": "লবণ",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v1152",
    "kana": "しかし",
    "kanji": null,
    "romaji": "shikashi",
    "en": "however",
    "bn": "কিন্তু",
    "category": "conjunction",
    "level": "N5"
  },
  {
    "id": "n5v1153",
    "kana": "じかん",
    "kanji": "時間",
    "romaji": "jikan",
    "en": "time / -hours",
    "bn": "সময় / ঘণ্টা",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v1154",
    "kana": "〜じかん",
    "kanji": "〜時間",
    "romaji": "-jikan",
    "en": "counter for hours",
    "bn": "ঘণ্টা",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1155",
    "kana": "しごと",
    "kanji": "仕事",
    "romaji": "shigoto",
    "en": "job / work",
    "bn": "কাজ",
    "category": "activity",
    "level": "N5"
  },
  {
    "id": "n5v1157",
    "kana": "しずか",
    "kanji": "静か",
    "romaji": "shizuka",
    "en": "quiet",
    "bn": "শান্ত / শান্ত/নিস্তব্ধ",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1158",
    "kana": "した",
    "kanji": "下",
    "romaji": "shita",
    "en": "below / under",
    "bn": "নিচে",
    "category": "direction",
    "level": "N5"
  },
  {
    "id": "n5v1159",
    "kana": "しつもん",
    "kanji": "質問",
    "romaji": "shitsumon",
    "en": "question",
    "bn": "প্রশ্ন",
    "category": "abstract",
    "level": "N5"
  },
  {
    "id": "n5v1160",
    "kana": "じてんしゃ",
    "kanji": "自転車",
    "romaji": "jitensha",
    "en": "bicycle",
    "bn": "সাইকেল",
    "category": "transport",
    "level": "N5"
  },
  {
    "id": "n5v1162",
    "kana": "じびき",
    "kanji": "字引",
    "romaji": "jibiki",
    "en": "dictionary",
    "bn": "অভিধান",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1163",
    "kana": "じぶん",
    "kanji": "自分",
    "romaji": "jibun",
    "en": "oneself",
    "bn": "নিজে",
    "category": "pronoun",
    "level": "N5"
  },
  {
    "id": "n5v1164",
    "kana": "しまる",
    "kanji": "閉まる",
    "romaji": "shimaru",
    "en": "to close / be closed",
    "bn": "বন্ধ হওয়া",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1165",
    "kana": "しめる",
    "kanji": "閉める",
    "romaji": "shimeru",
    "en": "to close something",
    "bn": "বন্ধ করা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1166",
    "kana": "しめる",
    "kanji": "締める",
    "romaji": "shimeru",
    "en": "to tie / fasten",
    "bn": "বাঁধা / আটকানো",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1167",
    "kana": "じゃ",
    "kanji": null,
    "romaji": "ja",
    "en": "well then",
    "bn": "তাহলে",
    "category": "conjunction",
    "level": "N5"
  },
  {
    "id": "n5v1168",
    "kana": "しゃしん",
    "kanji": "写真",
    "romaji": "shashin",
    "en": "photograph",
    "bn": "ছবি",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1169",
    "kana": "シャツ",
    "kanji": null,
    "romaji": "shatsu",
    "en": "shirt",
    "bn": "শার্ট",
    "category": "clothing",
    "level": "N5"
  },
  {
    "id": "n5v1170",
    "kana": "シャワー",
    "kanji": null,
    "romaji": "shawaa",
    "en": "shower",
    "bn": "ঝর্ণা / গোসল",
    "category": "activity",
    "level": "N5"
  },
  {
    "id": "n5v1171",
    "kana": "じゅう",
    "kanji": "十",
    "romaji": "juu",
    "en": "ten",
    "bn": "দশ",
    "category": "number",
    "level": "N5"
  },
  {
    "id": "n5v1172",
    "kana": "〜じゅう",
    "kanji": "〜中",
    "romaji": "-juu",
    "en": "throughout / during",
    "bn": "জুড়ে / সময়",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v1173",
    "kana": "じゅぎょう",
    "kanji": "授業",
    "romaji": "jugyou",
    "en": "lesson / class",
    "bn": "পাঠ / ক্লাস",
    "category": "activity",
    "level": "N5"
  },
  {
    "id": "n5v1174",
    "kana": "しゅくだい",
    "kanji": "宿題",
    "romaji": "shukudai",
    "en": "homework",
    "bn": "বাড়ির কাজ",
    "category": "activity",
    "level": "N5"
  },
  {
    "id": "n5v1175",
    "kana": "じょうず",
    "kanji": "上手",
    "romaji": "jouzu",
    "en": "skillful",
    "bn": "দক্ষ",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1176",
    "kana": "じょうぶ",
    "kanji": "丈夫",
    "romaji": "joubu",
    "en": "strong / durable",
    "bn": "মজবুত",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1177",
    "kana": "しょうゆ",
    "kanji": "醤油",
    "romaji": "shouyu",
    "en": "soy sauce",
    "bn": "সয়া সস",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v1178",
    "kana": "しょくどう",
    "kanji": "食堂",
    "romaji": "shokudou",
    "en": "cafeteria / dining hall",
    "bn": "ভোজনালয়",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v1179",
    "kana": "しる",
    "kanji": "知る",
    "romaji": "shiru",
    "en": "to know",
    "bn": "জানা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1180",
    "kana": "しろ",
    "kanji": "白",
    "romaji": "shiro",
    "en": "white",
    "bn": "সাদা",
    "category": "color",
    "level": "N5"
  },
  {
    "id": "n5v1181",
    "kana": "しろい",
    "kanji": "白い",
    "romaji": "shiroi",
    "en": "white",
    "bn": "সাদা",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1182",
    "kana": "にんじん",
    "kanji": "人参",
    "romaji": "ninjin",
    "en": "carrot",
    "bn": "গাজর",
    "category": "food",
    "level": "N5"
  },
  {
    "id": "n5v1185",
    "kana": "〜の",
    "kanji": null,
    "romaji": "-no",
    "en": "possessive particle",
    "bn": "এর",
    "category": "grammar",
    "level": "N5"
  },
  {
    "id": "n5v1189",
    "kana": "のりかえる",
    "kanji": "乗り換える",
    "romaji": "norikaeru",
    "en": "to transfer (train) / to transfer (trains)",
    "bn": "গাড়ি পরিবর্তন করা / পরিবর্তন করা (যানবাহন)",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1190",
    "kana": "のりもの",
    "kanji": "乗り物",
    "romaji": "norimono",
    "en": "vehicle",
    "bn": "যানবাহন",
    "category": "transport",
    "level": "N5"
  },
  {
    "id": "n5v1195",
    "kana": "〜はい",
    "kanji": "〜杯",
    "romaji": "-hai",
    "en": "counter for cups/glasses",
    "bn": "গ্লাসের সংখ্যা",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1196",
    "kana": "はいざら",
    "kanji": "灰皿",
    "romaji": "haizara",
    "en": "ashtray",
    "bn": "ছাইদানি / অ্যাশট্রে",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1205",
    "kana": "はじめ",
    "kanji": "初め / 始め",
    "romaji": "hajime",
    "en": "beginning",
    "bn": "শুরু",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v1226",
    "kana": "ハンカチ",
    "kanji": null,
    "romaji": "hankachi",
    "en": "handkerchief",
    "bn": "রুমাল",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1230",
    "kana": "ひ",
    "kanji": "火",
    "romaji": "hi",
    "en": "fire",
    "bn": "আগুন",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v1231",
    "kana": "ひ",
    "kanji": "日",
    "romaji": "hi",
    "en": "sun / day / day/sun",
    "bn": "সূর্য / দিন",
    "category": "nature",
    "level": "N5"
  },
  {
    "id": "n5v1237",
    "kana": "ひざ",
    "kanji": "左",
    "romaji": "hidari",
    "en": "left",
    "bn": "বাম",
    "category": "direction",
    "level": "N5"
  },
  {
    "id": "n5v1270",
    "kana": "ふろ",
    "kanji": "風呂",
    "romaji": "furo",
    "en": "bath",
    "bn": "গোসল",
    "category": "activity",
    "level": "N5"
  },
  {
    "id": "n5v1273",
    "kana": "ページ",
    "kanji": null,
    "romaji": "peeji",
    "en": "page",
    "bn": "পৃষ্ঠা",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1279",
    "kana": "ぺん",
    "kanji": null,
    "romaji": "pen",
    "en": "pen",
    "bn": "কলম",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1286",
    "kana": "ポケット",
    "kanji": null,
    "romaji": "poketto",
    "en": "pocket",
    "bn": "পকেট",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1287",
    "kana": "ほしい",
    "kanji": "欲しい",
    "romaji": "hoshii",
    "en": "want / desired",
    "bn": "চাওয়া",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1288",
    "kana": "ポスト",
    "kanji": null,
    "romaji": "posuto",
    "en": "postbox",
    "bn": "ডাকবাক্স",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1290",
    "kana": "ぼたん",
    "kanji": "ボタン",
    "romaji": "botan",
    "en": "button",
    "bn": "বোতাম",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1293",
    "kana": "〜ほん / 〜ぼん / 〜ぽん",
    "kanji": "〜本",
    "romaji": "-hon / -bon / -pon",
    "en": "counter for long cylindrical objects",
    "bn": "লম্বা জিনিসের সংখ্যা",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1296",
    "kana": "まい",
    "kanji": "毎",
    "romaji": "mai",
    "en": "every",
    "bn": "প্রতিটি",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v1302",
    "kana": "まいとし / まいねん",
    "kanji": "毎年",
    "romaji": "maitoshi / mainen",
    "en": "every year",
    "bn": "প্রতি বছর",
    "category": "time",
    "level": "N5"
  },
  {
    "id": "n5v1315",
    "kana": "まるい",
    "kanji": "丸い / 円い",
    "romaji": "marui",
    "en": "round / circular",
    "bn": "গোল / বৃত্তাকার",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1328",
    "kana": "みなさん",
    "kanji": "皆さん",
    "romaji": "minasan",
    "en": "everyone / all",
    "bn": "সবাই",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v1331",
    "kana": "みる",
    "kanji": "見る / 観る",
    "romaji": "miru",
    "en": "to see / watch",
    "bn": "দেখা",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1351",
    "kana": "や",
    "kanji": "屋",
    "romaji": "ya",
    "en": "shop / store / house",
    "bn": "দোকান / বাড়ি",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v1352",
    "kana": "〜や",
    "kanji": "〜屋",
    "romaji": "-ya",
    "en": "-shop / -seller",
    "bn": "দোকানি",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n5v1355",
    "kana": "やさしい",
    "kanji": "優しい",
    "romaji": "yasashii",
    "en": "kind / gentle",
    "bn": "দয়ালু",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1383",
    "kana": "りょうしん",
    "kanji": "両親",
    "romaji": "ryoushin",
    "en": "parents",
    "bn": "পিতামাতা",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v1402",
    "kana": "いい / よい",
    "kanji": "良い",
    "romaji": "ii / yoi",
    "en": "good / nice",
    "bn": "ভালো",
    "category": "adjective",
    "level": "N5"
  },
  {
    "id": "n5v1435",
    "kana": "うち",
    "kanji": "内",
    "romaji": "uchi",
    "en": "home / my home / within",
    "bn": "বাড়ি / ভেতর",
    "category": "place",
    "level": "N5"
  },
  {
    "id": "n5v1464",
    "kana": "おじさん",
    "kanji": "伯父さん / 叔父さん",
    "romaji": "ojisan",
    "en": "uncle / middle-aged man",
    "bn": "চাচা / মামা",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v1474",
    "kana": "おとす",
    "kanji": "落とす",
    "romaji": "otosu",
    "en": "to drop",
    "bn": "ফেলে দেওয়া / ফেলে দেওয়া",
    "category": "verb",
    "level": "N5"
  },
  {
    "id": "n5v1481",
    "kana": "おばさん",
    "kanji": "伯母さん / 叔母さん",
    "romaji": "obasan",
    "en": "aunt / middle-aged woman",
    "bn": "খালা / ফুফু",
    "category": "people",
    "level": "N5"
  },
  {
    "id": "n5v1488",
    "kana": "おもちゃ",
    "kanji": null,
    "romaji": "omocha",
    "en": "toy",
    "bn": "খেলনা",
    "category": "object",
    "level": "N5"
  },
  {
    "id": "n5v1489",
    "kana": "おもて",
    "kanji": "表",
    "romaji": "omote",
    "en": "front / surface / front side",
    "bn": "সামনে / সামনের দিক / সামনে / পৃষ্ঠ",
    "category": "direction",
    "level": "N5"
  },
  {
    "id": "n5v1496",
    "kana": "〜かい",
    "kanji": "〜回",
    "romaji": "-kai",
    "en": "counter for times",
    "bn": "বার",
    "category": "counter",
    "level": "N5"
  },
  {
    "id": "n4v001",
    "kana": "あく",
    "kanji": "開く",
    "romaji": "aku",
    "en": "to open",
    "bn": "খোলা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v002",
    "kana": "あやまる",
    "kanji": "謝る",
    "romaji": "ayamaru",
    "en": "to apologize",
    "bn": "ক্ষমা চাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v003",
    "kana": "あんしん",
    "kanji": "安心",
    "romaji": "anshin",
    "en": "relief / relief/peace of mind",
    "bn": "স্বস্তি",
    "category": "feelings",
    "level": "N4"
  },
  {
    "id": "n4v004",
    "kana": "あんぜん",
    "kanji": "安全",
    "romaji": "anzen",
    "en": "safety",
    "bn": "নিরাপত্তা",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v005",
    "kana": "いか",
    "kanji": "以下",
    "romaji": "ika",
    "en": "less than",
    "bn": "কম",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v006",
    "kana": "いがい",
    "kanji": "以外",
    "romaji": "igai",
    "en": "except",
    "bn": "ব্যতীত",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v007",
    "kana": "いがく",
    "kanji": "医学",
    "romaji": "igaku",
    "en": "medical science",
    "bn": "চিকিৎসা বিজ্ঞান",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v008",
    "kana": "いきる",
    "kanji": "生きる",
    "romaji": "ikiru",
    "en": "to live",
    "bn": "বেঁচে থাকা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v009",
    "kana": "いけん",
    "kanji": "意見",
    "romaji": "iken",
    "en": "opinion",
    "bn": "মতামত",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v010",
    "kana": "いし",
    "kanji": "石",
    "romaji": "ishi",
    "en": "stone",
    "bn": "পাথর",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v011",
    "kana": "いじめる",
    "kanji": null,
    "romaji": "ijimeru",
    "en": "to bully",
    "bn": "ত্যক্ত করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v012",
    "kana": "いじょう",
    "kanji": "以上",
    "romaji": "ijou",
    "en": "more than",
    "bn": "বেশি",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v013",
    "kana": "いそぐ",
    "kanji": "急ぐ",
    "romaji": "isogu",
    "en": "to hurry",
    "bn": "তাড়াহুড়া করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v014",
    "kana": "いたす",
    "kanji": "致す",
    "romaji": "itasu",
    "en": "to do (humble)",
    "bn": "করা (বিনম্র)",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v015",
    "kana": "いちど",
    "kanji": "一度",
    "romaji": "ichido",
    "en": "once",
    "bn": "একবার",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v016",
    "kana": "いっしょうけんめい",
    "kanji": "一生懸命",
    "romaji": "isshoukenmei",
    "en": "with all one's effort",
    "bn": "কঠোর পরিশ্রমের সাথে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v017",
    "kana": "いっぱい",
    "kanji": null,
    "romaji": "ippai",
    "en": "full",
    "bn": "পূর্ণ",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v018",
    "kana": "いと",
    "kanji": "糸",
    "romaji": "ito",
    "en": "thread",
    "bn": "সুতা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v019",
    "kana": "いない",
    "kanji": "以内",
    "romaji": "inai",
    "en": "within",
    "bn": "অভ্যন্তরে",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v020",
    "kana": "いなか",
    "kanji": "田舎",
    "romaji": "inaka",
    "en": "countryside",
    "bn": "গ্রামাঞ্চল",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v021",
    "habit": "いのる",
    "kanji": "祈る",
    "romaji": "inoru",
    "en": "to pray",
    "bn": "প্রার্থনা করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v022",
    "kana": "いらっしゃる",
    "kanji": null,
    "romaji": "irassharu",
    "en": "to be/come/go (honorific)",
    "bn": "থাকা/আসা/যাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v023",
    "kana": "うえ",
    "kanji": "植える",
    "romaji": "ueru",
    "en": "to plant",
    "bn": "রোপণ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v024",
    "kana": "うかがう",
    "kanji": "伺う",
    "romaji": "ukagau",
    "en": "to visit/ask (humble)",
    "bn": "পরিদর্শন করা/জিজ্ঞাসা করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v025",
    "kana": "うけつけ",
    "kanji": "受付",
    "romaji": "uketsuke",
    "en": "reception",
    "bn": "অভ্যর্থনা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v026",
    "kana": "うける",
    "kanji": "受ける",
    "romaji": "ukeru",
    "en": "to receive/take a test / to receive/take (test)",
    "bn": "গ্রহণ করা/পরীক্ষা দেওয়া / গ্রহণ করা/পরীক্ষা দেওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v027",
    "kana": "うごく",
    "kanji": "動く",
    "romaji": "ugoku",
    "en": "to move",
    "bn": "নড়াচড়া করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v028",
    "kana": "うそ",
    "kanji": null,
    "romaji": "uso",
    "en": "lie",
    "bn": "মিথ্যা",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v029",
    "kana": "うちゅう",
    "kanji": "宇宙",
    "romaji": "uchuu",
    "en": "space / space/universe",
    "bn": "মহাকাশ",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v030",
    "kana": "うつ",
    "kanji": "打つ",
    "romaji": "utsu",
    "en": "to hit",
    "bn": "আঘাত করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v031",
    "kana": "うつくしい",
    "kanji": "美しい",
    "romaji": "utsukushii",
    "en": "beautiful",
    "bn": "সুন্দর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v032",
    "kana": "うつす",
    "kanji": "写す",
    "romaji": "utsusu",
    "en": "to copy / to copy/photograph",
    "bn": "অনুলিপি করা / কপি করা/ছবি তোলা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v033",
    "kana": "うつる",
    "kanji": "移る",
    "romaji": "utsuru",
    "en": "to move/transfer",
    "bn": "স্থানান্তরিত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v035",
    "kana": "うら",
    "kanji": "裏",
    "romaji": "ura",
    "en": "reverse side",
    "bn": "বিপরীত দিক",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v036",
    "kana": "うりば",
    "kanji": "売り場",
    "romaji": "uriba",
    "en": "selling area / sales counter",
    "bn": "বিক্রয় কেন্দ্র / বিক্রয় কাউন্টার",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v037",
    "kana": "うれしい",
    "kanji": null,
    "romaji": "ureshii",
    "en": "happy",
    "bn": "খুশি",
    "category": "feelings",
    "level": "N4"
  },
  {
    "id": "n4v038",
    "kana": "うん",
    "kanji": null,
    "romaji": "un",
    "en": "luck",
    "bn": "ভাগ্য",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v039",
    "kana": "うんてん",
    "kanji": "運転",
    "romaji": "unten",
    "en": "driving",
    "bn": "ড্রাইভিং",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v040",
    "kana": "うんどう",
    "kanji": "運動",
    "romaji": "undou",
    "en": "exercise",
    "bn": "ব্যায়াম",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v042",
    "kana": "えんりょ",
    "kanji": "遠慮",
    "romaji": "enryo",
    "en": "reserve/hesitation",
    "bn": "সংকোচ",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v043",
    "kana": "おかげ",
    "kanji": null,
    "romaji": "okage",
    "en": "thanks to",
    "bn": "কারণে",
    "category": "expressions",
    "level": "N4"
  },
  {
    "id": "n4v044",
    "kana": "おかしい",
    "kanji": null,
    "romaji": "okashii",
    "en": "strange/funny",
    "bn": "বিচিত্র/মজার",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v045",
    "kana": "おき",
    "kanji": "置き",
    "romaji": "oki",
    "en": "at intervals of",
    "bn": "বিরতিতে",
    "category": "nouns",
    "level": "N4"
  },
  {
    "id": "n4v046",
    "kana": "おく",
    "kanji": "億",
    "romaji": "oku",
    "en": "one hundred million",
    "bn": "দশ কোটি",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v047",
    "kana": "おくじょう",
    "kanji": "屋上",
    "romaji": "okujou",
    "en": "rooftop",
    "bn": "ছাদ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v048",
    "kana": "おくりもの",
    "kanji": "贈り物",
    "romaji": "okurimono",
    "en": "gift",
    "bn": "উপহার",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v050",
    "kana": "おくれる",
    "kanji": "遅れる",
    "romaji": "okureru",
    "en": "to be late",
    "bn": "দেরি হওয়া / দেরি হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v101",
    "kana": "あいさつ",
    "kanji": "挨拶",
    "romaji": "aisatsu",
    "en": "greeting",
    "bn": "অভিবাদন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v103",
    "kana": "あかちゃん",
    "kanji": "赤ちゃん",
    "romaji": "akachan",
    "en": "baby",
    "bn": "শিশু",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v104",
    "kana": "あかい",
    "kanji": "浅い",
    "romaji": "asai",
    "en": "shallow",
    "bn": "অগভীর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v105",
    "kana": "あじ",
    "kanji": "味",
    "romaji": "aji",
    "en": "taste",
    "bn": "স্বাদ",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v106",
    "kana": "あした",
    "kanji": "明日",
    "romaji": "ashita",
    "en": "tomorrow",
    "bn": "আগামীকাল",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v107",
    "kana": "あそび",
    "kanji": "遊び",
    "romaji": "asobi",
    "en": "play/game",
    "bn": "খেলা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v108",
    "kana": "あつまる",
    "kanji": "集まる",
    "romaji": "atsumaru",
    "en": "to gather",
    "bn": "একত্রিত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v109",
    "kana": "あつめる",
    "kanji": "集める",
    "romaji": "atsumeru",
    "en": "to collect",
    "bn": "সংগ্রহ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v113",
    "kana": "あんな",
    "kanji": null,
    "romaji": "anna",
    "en": "that kind of",
    "bn": "সেই ধরনের",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v114",
    "kana": "あんない",
    "kanji": "案内",
    "romaji": "annai",
    "en": "guide",
    "bn": "নির্দেশিকা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v118",
    "kana": "いきてる",
    "kanji": "生きてる",
    "romaji": "ikiteru",
    "en": "living",
    "bn": "জীবিত",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v121",
    "kana": "いじめる",
    "kanji": "苛める",
    "romaji": "ijimeru",
    "en": "to bully",
    "bn": "ত্যক্ত করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v125",
    "kana": "いただく",
    "kanji": "頂く",
    "romaji": "itadaku",
    "en": "to receive (humble)",
    "bn": "গ্রহণ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v132",
    "kana": "いのる",
    "kanji": "祈る",
    "romaji": "inoru",
    "en": "to pray",
    "bn": "প্রার্থনা করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v134",
    "kana": "うえる",
    "kanji": "植える",
    "romaji": "ueru",
    "en": "to plant",
    "bn": "রোপণ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v151",
    "kana": "おーとばい",
    "kanji": "オートバイ",
    "romaji": "ootobai",
    "en": "motorcycle",
    "bn": "মোটরসাইকেল",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v152",
    "kana": "おかげ",
    "kanji": "お陰",
    "romaji": "okage",
    "en": "thanks to",
    "bn": "কারণে/ধন্যবাদ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v153",
    "kana": "おかしい",
    "kanji": "可笑しい",
    "romaji": "okashii",
    "en": "strange/funny / strange / funny",
    "bn": "বিচিত্র/মজার / অদ্ভুত / মজার",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v160",
    "kana": "おこす",
    "kanji": "起こす",
    "romaji": "okosu",
    "en": "to wake someone up",
    "bn": "কাউকে জাগানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v161",
    "kana": "おこなう",
    "kanji": "行う",
    "romaji": "okonau",
    "en": "to perform/do / to perform / do / carry out",
    "bn": "সম্পাদন করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v163",
    "kana": "おしいれ",
    "kanji": "押し入れ",
    "romaji": "oshiire",
    "en": "closet / closet / wardrobe",
    "bn": "আলমারি / আলমারি / ক্লোজেট",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v164",
    "kana": "おじょうさん",
    "kanji": "お嬢さん",
    "romaji": "ojoousan",
    "en": "young lady/daughter / young lady / daughter (polite)",
    "bn": "যুবতী/কন্যা / তরুণী / কন্যা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v165",
    "kana": "おだやか",
    "kanji": "穏やか",
    "romaji": "odayaka",
    "en": "calm/peaceful",
    "bn": "শান্ত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v166",
    "kana": "おたまじゃくし",
    "kanji": null,
    "romaji": "otamajakushi",
    "en": "tadpole",
    "bn": "ব্যাঙাচি",
    "category": "animals",
    "level": "N4"
  },
  {
    "id": "n4v167",
    "kana": "おちる",
    "kanji": "落ちる",
    "romaji": "ochiru",
    "en": "to fall / to fall / fail",
    "bn": "পড়ে যাওয়া / পড়ে যাওয়া / ব্যর্থ হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v168",
    "kana": "おっしゃる",
    "kanji": null,
    "romaji": "ossharu",
    "en": "to say (honorific)",
    "bn": "বলা (সম্মানীয়) / বলা (সম্মানসূচক)",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v169",
    "kana": "おっと",
    "kanji": "夫",
    "romaji": "otto",
    "en": "husband",
    "bn": "স্বামী",
    "category": "family",
    "level": "N4"
  },
  {
    "id": "n4v170",
    "kana": "おつり",
    "kanji": "お釣り",
    "romaji": "otsuri",
    "en": "change (money)",
    "bn": "বাকি টাকা / খুচরা টাকা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v173",
    "kana": "おどり",
    "kanji": "踊り",
    "romaji": "odori",
    "en": "dance",
    "bn": "নাচ",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v175",
    "kana": "おまつり",
    "kanji": "お祭り",
    "romaji": "omatsuri",
    "en": "festival",
    "bn": "উৎসব",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v176",
    "kana": "おみまい",
    "kanji": "お見舞い",
    "romaji": "omimai",
    "en": "visiting ill person / calling on the sick / inquiry",
    "bn": "অসুস্থ ব্যক্তিকে দেখতে যাওয়া / অসুস্থ কাউকে দেখতে যাওয়া",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v177",
    "kana": "おみやげ",
    "kanji": "お土産",
    "romaji": "omiyage",
    "en": "souvenir",
    "bn": "স্মৃতিচিহ্ন / স্মৃতিচিহ্ন / উপহার",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v178",
    "kana": "おもいだす",
    "kanji": "思い出す",
    "romaji": "omoidasu",
    "en": "to remember / to remember / recall",
    "bn": "মনোভাব প্রকাশ করা / মনে করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v181",
    "kana": "おや",
    "kanji": "親",
    "romaji": "oya",
    "en": "parent",
    "bn": "অভিভাবক / পিতা-মাতা / অভিভাবক",
    "category": "family",
    "level": "N4"
  },
  {
    "id": "n4v183",
    "kana": "おる",
    "kanji": "折る",
    "romaji": "oru",
    "en": "to break/fold / to break / fold",
    "bn": "ভাঙা/ভাঁজ করা / ভাঙা / ভাঁজ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v184",
    "kana": "おれい",
    "kanji": "お礼",
    "romaji": "orei",
    "en": "gratitude / thanks / gratitude",
    "bn": "কৃতজ্ঞতা / ধন্যবাদ / কৃতজ্ঞতা",
    "category": "expressions",
    "level": "N4"
  },
  {
    "id": "n4v186",
    "kana": "かいがん",
    "kanji": "海岸",
    "romaji": "kaigan",
    "en": "coast",
    "bn": "উপকূল",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v187",
    "kana": "かいぎ",
    "kanji": "会議",
    "romaji": "kaigi",
    "en": "meeting",
    "bn": "সভা",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v188",
    "kana": "かいぎしつ",
    "kanji": "会議室",
    "romaji": "kaigishitsu",
    "en": "meeting room",
    "bn": "সভা কক্ষ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v189",
    "kana": "かいじょう",
    "kanji": "会場",
    "romaji": "kaijou",
    "en": "venue",
    "bn": "ঘটনাস্থল",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v190",
    "kana": "かいわ",
    "kanji": "会話",
    "romaji": "kaiwa",
    "en": "conversation",
    "bn": "কথোপকথন",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v191",
    "kana": "かえり",
    "kanji": "帰り",
    "romaji": "kaeri",
    "en": "return home",
    "bn": "ফিরে আসা",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v192",
    "kana": "かえる",
    "kanji": "変える",
    "romaji": "kaeru",
    "en": "to change",
    "bn": "পরিবর্তন করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v193",
    "kana": "かがく",
    "kanji": "科学",
    "romaji": "kagaku",
    "en": "science",
    "bn": "বিজ্ঞান",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v194",
    "kana": "かがみ",
    "kanji": "鏡",
    "romaji": "kagami",
    "en": "mirror",
    "bn": "আয়না",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v196",
    "kana": "かざる",
    "kanji": "飾る",
    "romaji": "kazaru",
    "en": "to decorate",
    "bn": "সাজানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v197",
    "kana": "かじ",
    "kanji": "火事",
    "romaji": "kaji",
    "en": "fire accident",
    "bn": "অগ্নিকাণ্ড",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v198",
    "kana": "ガス",
    "kanji": null,
    "romaji": "gasu",
    "en": "gas",
    "bn": "গ্যাস",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v199",
    "kana": "ガソリン",
    "kanji": null,
    "romaji": "gasorin",
    "en": "gasoline",
    "bn": "পেট্রোল",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v200",
    "kana": "かた",
    "kanji": "型",
    "romaji": "kata",
    "en": "mold/model",
    "bn": "নমুনা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v201",
    "kana": "かたい",
    "kanji": "硬い",
    "romaji": "katai",
    "en": "hard/stiff",
    "bn": "শক্ত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v202",
    "kana": "かたち",
    "kanji": "形",
    "romaji": "katachi",
    "en": "shape / shape / form",
    "bn": "আকৃতি / আকার",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v203",
    "kana": "かたづける",
    "kanji": "片付ける",
    "romaji": "katazukeru",
    "en": "to tidy up",
    "bn": "গোছানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v204",
    "kana": "かちょう",
    "kanji": "課長",
    "romaji": "kachou",
    "en": "section manager",
    "bn": "বিভাগীয় ব্যবস্থাপক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v205",
    "kana": "かつ",
    "kanji": "勝つ",
    "romaji": "katsu",
    "en": "to win",
    "bn": "জেতা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v206",
    "kana": "かっこ",
    "kanji": "括弧",
    "romaji": "kakko",
    "en": "parenthesis",
    "bn": "বন্ধনী",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v207",
    "kana": "かっこう",
    "kanji": "格好",
    "romaji": "kakkou",
    "en": "appearance",
    "bn": "চেহারা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v208",
    "kana": "かない",
    "kanji": "家内",
    "romaji": "kanai",
    "en": "wife (own)",
    "bn": "বউ (নিজের) / স্ত্রী (নিজের)",
    "category": "family",
    "level": "N4"
  },
  {
    "id": "n4v209",
    "kana": "かなしむ",
    "kanji": "悲しむ",
    "romaji": "kanashimu",
    "en": "to be sad",
    "bn": "দুঃখিত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v211",
    "kana": "かなり",
    "kanji": null,
    "romaji": "kanari",
    "en": "considerably / considerably / quite",
    "bn": "যথেষ্ট / বেশ / অনেকটা",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v212",
    "kana": "かねもち",
    "kanji": "金持ち",
    "romaji": "kanemochi",
    "en": "rich person",
    "bn": "ধনী ব্যক্তি",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v213",
    "kana": "かのじょ",
    "kanji": "彼女",
    "romaji": "kanojo",
    "en": "she/girlfriend",
    "bn": "সে/বান্ধবী",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v214",
    "kana": "かべ",
    "kanji": "壁",
    "romaji": "kabe",
    "en": "wall",
    "bn": "দেয়াল",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v215",
    "kana": "かみ",
    "kanji": "髪",
    "romaji": "kami",
    "en": "hair",
    "bn": "চুল",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v216",
    "kana": "かむ",
    "kanji": "噛む",
    "romaji": "kamu",
    "en": "to bite/chew",
    "bn": "কামড়ানো/চিবানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v217",
    "kana": "かよう",
    "kanji": "通う",
    "romaji": "kayou",
    "en": "to commute",
    "bn": "যাতায়াত করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v218",
    "kana": "ガラス",
    "kanji": null,
    "romaji": "garasu",
    "en": "glass pane",
    "bn": "কাঁচ",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v219",
    "kana": "からだにいい",
    "kanji": "体にいい",
    "romaji": "karadani ii",
    "en": "good for health",
    "bn": "স্বাস্থ্যের জন্য ভালো",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v224",
    "kana": "かわく",
    "kanji": "乾く",
    "romaji": "kawaku",
    "en": "to get dry",
    "bn": "শুকানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v225",
    "kana": "かわる",
    "kanji": "代わる",
    "romaji": "kawaru",
    "en": "to substitute",
    "bn": "বদল করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v226",
    "kana": "かんがえる",
    "kanji": "考える",
    "romaji": "kangaeru",
    "en": "to think",
    "bn": "ভাবা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v227",
    "kana": "かんけい",
    "kanji": "関係",
    "romaji": "kankei",
    "en": "relation",
    "bn": "সম্পর্ক",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v228",
    "kana": "かんごふ",
    "kanji": "看護婦",
    "romaji": "kangofu",
    "en": "nurse",
    "bn": "নার্স",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v230",
    "kana": "がんばる",
    "kanji": "頑張る",
    "romaji": "ganbaru",
    "en": "to do one's best",
    "bn": "ভালো করার চেষ্টা করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v231",
    "kana": "き",
    "kanji": "気",
    "romaji": "ki",
    "en": "spirit/mind / spirit / mind",
    "bn": "মন / মন / চেতনা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v234",
    "kana": "きく",
    "kanji": "効く",
    "romaji": "kiku",
    "en": "to be effective",
    "bn": "কার্যকর হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v235",
    "kana": "きざむ",
    "kanji": "刻む",
    "romaji": "kizamu",
    "en": "to chop/carve",
    "bn": "কাটা/খোদাই করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v236",
    "kana": "きびしい",
    "kanji": "厳しい",
    "romaji": "kibishii",
    "en": "strict/severe",
    "bn": "কঠোর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v237",
    "kana": "きぶん",
    "kanji": "気分",
    "romaji": "kibun",
    "en": "mood/feeling",
    "bn": "মেজাজ/অনুভূতি",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v238",
    "kana": "きまる",
    "kanji": "決まる",
    "romaji": "kimaru",
    "en": "to be decided",
    "bn": "স্থির হওয়া / স্থির হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v239",
    "kana": "きみ",
    "kanji": "君",
    "romaji": "kimi",
    "en": "you (informal) / you (familiar)",
    "bn": "তুমি",
    "category": "pronouns",
    "level": "N4"
  },
  {
    "id": "n4v240",
    "kana": "きめる",
    "kanji": "決める",
    "romaji": "kimeru",
    "en": "to decide",
    "bn": "স্থির করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v241",
    "kana": "きもち",
    "kanji": "気持ち",
    "romaji": "kimochi",
    "en": "feeling / feeling / mood",
    "bn": "অনুভূতি / মন / অনুভূতি",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v242",
    "kana": "きもの",
    "kanji": "着物",
    "romaji": "kimono",
    "en": "kimono",
    "bn": "কিমোনো",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v243",
    "kana": "きゃく",
    "kanji": "客",
    "romaji": "kyaku",
    "en": "guest/customer / guest / customer",
    "bn": "অতিথি",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v244",
    "kana": "きゅう",
    "kanji": "急",
    "romaji": "kyuu",
    "en": "urgent/sudden / urgent / steep",
    "bn": "জরুরি",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v245",
    "kana": "きゅうこう",
    "kanji": "急行",
    "romaji": "kyuukou",
    "en": "express train",
    "bn": "এক্সপ্রেস ট্রেন",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v246",
    "kana": "きょういく",
    "kanji": "教育",
    "romaji": "kyouiku",
    "en": "education",
    "bn": "শিক্ষা",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v247",
    "kana": "きょうかい",
    "kanji": "教会",
    "romaji": "kyoukai",
    "en": "church",
    "bn": "গির্জা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v248",
    "kana": "きょうそう",
    "kanji": "競争",
    "romaji": "kyousou",
    "en": "competition",
    "bn": "প্রতিযোগিতা",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v249",
    "kana": "きょうみ",
    "kanji": "興味",
    "romaji": "kyoumi",
    "en": "interest",
    "bn": "আগ্রহ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v251",
    "kana": "ぐあい",
    "kanji": "具合",
    "romaji": "guai",
    "en": "condition/health",
    "bn": "অবস্থা/স্বাস্থ্য",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v252",
    "kana": "くうき",
    "kanji": "空気",
    "romaji": "kuuki",
    "en": "air/atmosphere",
    "bn": "বাতাস/আবহাওয়া",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v253",
    "kana": "くうこう",
    "kanji": "空港",
    "romaji": "kuukou",
    "en": "airport",
    "bn": "বিমানবন্দর",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v254",
    "kana": "くさ",
    "kanji": "草",
    "romaji": "kusa",
    "en": "grass",
    "bn": "ঘাস",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v255",
    "kana": "くすりゆび",
    "kanji": "薬指",
    "romaji": "kusuriyubi",
    "en": "ring finger",
    "bn": "অনামিকা আঙুল",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v257",
    "kana": "くび",
    "kanji": "首",
    "romaji": "kubi",
    "en": "neck",
    "bn": "ঘাড়/গলা / ঘাড় / গলা",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v258",
    "kana": "くも",
    "kanji": "雲",
    "romaji": "kumo",
    "en": "cloud",
    "bn": "মেঘ",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v259",
    "kana": "くらべる",
    "kanji": "比べる",
    "romaji": "kuraberu",
    "en": "to compare",
    "bn": "তুলনা করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v260",
    "kana": "くるしい",
    "kanji": "苦しい",
    "romaji": "kurushii",
    "en": "painful/difficult / painful / difficult",
    "bn": "কষ্টদায়ক/কঠিন / কষ্টকর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v261",
    "kana": "くれる",
    "kanji": "暮れる",
    "romaji": "kureru",
    "en": "to get dark/to end / to get dark / to end",
    "bn": "অন্ধকার হওয়া/শেষ হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v262",
    "kana": "くん",
    "kanji": "君",
    "romaji": "kun",
    "en": "honorific for males / honorific for boys/juniors",
    "bn": "সম্মানসূচক শব্দ (পুরুষের জন্য)",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v263",
    "kana": "け",
    "kanji": "毛",
    "romaji": "ke",
    "en": "hair/fur / hair / fur",
    "bn": "চুল/লোম / চুল / পশম",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v264",
    "kana": "けいかく",
    "kanji": "計画",
    "romaji": "keikaku",
    "en": "plan/schedule / plan / project",
    "bn": "পরিকল্পনা/সময়সূচী",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v265",
    "kana": "けいけん",
    "kanji": "経験",
    "romaji": "keiken",
    "en": "experience",
    "bn": "অভিজ্ঞতা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v266",
    "kana": "けいざい",
    "kanji": "経済",
    "romaji": "keizai",
    "en": "economy/finance",
    "bn": "অর্থনীতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v267",
    "kana": "けいさつ",
    "kanji": "警察",
    "romaji": "keisatsu",
    "en": "police",
    "bn": "পুলিশ",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v268",
    "kana": "けしき",
    "kanji": "景色",
    "romaji": "keshiki",
    "en": "scenery/landscape / scenery / landscape",
    "bn": "দৃশ্য/ল্যান্ডস্কেপ",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v269",
    "kana": "けしゴム",
    "kanji": "消しゴム",
    "romaji": "keshigomu",
    "en": "eraser",
    "bn": "ইরেজার",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v270",
    "kana": "けっして",
    "kanji": "決して",
    "romaji": "kesshite",
    "en": "never / never / by no means",
    "bn": "কখনোই না",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v271",
    "kana": "けってい",
    "kanji": "決定",
    "romaji": "kettei",
    "en": "decision",
    "bn": "সিদ্ধান্ত",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v272",
    "kana": "けっせき",
    "kanji": "欠席",
    "romaji": "kesseki",
    "en": "absence",
    "bn": "অনুপস্থিতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v274",
    "kana": "てん",
    "kanji": "点",
    "romaji": "ten",
    "en": "point/score / point/mark",
    "bn": "পয়েন্ট/স্কোর",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v275",
    "kana": "けんか",
    "kanji": "喧嘩",
    "romaji": "kenka",
    "en": "quarrel/fight",
    "bn": "ঝগড়া/মারামারি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v276",
    "kana": "けんきゅう",
    "kanji": "研究",
    "romaji": "kenkyuu",
    "en": "research",
    "bn": "গবেষণা",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v277",
    "kana": "けんきゅうしつ",
    "kanji": "研究室",
    "romaji": "kenkyuushitsu",
    "en": "laboratory/study room",
    "bn": "গবেষণাগার",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v278",
    "kana": "けんぶつ",
    "kanji": "見物",
    "romaji": "kenbutsu",
    "en": "sightseeing",
    "bn": "দর্শনীয় স্থান দেখা",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v279",
    "kana": "こ",
    "kanji": "子",
    "romaji": "ko",
    "en": "child",
    "bn": "শিশু",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v280",
    "kana": "こう",
    "kanji": null,
    "romaji": "kou",
    "en": "this way/in this manner",
    "bn": "এভাবে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v281",
    "kana": "こうがい",
    "kanji": "郊外",
    "romaji": "kougai",
    "en": "suburbs",
    "bn": "শহরতলি",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v282",
    "kana": "こうぎ",
    "kanji": "講義",
    "romaji": "kougi",
    "en": "lecture",
    "bn": "লেকচার/বক্তৃতা / বক্তব্য",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v283",
    "kana": "こうぎょう",
    "kanji": "工業",
    "romaji": "kougyou",
    "en": "industry",
    "bn": "শিল্প",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v284",
    "kana": "こうこう",
    "kanji": "高校",
    "romaji": "koukou",
    "en": "high school",
    "bn": "উচ্চ বিদ্যালয়",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v285",
    "kana": "こうむいん",
    "kanji": "公務員",
    "romaji": "koumuin",
    "en": "government worker",
    "bn": "সরকারি চাকুরিজীবী",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v286",
    "kana": "こくさい",
    "kanji": "国際",
    "romaji": "kokusai",
    "en": "international",
    "bn": "আন্তর্জাতিক",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v288",
    "kana": "こし",
    "kanji": "腰",
    "romaji": "koshi",
    "en": "waist/lower back / waist / hips",
    "bn": "কোমর",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v289",
    "kana": "こしょう",
    "kanji": "故障",
    "romaji": "koshou",
    "en": "breakdown/fault",
    "bn": "ত্রুটি/নষ্ট হওয়া",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v290",
    "kana": "ごじゅうおん",
    "kanji": "五十音",
    "romaji": "gojuuon",
    "en": "Japanese syllabary",
    "bn": "জাপানি বর্ণমালা",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v291",
    "kana": "こたえ",
    "kanji": "答え",
    "romaji": "kotae",
    "en": "answer/response / answer / response",
    "bn": "উত্তর",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v292",
    "kana": "ごちそう",
    "kanji": "御馳走",
    "romaji": "gochisou",
    "en": "feast/treat",
    "bn": "ভোজ",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v293",
    "kana": "こと",
    "kanji": "事",
    "romaji": "koto",
    "en": "thing/matter",
    "bn": "বিষয়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v296",
    "kana": "このあいだ",
    "kanji": "この間",
    "romaji": "kono aida",
    "en": "the other day/recently",
    "bn": "কিছুদিন আগে",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v297",
    "kana": "このごろ",
    "kanji": "この頃",
    "romaji": "kono goro",
    "en": "these days/recently",
    "bn": "আজকাল",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v298",
    "kana": "こまかい",
    "kanji": "細かい",
    "romaji": "komakai",
    "en": "fine/small/detailed",
    "bn": "সূক্ষ্ম/বিস্তারিত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v300",
    "kana": "こむ",
    "kanji": "込む",
    "romaji": "komu",
    "en": "to be crowded",
    "bn": "ভিড় হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v301",
    "kana": "こめ",
    "kanji": "米",
    "romaji": "kome",
    "en": "uncooked rice",
    "bn": "চাল",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v302",
    "kana": "ごらんになる",
    "kanji": "ご覧になる",
    "romaji": "goran ni naru",
    "en": "to see (honorific)",
    "bn": "দেখা (সম্মানসূচক)",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v303",
    "kana": "これから",
    "kanji": null,
    "romaji": "korekara",
    "en": "from now on",
    "bn": "এখন থেকে",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v304",
    "kana": "こわい",
    "kanji": "怖い",
    "romaji": "kowai",
    "en": "scary/frightening",
    "bn": "ভয়ঙ্কর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v305",
    "kana": "こわす",
    "kanji": "壊す",
    "romaji": "kowasu",
    "en": "to break something",
    "bn": "ভাঙ্গা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v306",
    "kana": "こわれる",
    "kanji": "壊れる",
    "romaji": "kowareru",
    "en": "to be broken",
    "bn": "ভেঙ্গে যাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v307",
    "kana": "こんかい",
    "kanji": "今回",
    "romaji": "konkai",
    "en": "this time",
    "bn": "এইবার",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v308",
    "kana": "こんご",
    "kanji": "今後",
    "romaji": "kongo",
    "en": "from now on/hereafter",
    "bn": "ভবিষ্যতে",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v309",
    "kana": "こんざつ",
    "kanji": "混雑",
    "romaji": "konzatsu",
    "en": "congestion/crowding",
    "bn": "ভিড়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v311",
    "kana": "こんや",
    "kanji": "今夜",
    "romaji": "konya",
    "en": "tonight",
    "bn": "আজ রাত",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v312",
    "kana": "さいあく",
    "kanji": "最悪",
    "romaji": "saiaku",
    "en": "worst",
    "bn": "সবচেয়ে খারাপ",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v313",
    "kana": "さいきん",
    "kanji": "最近",
    "romaji": "saikin",
    "en": "recently",
    "bn": "সম্প্রতি",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v314",
    "kana": "さいご",
    "kanji": "最後",
    "romaji": "saigo",
    "en": "last/end",
    "bn": "শেষ",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v315",
    "kana": "さいしょ",
    "kanji": "最初",
    "romaji": "saisho",
    "en": "beginning/first",
    "bn": "শুরু/প্রথম",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v316",
    "kana": "さか",
    "kanji": "坂",
    "romaji": "saka",
    "en": "slope/hill",
    "bn": "ঢাল",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v318",
    "kana": "さがる",
    "kanji": "下がる",
    "romaji": "sagaru",
    "en": "to go down/drop",
    "bn": "কমে যাওয়া/নামা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v319",
    "kana": "さかん",
    "kanji": "盛ん",
    "romaji": "sakan",
    "en": "popular/prosperous",
    "bn": "জনপ্রিয়/সমৃদ্ধ",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v320",
    "kana": "さげる",
    "kanji": "下げる",
    "romaji": "sageru",
    "en": "to lower/hang",
    "bn": "নামানো/ঝোলানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v321",
    "kana": "さしあげる",
    "kanji": "差し上げる",
    "romaji": "sashiageru",
    "en": "to give (polite)",
    "bn": "দেওয়া (বিনম্র)",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v322",
    "kana": "さっき",
    "kanji": null,
    "romaji": "sakki",
    "en": "a short while ago",
    "bn": "কিছুক্ষণ আগে",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v323",
    "kana": "さみしい",
    "kanji": "寂しい",
    "romaji": "samishii",
    "en": "lonely",
    "bn": "একাকী",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v324",
    "kana": "さらいげつ",
    "kanji": "再来月",
    "romaji": "saraigetsu",
    "en": "month after next",
    "bn": "আগামী মাসের পরের মাস",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v325",
    "kana": "さらいねん",
    "kanji": "再来年",
    "romaji": "sarainen",
    "en": "year after next",
    "bn": "আগামী বছরের পরের বছর",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v326",
    "kana": "さわぐ",
    "kanji": "騒ぐ",
    "romaji": "sawagu",
    "en": "to make noise",
    "bn": "গোলমাল করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v327",
    "kana": "さわる",
    "kanji": "触る",
    "romaji": "sawaru",
    "en": "to touch",
    "bn": "স্পর্শ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v328",
    "kana": "さんせい",
    "kanji": "賛成",
    "romaji": "sansei",
    "en": "agreement/approval",
    "bn": "সম্মত হওয়া",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v329",
    "kana": "し",
    "kanji": "市",
    "romaji": "si",
    "en": "city",
    "bn": "শহর",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v330",
    "kana": "しあい",
    "kanji": "試合",
    "romaji": "shiai",
    "en": "match/game",
    "bn": "খেলা/ম্যাচ",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v331",
    "kana": "しかた",
    "kanji": "仕方",
    "romaji": "shikata",
    "en": "way/method",
    "bn": "উপায়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v332",
    "kana": "しっかり",
    "kanji": null,
    "romaji": "shikkari",
    "en": "firmly/properly",
    "bn": "দৃঢ়ভাবে/সঠিকভাবে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v333",
    "kana": "しけん",
    "kanji": "試験",
    "romaji": "shiken",
    "en": "examination",
    "bn": "পরীক্ষা",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v335",
    "kana": "しつれい",
    "kanji": "失礼",
    "romaji": "shitsurei",
    "en": "rude/excuse me",
    "bn": "অসভ্যতা/মাফ করবেন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v337",
    "kana": "じどうしゃ",
    "kanji": "自動車",
    "romaji": "jidousha",
    "en": "automobile/car",
    "bn": "গাড়ি",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v338",
    "kana": "しなもの",
    "kanji": "品物",
    "romaji": "shinamono",
    "en": "goods/article",
    "bn": "পণ্য",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v339",
    "kana": "しばらく",
    "kanji": null,
    "romaji": "shibaraku",
    "en": "a little while",
    "bn": "কিছুক্ষণ",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v340",
    "kana": "しま",
    "kanji": "島",
    "romaji": "shima",
    "en": "island",
    "bn": "দ্বীপ",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v341",
    "kana": "じむしょ",
    "kanji": "事務所",
    "romaji": "jimusho",
    "en": "office",
    "bn": "অফিস",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v342",
    "kana": "しゃかい",
    "kanji": "社会",
    "romaji": "shakai",
    "en": "society",
    "bn": "সমাজ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v343",
    "kana": "しゃちょう",
    "kanji": "社長",
    "romaji": "shachou",
    "en": "company president",
    "bn": "কোম্পানি প্রেসিডেন্ট",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v344",
    "kana": "じゃま",
    "kanji": "邪魔",
    "romaji": "jama",
    "en": "hindrance/intrusion",
    "bn": "বিরক্তি/বাধা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v345",
    "kana": "じゆう",
    "kanji": "自由",
    "romaji": "jiyuu",
    "en": "freedom",
    "bn": "স্বাধীনতা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v346",
    "kana": "しゅうかん",
    "kanji": "習慣",
    "romaji": "shuukan",
    "en": "custom/habit",
    "bn": "অভ্যাস/রীতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v347",
    "kana": "じゅうしょ",
    "kanji": "住所",
    "romaji": "juusho",
    "en": "address",
    "bn": "ঠিকানা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v348",
    "kana": "じゅうぶん",
    "kanji": "十分",
    "romaji": "juubun",
    "en": "enough/sufficient",
    "bn": "পর্যাপ্ত",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v349",
    "kana": "しゅっせき",
    "kanji": "出席",
    "romaji": "shusseki",
    "en": "attendance",
    "bn": "উপস্থিতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v350",
    "kana": "しゅっぱつ",
    "kanji": "出発",
    "romaji": "shuppatsu",
    "en": "departure",
    "bn": "প্রস্থান",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v352",
    "kana": "しょうかい",
    "kanji": "紹介",
    "romaji": "shoukai",
    "en": "introduction",
    "bn": "পরিচয়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v353",
    "kana": "しょうがつ",
    "kanji": "正月",
    "romaji": "shougatsu",
    "en": "New Year",
    "bn": "নতুন বছর",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v354",
    "kana": "しょうせつ",
    "kanji": "小説",
    "romaji": "shousetsu",
    "en": "novel",
    "bn": "উপন্যাস",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v355",
    "kana": "しょうたい",
    "kanji": "招待",
    "romaji": "shoutai",
    "en": "invitation",
    "bn": "আমন্ত্রণ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v356",
    "kana": "しょうち",
    "kanji": "承知",
    "romaji": "shouchi",
    "en": "knowledge/consent",
    "bn": "সম্মতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v357",
    "kana": "しょうらい",
    "kanji": "将来",
    "romaji": "shourai",
    "en": "future",
    "bn": "ভবিষ্যৎ",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v358",
    "kana": "しょくじ",
    "kanji": "食事",
    "romaji": "shokuji",
    "en": "meal",
    "bn": "খাবার",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v359",
    "kana": "しらない",
    "kanji": "知らない",
    "romaji": "shiranai",
    "en": "not know",
    "bn": "না জানা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v360",
    "kana": "しらべる",
    "kanji": "調べる",
    "romaji": "shiraberu",
    "en": "to investigate/check",
    "bn": "তদন্ত করা/চেক করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v361",
    "kana": "じんこう",
    "kanji": "人口",
    "romaji": "jinkou",
    "en": "population",
    "bn": "জনসংখ্যা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v362",
    "kana": "じんじゃ",
    "kanji": "神社",
    "romaji": "jinja",
    "en": "Shinto shrine",
    "bn": "শিন্টো উপাসনালয়",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v363",
    "kana": "しんせつ",
    "kanji": "親切",
    "romaji": "shinsetsu",
    "en": "kindness",
    "bn": "দয়া",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v364",
    "kana": "しんぱい",
    "kanji": "心配",
    "romaji": "shinpai",
    "en": "worry/anxiety",
    "bn": "চিন্তা/দুশ্চিন্তা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v365",
    "kana": "しんぶん",
    "kanji": "新聞",
    "romaji": "shinbun",
    "en": "newspaper",
    "bn": "সংবাদপত্র",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v366",
    "kana": "すいもじ",
    "kanji": "水文字",
    "romaji": "suimoji",
    "en": "water writing",
    "bn": "জললিপি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v367",
    "kana": "ずいぶん",
    "kanji": null,
    "romaji": "zuibun",
    "en": "extremely/considerably",
    "bn": "অত্যন্ত/অনেকটা",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v368",
    "kana": "すう",
    "kanji": "吸う",
    "romaji": "suu",
    "en": "to smoke/inhale",
    "bn": "ধূমপান করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v369",
    "kana": "スカート",
    "kanji": null,
    "romaji": "sukaato",
    "en": "skirt",
    "bn": "স্কার্ট",
    "category": "clothing",
    "level": "N4"
  },
  {
    "id": "n4v370",
    "kana": "ずが",
    "kanji": "図画",
    "romaji": "zuga",
    "en": "drawing",
    "bn": "অঙ্কন",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v373",
    "kana": "すごい",
    "kanji": null,
    "romaji": "sugoi",
    "en": "amazing/terrible",
    "bn": "চমৎকার/ভয়াবহ",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v376",
    "kana": "ずっと",
    "kanji": null,
    "romaji": "zutto",
    "en": "the whole time/much more",
    "bn": "পুরোটা সময়/অনেক বেশি",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v377",
    "kana": "すてる",
    "kanji": "捨てる",
    "romaji": "suteru",
    "en": "to throw away",
    "bn": "ফেলে দেওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v378",
    "kana": "すな",
    "kanji": "砂",
    "romaji": "suna",
    "en": "sand",
    "bn": "বালু",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v379",
    "kana": "すばらしい",
    "kanji": "素晴らしい",
    "romaji": "subarashii",
    "en": "wonderful/splendid",
    "bn": "চমৎকার",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v380",
    "kana": "すべる",
    "kanji": "滑る",
    "romaji": "suberu",
    "en": "to slide/slip",
    "bn": "পিছলানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v381",
    "kana": "すべて",
    "kanji": null,
    "romaji": "subete",
    "en": "all/entirety",
    "bn": "সব/সম্পূর্ণ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v382",
    "kana": "すみ",
    "kanji": "隅",
    "romaji": "sumi",
    "en": "corner/nook",
    "bn": "কোণ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v383",
    "kana": "すむ",
    "kanji": "済む",
    "romaji": "sumu",
    "en": "to finish/end",
    "bn": "শেষ হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v384",
    "kana": "すり",
    "kanji": null,
    "romaji": "suri",
    "en": "pickpocket",
    "bn": "পকেটমার",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v385",
    "kana": "すると",
    "kanji": null,
    "romaji": "suruto",
    "en": "then/thereupon",
    "bn": "তারপর",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v387",
    "kana": "せいさん",
    "kanji": "生産",
    "romaji": "seisan",
    "en": "production",
    "bn": "উৎপাদন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v391",
    "kana": "せなか",
    "kanji": "背中",
    "romaji": "senaka",
    "en": "back (of body)",
    "bn": "পিঠ",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v392",
    "kana": "ぜひ",
    "kanji": null,
    "romaji": "zehi",
    "en": "by all means",
    "bn": "অবশ্যই",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v393",
    "kana": "せわ",
    "kanji": "世話",
    "romaji": "sewa",
    "en": "care/help",
    "bn": "যত্ন/সহায়তা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v395",
    "kana": "せんもん",
    "kanji": "専門",
    "romaji": "senmon",
    "en": "specialty",
    "bn": "বিশেষজ্ঞতা",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v398",
    "kana": "そうだん",
    "kanji": "相談",
    "romaji": "soudan",
    "en": "consultation",
    "bn": "পরামর্শ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v399",
    "kana": "そだてる",
    "kanji": "育てる",
    "romaji": "sodateru",
    "en": "to rear/bring up",
    "bn": "লালন-পালন করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v400",
    "kana": "そつぎょう",
    "kanji": "卒業",
    "romaji": "sotsugyou",
    "en": "graduation",
    "bn": "স্নাতক",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v401",
    "kana": "そふ",
    "kanji": "祖父",
    "romaji": "sofu",
    "en": "grandfather (own)",
    "bn": "দাদা/নানা",
    "category": "family",
    "level": "N4"
  },
  {
    "id": "n4v402",
    "kana": "そぼ",
    "kanji": "祖母",
    "romaji": "sobo",
    "en": "grandmother (own)",
    "bn": "দাদী/নানী",
    "category": "family",
    "level": "N4"
  },
  {
    "id": "n4v403",
    "kana": "それで",
    "kanji": null,
    "romaji": "sorede",
    "en": "and then/therefore",
    "bn": "তারপর/তাই",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v404",
    "kana": "それに",
    "kanji": null,
    "romaji": "sore ni",
    "en": "besides/moreover",
    "bn": "তাছাড়া",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v405",
    "kana": "それほど",
    "kanji": null,
    "romaji": "sore hodo",
    "en": "to that extent",
    "bn": "সেই পর্যন্ত",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v406",
    "kana": "そろそろ",
    "kanji": null,
    "romaji": "sorosoro",
    "en": "gradually/soon",
    "bn": "ধীরে ধীরে/শীঘ্রই",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v407",
    "kana": "そんな",
    "kanji": null,
    "romaji": "sonna",
    "en": "that sort of",
    "bn": "সেই ধরণের",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v408",
    "kana": "たいいん",
    "kanji": "退院",
    "romaji": "taiin",
    "en": "leaving hospital",
    "bn": "হাসপাতাল ছাড়া",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v410",
    "kana": "だいたい",
    "kanji": "大体",
    "romaji": "daitai",
    "en": "generally/mostly",
    "bn": "সাধারণত",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v411",
    "kana": "たいてい",
    "kanji": "大抵",
    "romaji": "taitei",
    "en": "usually",
    "bn": "সাধারণত",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v412",
    "kana": "だいとうりょう",
    "kanji": "大統領",
    "romaji": "daitouryou",
    "en": "president",
    "bn": "রাষ্ট্রপতি",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v413",
    "kana": "だいぶ",
    "kanji": "大分",
    "romaji": "daibu",
    "en": "considerably/greatly",
    "bn": "যথেষ্ট",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v414",
    "kana": "だいぶつ",
    "kanji": "大仏",
    "romaji": "daibutsu",
    "en": "giant Buddha statue",
    "bn": "বিশাল বুদ্ধ মূর্তি",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v415",
    "kana": "たいぼく",
    "kanji": "大木",
    "romaji": "taiboku",
    "en": "large tree",
    "bn": "বড় গাছ",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v416",
    "kana": "だいめい",
    "kanji": "題名",
    "romaji": "daimei",
    "en": "title/name",
    "bn": "শিরোনাম",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v417",
    "kana": "だいめいし",
    "kanji": "代名詞",
    "romaji": "daimeishi",
    "en": "pronoun",
    "bn": "সর্বনাম",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v418",
    "kana": "ダイヤ",
    "kanji": null,
    "romaji": "daiya",
    "en": "diamond",
    "bn": "হীরা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v419",
    "kana": "ダイヤモンド",
    "kanji": null,
    "romaji": "daiyamondo",
    "en": "diamond",
    "bn": "হীরক",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v420",
    "kana": "タイや",
    "kanji": "タイヤ",
    "romaji": "taiya",
    "en": "tire/tyre",
    "bn": "টায়ার",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v421",
    "kana": "たおれる",
    "kanji": "倒れる",
    "romaji": "taoreru",
    "en": "to fall/collapse",
    "bn": "পড়ে যাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v422",
    "kana": "たからくじ",
    "kanji": "宝くじ",
    "romaji": "takarakuji",
    "en": "lottery",
    "bn": "লটারি",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v423",
    "kana": "だから",
    "kanji": null,
    "romaji": "dakara",
    "en": "therefore/so",
    "bn": "তাই/সুতরাং",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v424",
    "kana": "たしか",
    "kanji": "確か",
    "romaji": "tashika",
    "en": "certain/sure",
    "bn": "নিশ্চিত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v425",
    "kana": "だす",
    "kanji": "出す",
    "romaji": "dasu",
    "en": "to put out",
    "bn": "বের করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v426",
    "kana": "たすかる",
    "kanji": "助かる",
    "romaji": "tasukaru",
    "en": "to be saved/helped",
    "bn": "বেঁচে যাওয়া/সাহায্য পাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v427",
    "kana": "たすける",
    "kanji": "助ける",
    "romaji": "tasukeru",
    "en": "to save/help",
    "bn": "বাঁচানো/সাহায্য করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v428",
    "kana": "たたかう",
    "kanji": "戦う",
    "romaji": "tatakau",
    "en": "to fight/struggle",
    "bn": "যুদ্ধ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v429",
    "kana": "たたむ",
    "kanji": "畳む",
    "romaji": "tatamu",
    "en": "to fold",
    "bn": "ভাঁজ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v430",
    "kana": "たたす",
    "kanji": "立たす",
    "romaji": "tatasu",
    "en": "to make someone stand",
    "bn": "কাউকে দাঁড় করানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v431",
    "kana": "だたしい",
    "kanji": "正しい",
    "romaji": "tadashii",
    "en": "correct/right",
    "bn": "সঠিক",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v432",
    "kana": "たたみ",
    "kanji": "畳",
    "romaji": "tatami",
    "en": "tatami mat",
    "bn": "তাতামি ম্যাট",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v433",
    "kana": "たてる",
    "kanji": "建てる",
    "romaji": "tateru",
    "en": "to build/erect",
    "bn": "নির্মাণ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v434",
    "kana": "たてる",
    "kanji": "立てる",
    "romaji": "tateru",
    "en": "to stand something up",
    "bn": "দাঁড় করানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v435",
    "kana": "たとえば",
    "kanji": "例えば",
    "romaji": "tatoeba",
    "en": "for example",
    "bn": "উদাহরণস্বরূপ",
    "category": "expressions",
    "level": "N4"
  },
  {
    "id": "n4v436",
    "kana": "たな",
    "kanji": "棚",
    "romaji": "tana",
    "en": "shelf",
    "bn": "শেলফ/আলমারি",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v437",
    "kana": "たのしむ",
    "kanji": "楽しむ",
    "romaji": "tanoshimu",
    "en": "to enjoy",
    "bn": "উপভোগ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v438",
    "kana": "たのみ",
    "kanji": "頼み",
    "romaji": "tanomi",
    "en": "request/favor",
    "bn": "অনুরোধ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v439",
    "kana": "たばこ",
    "kanji": "煙草",
    "romaji": "tabako",
    "en": "tobacco/cigarette",
    "bn": "তামাক/সিগারেট",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v440",
    "kana": "たぶん",
    "kanji": "多分",
    "romaji": "tabun",
    "en": "perhaps/probably",
    "bn": "সম্ভবত",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v441",
    "kana": "たま",
    "kanji": "玉",
    "romaji": "tama",
    "en": "ball/sphere",
    "bn": "বল",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v442",
    "kana": "たま",
    "kanji": "弾",
    "romaji": "tama",
    "en": "bullet/shot",
    "bn": "বুলেট",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v443",
    "kana": "たまご",
    "kanji": "卵",
    "romaji": "tamago",
    "en": "egg",
    "bn": "ডিম",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v444",
    "kana": "たまに",
    "kanji": null,
    "romaji": "tamani",
    "en": "occasionally/seldom",
    "bn": "মাঝেমধ্যে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v445",
    "kana": "だり",
    "kanji": "足り",
    "romaji": "tari",
    "en": "sufficiency",
    "bn": "পর্যাপ্ততা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v446",
    "kana": "だる",
    "kanji": "足る",
    "romaji": "taru",
    "en": "to be enough",
    "bn": "পর্যাপ্ত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v447",
    "kana": "たんじょうび",
    "kanji": "誕生日",
    "romaji": "tanjoubi",
    "en": "birthday",
    "bn": "জন্মদিন",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v448",
    "kana": "だんせい",
    "kanji": "男性",
    "romaji": "dansei",
    "en": "male/man",
    "bn": "পুরুষ",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v449",
    "kana": "たんたい",
    "kanji": "団体",
    "romaji": "tantai",
    "en": "organization/group",
    "bn": "সংস্থা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v450",
    "kana": "だんぼう",
    "kanji": "暖房",
    "romaji": "danbou",
    "en": "heating",
    "bn": "হিটিং",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v451",
    "kana": "ち",
    "kanji": "血",
    "romaji": "chi",
    "en": "blood",
    "bn": "রক্ত",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v452",
    "kana": "チェック",
    "kanji": null,
    "romaji": "chekku",
    "en": "check",
    "bn": "চেক",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v453",
    "kana": "ちから",
    "kanji": "力",
    "romaji": "chikara",
    "en": "force/power",
    "bn": "শক্তি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v454",
    "kana": "ちきゅう",
    "kanji": "地球",
    "romaji": "chikyuu",
    "en": "the earth",
    "bn": "পৃথিবী",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v455",
    "kana": "ちこく",
    "kanji": "遅刻",
    "romaji": "chikoku",
    "en": "lateness",
    "bn": "দেরি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v456",
    "kana": "ちしゃ",
    "kanji": "知者",
    "romaji": "chisha",
    "en": "wise man",
    "bn": "জ্ঞানী ব্যক্তি",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v457",
    "kana": "ちず",
    "kanji": "地図",
    "romaji": "chizu",
    "en": "map",
    "bn": "মানচিত্র",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v458",
    "kana": "ちゃ",
    "kanji": "茶",
    "romaji": "cha",
    "en": "tea",
    "bn": "চা",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v459",
    "kana": "ちゃいろい",
    "kanji": "茶色い",
    "romaji": "chairoi",
    "en": "brown",
    "bn": "বাদামী",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v460",
    "kana": "ちゃわん",
    "kanji": "茶碗",
    "romaji": "chawan",
    "en": "rice bowl",
    "bn": "চায়ের বাটি",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v461",
    "kana": "～ちゅう",
    "kanji": "～中",
    "romaji": "-chuu",
    "en": "during/under/in",
    "bn": "চলমান/মধ্যে",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v462",
    "kana": "ちゅうい",
    "kanji": "注意",
    "romaji": "chuui",
    "en": "caution/attention",
    "bn": "সতর্কতা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v463",
    "kana": "ちゅうがっこう",
    "kanji": "中学校",
    "romaji": "chuugakkou",
    "en": "junior high school",
    "bn": "জুনিয়র হাই স্কুল",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v464",
    "kana": "ちゅうしゃ",
    "kanji": "注射",
    "romaji": "chuusha",
    "en": "injection",
    "bn": "ইনজেকশন",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v465",
    "kana": "ちゅうしゃじょう",
    "kanji": "駐車場",
    "romaji": "chuushajou",
    "en": "parking lot",
    "bn": "পার্কিং লট",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v466",
    "kana": "ちりん",
    "kanji": "地理",
    "romaji": "chiri",
    "en": "geography",
    "bn": "ভুগোল",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v467",
    "kana": "ちりとり",
    "kanji": null,
    "romaji": "chiritori",
    "en": "dustpan",
    "bn": "ডাস্টপ্যান",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4:100",
    "kana": "つかまえる",
    "kanji": "捕まえる",
    "romaji": "tsukamaeru",
    "en": "to catch",
    "bn": "ধরা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v469",
    "kana": "つかまる",
    "kanji": "捕まる",
    "romaji": "tsukamaru",
    "en": "to be caught",
    "bn": "ধরা পড়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v470",
    "kana": "つかう",
    "kanji": "使う",
    "romaji": "tsukau",
    "en": "to use",
    "bn": "ব্যবহার করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v471",
    "kana": "つかれる",
    "kanji": "疲れる",
    "romaji": "tsukareru",
    "en": "to get tired",
    "bn": "ক্লান্ত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v472",
    "kana": "つく",
    "kanji": "点く",
    "romaji": "tsuku",
    "en": "to be lit",
    "bn": "জ্বলা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v473",
    "kana": "つぐ",
    "kanji": "次ぐ",
    "romaji": "tsugu",
    "en": "to follow",
    "bn": "অনুসরণ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v474",
    "kana": "つく",
    "kanji": "付く",
    "romaji": "tsuku",
    "en": "to be attached",
    "bn": "সংযুক্ত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v475",
    "kana": "つく",
    "kanji": "着く",
    "romaji": "tsuku",
    "en": "to arrive at",
    "bn": "পৌঁছানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v476",
    "kana": "つくえ",
    "kanji": "机",
    "romaji": "tsukue",
    "en": "desk/table",
    "bn": "টেবিল",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v477",
    "kana": "つくる",
    "kanji": "作る",
    "romaji": "tsukuru",
    "en": "to make/create",
    "bn": "তৈরি করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v478",
    "kana": "つける",
    "kanji": "点ける",
    "romaji": "tsukeru",
    "en": "to turn on",
    "bn": "চালানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v479",
    "kana": "つける",
    "kanji": "付ける",
    "romaji": "tsukeru",
    "en": "to attach",
    "bn": "সংযুক্ত করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v480",
    "kana": "つける",
    "kanji": "漬ける",
    "romaji": "tsukeru",
    "en": "to pickle/soak",
    "bn": "ভেজানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v481",
    "kana": "つたえる",
    "kanji": "伝える",
    "romaji": "tsutaeru",
    "en": "to convey/report",
    "bn": "জানানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v482",
    "kana": "つづく",
    "kanji": "続く",
    "romaji": "tsuduku",
    "en": "to continue",
    "bn": "চালিয়ে যাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v483",
    "kana": "つづける",
    "kanji": "続ける",
    "romaji": "tsudukeru",
    "en": "to keep up/continue",
    "bn": "অব্যাহত রাখা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v484",
    "kana": "つつむ",
    "kanji": "包む",
    "romaji": "tsutsumu",
    "en": "to wrap",
    "bn": "মোড়ানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v485",
    "kana": "つとめる",
    "kanji": "勤める",
    "romaji": "tsutomeru",
    "en": "to work for someone",
    "bn": "চাকরি করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v486",
    "kana": "つなぐ",
    "kanji": "繋ぐ",
    "romaji": "tsunagu",
    "en": "to connect",
    "bn": "সংযুক্ত করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v487",
    "kana": "つなみ",
    "kanji": "津波",
    "romaji": "tsunami",
    "en": "tsunami",
    "bn": "সুনামি",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v488",
    "kana": "つねに",
    "kanji": "常に",
    "romaji": "tsuneni",
    "en": "always",
    "bn": "সবসময়",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v489",
    "kana": "つばさ",
    "kanji": "翼",
    "romaji": "tsubasa",
    "en": "wings",
    "bn": "ডানা",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v490",
    "kana": "つま",
    "kanji": "妻",
    "romaji": "tsuma",
    "en": "wife (my own)",
    "bn": "স্ত্রী",
    "category": "family",
    "level": "N4"
  },
  {
    "id": "n4v491",
    "kana": "つまらない",
    "kanji": null,
    "romaji": "tsumaranai",
    "en": "boring",
    "bn": "বিরক্তিকর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v492",
    "kana": "つめ",
    "kanji": "爪",
    "romaji": "tsume",
    "en": "nail/claw",
    "bn": "নখ",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v493",
    "kana": "つめたい",
    "kanji": "冷たい",
    "romaji": "tsumetai",
    "en": "cold (to touch)",
    "bn": "ঠান্ডা",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v494",
    "kana": "つまる",
    "kanji": "詰まる",
    "romaji": "tsumaru",
    "en": "to be blocked",
    "bn": "আটকে যাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v495",
    "kana": "つめきり",
    "kanji": "爪切り",
    "romaji": "tsumekiri",
    "en": "nail clippers",
    "bn": "নেইল কাটার",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v496",
    "kana": "つもる",
    "kanji": "積もる",
    "romaji": "tsumoru",
    "en": "to pile up",
    "bn": "জমা হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v497",
    "kana": "つよい",
    "kanji": "強い",
    "romaji": "tsuyoi",
    "en": "strong",
    "bn": "শক্তিশালী",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v498",
    "kana": "つらなる",
    "kanji": "連なる",
    "romaji": "tsuranaru",
    "en": "to be in a row",
    "bn": "সারিবদ্ধ হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v499",
    "kana": "つり",
    "kanji": "釣り",
    "romaji": "tsuri",
    "en": "fishing",
    "bn": "মাছ ধরা",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v500",
    "kana": "つる",
    "kanji": "釣る",
    "romaji": "tsuru",
    "en": "to fish",
    "bn": "মাছ শিকার করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v501",
    "kana": "つれる",
    "kanji": "連れる",
    "romaji": "tsureru",
    "en": "to lead/take with",
    "bn": "সাথে নেওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v502",
    "kana": "ていねい",
    "kanji": "丁寧",
    "romaji": "teinei",
    "en": "polite/courteous",
    "bn": "বিনম্র",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v503",
    "kana": "テキスト",
    "kanji": null,
    "romaji": "tekisuto",
    "en": "textbook",
    "bn": "পাঠ্যবই",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v504",
    "kana": "できれば",
    "kanji": null,
    "romaji": "dekireba",
    "en": "if possible",
    "bn": "যদি সম্ভব হয়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v505",
    "kana": "てきとう",
    "kanji": "適当",
    "romaji": "tekitou",
    "en": "suitable",
    "bn": "উপযুক্ত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v506",
    "kana": "できるだけ",
    "kanji": null,
    "romaji": "dekirudake",
    "en": "as much as possible",
    "bn": "যতটা সম্ভব",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v507",
    "kana": "てつだう",
    "kanji": "手伝う",
    "romaji": "tetsudau",
    "en": "to help/assist",
    "bn": "সাহায্য করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v508",
    "kana": "てつどう",
    "kanji": "鉄道",
    "romaji": "tetsudou",
    "en": "railroad",
    "bn": "রেলপথ",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v509",
    "kana": "テニス",
    "kanji": null,
    "romaji": "tenisu",
    "en": "tennis",
    "bn": "টেনিস",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v510",
    "kana": "てぶくろ",
    "kanji": "手袋",
    "romaji": "tebukuro",
    "en": "gloves",
    "bn": "হাতমোজা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v511",
    "kana": "でも",
    "kanji": null,
    "romaji": "demo",
    "en": "but/however",
    "bn": "কিন্তু",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v512",
    "kana": "てら",
    "kanji": "寺",
    "romaji": "tera",
    "en": "temple",
    "bn": "মন্দির",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v514",
    "kana": "てんいん",
    "kanji": "店員",
    "romaji": "tenin",
    "en": "clerk/shop assistant",
    "bn": "দোকানদার",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v515",
    "kana": "てんきよほう",
    "kanji": "天気予報",
    "romaji": "tenki yohou",
    "en": "weather forecast",
    "bn": "আবহাওয়ার পূর্বাভাস",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v516",
    "kana": "でんとう",
    "kanji": "電灯",
    "romaji": "dentou",
    "en": "electric light",
    "bn": "বৈদ্যুতিক আলো",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v517",
    "kana": "でんぽう",
    "kanji": "電報",
    "romaji": "denpou",
    "en": "telegram",
    "bn": "টেলিগ্রাম",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v518",
    "kana": "てんらんかい",
    "kanji": "展覧会",
    "romaji": "tenrankai",
    "en": "exhibition",
    "bn": "প্রদর্শনী",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v519",
    "kana": "とい",
    "kanji": "問い",
    "romaji": "toi",
    "en": "question/inquiry",
    "bn": "প্রশ্ন",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v520",
    "kana": "どう",
    "kanji": null,
    "romaji": "dou",
    "en": "how/in what way",
    "bn": "কিভাবে",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v521",
    "kana": "とう",
    "kanji": "等",
    "romaji": "tou",
    "en": "etcetera/class",
    "bn": "ইত্যাদি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v522",
    "kana": "どういたしまして",
    "kanji": null,
    "romaji": "douitashimashite",
    "en": "you are welcome",
    "bn": "আপনাকে স্বাগতম",
    "category": "expressions",
    "level": "N4"
  },
  {
    "id": "n4v523",
    "kana": "とうきょう",
    "kanji": "東京",
    "romaji": "toukyou",
    "en": "Tokyo",
    "bn": "টোকিও",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v524",
    "kana": "どうぐ",
    "kanji": "道具",
    "romaji": "dougu",
    "en": "tool/implement",
    "bn": "সরঞ্জাম",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v525",
    "kana": "とうとう",
    "kanji": null,
    "romaji": "toutou",
    "en": "finally",
    "bn": "অবশেষে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v526",
    "kana": "どうぶつえん",
    "kanji": "動物園",
    "romaji": "doubutsuen",
    "en": "zoo",
    "bn": "চিড়িয়াখানা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v527",
    "kana": "とおく",
    "kanji": "遠く",
    "romaji": "tooku",
    "en": "distant/far away",
    "bn": "দূরে",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v528",
    "kana": "どおる",
    "kanji": "通る",
    "romaji": "tooru",
    "en": "to pass/go through",
    "bn": "অতিক্রম করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v530",
    "kana": "とく",
    "kanji": "解く",
    "romaji": "toku",
    "en": "to solve/untie",
    "bn": "সমাধান করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v531",
    "kana": "とくに",
    "kanji": "特に",
    "romaji": "tokuni",
    "en": "especially",
    "bn": "বিশেষ করে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v532",
    "kana": "とくべつ",
    "kanji": "特別",
    "romaji": "tokubetsu",
    "en": "special",
    "bn": "বিশেষ",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v533",
    "kana": "とこや",
    "kanji": "床屋",
    "romaji": "tokoya",
    "en": "barbershop",
    "bn": "নাপিতের দোকান",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v534",
    "kana": "とじ",
    "kanji": "閉じ",
    "romaji": "toji",
    "en": "closing",
    "bn": "বন্ধ করা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v535",
    "kana": "とじる",
    "kanji": "閉じる",
    "romaji": "tojiru",
    "en": "to close",
    "bn": "বন্ধ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v536",
    "kana": "とっきゅう",
    "kanji": "特急",
    "romaji": "tokkyuu",
    "en": "limited express",
    "bn": "লিমিটেড এক্সপ্রেস",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v537",
    "kana": "とどける",
    "kanji": "届ける",
    "romaji": "todokeru",
    "en": "to deliver/reach",
    "bn": "পৌঁছে দেওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v538",
    "kana": "とまる",
    "kanji": "泊まる",
    "romaji": "tomaru",
    "en": "to stay at",
    "bn": "থাকা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v540",
    "kana": "とめる",
    "kanji": "止める",
    "romaji": "tomeru",
    "en": "to stop something",
    "bn": "থামানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v541",
    "kana": "とりかえる",
    "kanji": "取り替える",
    "romaji": "torikaeru",
    "en": "to exchange",
    "bn": "বিনিময় করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v542",
    "kana": "どろぼう",
    "kanji": "泥棒",
    "romaji": "dorobou",
    "en": "thief/robber",
    "bn": "চোর",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v543",
    "kana": "どんどん",
    "kanji": null,
    "romaji": "dondon",
    "en": "rapidly/steadily",
    "bn": "দ্রুতগতিতে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v546",
    "kana": "なおる",
    "kanji": "直る",
    "romaji": "naoru",
    "en": "to be repaired",
    "bn": "মেরামত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v547",
    "kana": "なおる",
    "kanji": "治る",
    "romaji": "naoru",
    "en": "to get well/cure",
    "bn": "সেরে ওঠা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v550",
    "kana": "なかま",
    "kanji": "仲間",
    "romaji": "nakama",
    "en": "partner/group",
    "bn": "সঙ্গী/দল",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v551",
    "kana": "なかむら",
    "kanji": "中村",
    "romaji": "nakamura",
    "en": "Nakamura (name)",
    "bn": "নাকামুরা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v552",
    "kana": "なぐ",
    "kanji": "鳴ぐ",
    "romaji": "nagu",
    "en": "to chirrup/honk",
    "bn": "ডাকা (পাখি)",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v553",
    "kana": "なく",
    "kanji": "無く",
    "romaji": "naku",
    "en": "to lose/be missing",
    "bn": "হারানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v555",
    "kana": "なさる",
    "kanji": "なさる",
    "romaji": "nasaru",
    "en": "to do (honorific)",
    "bn": "করা (সম্মানসূচক)",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v559",
    "kana": "ななひゃく",
    "kanji": "七百",
    "romaji": "nanahyaku",
    "en": "seven hundred",
    "bn": "সাতশত",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v561",
    "kana": "ななひと",
    "kanji": "七人",
    "romaji": "nananin",
    "en": "seven people",
    "bn": "সাত জন",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v562",
    "kana": "ななふん",
    "kanji": "七分",
    "romaji": "nanafun",
    "en": "seven minutes",
    "bn": "সাত মিনিট",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v563",
    "kana": "ななひき",
    "kanji": "七匹",
    "romaji": "nanahiki",
    "en": "seven small animals",
    "bn": "সাতটি (ছোট প্রাণী)",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v564",
    "kana": "ななほん",
    "kanji": "七本",
    "romaji": "nanahon",
    "en": "seven long objects",
    "bn": "সাতটি (লম্বা বস্তু)",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v565",
    "kana": "ななまい",
    "kanji": "七枚",
    "romaji": "nanamai",
    "en": "seven flat objects",
    "bn": "সাতটি (চ্যাপ্টা বস্তু)",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v566",
    "kana": "なに",
    "kanji": "何",
    "romaji": "nani",
    "en": "what",
    "bn": "কি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v569",
    "kana": "なら",
    "kanji": null,
    "romaji": "nara",
    "en": "if so/case",
    "bn": "যদি তাই হয়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v570",
    "kana": "ならい",
    "kanji": "習い",
    "romaji": "narai",
    "en": "learning",
    "bn": "শেখা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v574",
    "kana": "なり",
    "kanji": null,
    "romaji": "nari",
    "en": "becoming",
    "bn": "হওয়া",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v576",
    "kana": "なる",
    "kanji": "鳴る",
    "romaji": "naru",
    "en": "to sound/ring",
    "bn": "বাজা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v577",
    "kana": "なるほど",
    "kanji": null,
    "romaji": "naruhodo",
    "en": "I see/indeed",
    "bn": "তাই তো",
    "category": "expressions",
    "level": "N4"
  },
  {
    "id": "n4v578",
    "kana": "なれる",
    "kanji": "慣れる",
    "romaji": "nareru",
    "en": "to get used to",
    "bn": "অভ্যস্ত হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v579",
    "kana": "なん",
    "kanji": "何",
    "romaji": "nan",
    "en": "what (followed by d, t, n)",
    "bn": "কি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v580",
    "kana": "なんじ",
    "kanji": "何時",
    "romaji": "nanji",
    "en": "what time",
    "bn": "কয়টা",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v581",
    "kana": "なんにん",
    "kanji": "何人",
    "romaji": "nannin",
    "en": "how many people",
    "bn": "কতজন",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v582",
    "kana": "なんようび",
    "kanji": "何曜日",
    "romaji": "nanyoubi",
    "en": "what day of the week",
    "bn": "কি বার",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v584",
    "kana": "にがつ",
    "kanji": "二月",
    "romaji": "nigatsu",
    "en": "February",
    "bn": "ফেব্রুয়ারি",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v589",
    "kana": "にっ",
    "kanji": "日",
    "romaji": "ni",
    "en": "day (counter)",
    "bn": "দিন",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v591",
    "kana": "にじ",
    "kanji": "二時",
    "romaji": "niji",
    "en": "two o'clock",
    "bn": "দুইটা",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v592",
    "kana": "にど",
    "kanji": "二度",
    "romaji": "nido",
    "en": "twice",
    "bn": "দুইবার",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v593",
    "kana": "には",
    "kanji": "庭",
    "romaji": "niwa",
    "en": "garden",
    "bn": "বাগান",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v594",
    "kana": "にはん",
    "kanji": "二版",
    "romaji": "nihan",
    "en": "second edition",
    "bn": "দ্বিতীয় সংস্করণ",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v595",
    "kana": "にばん",
    "kanji": "二番",
    "romaji": "niban",
    "en": "second/number two",
    "bn": "দ্বিতীয়",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v596",
    "kana": "にひゃく",
    "kanji": "二百",
    "romaji": "nihyaku",
    "en": "two hundred",
    "bn": "দুইশত",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v597",
    "kana": "にび",
    "kanji": "二日",
    "romaji": "nibi",
    "en": "two days",
    "bn": "দুই দিন",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v598",
    "kana": "にふん",
    "kanji": "二分",
    "romaji": "nifun",
    "en": "two minutes",
    "bn": "দুই মিনিট",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v599",
    "kana": "にほん",
    "kanji": "日本",
    "romaji": "nihon",
    "en": "Japan",
    "bn": "জাপান",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v600",
    "kana": "にほんご",
    "kanji": "日本語",
    "romaji": "nihongo",
    "en": "Japanese language",
    "bn": "জাপানি ভাষা",
    "category": "education",
    "level": "N4"
  },
  {
    "id": "n4v601",
    "kana": "にほんしゅ",
    "kanji": "日本酒",
    "romaji": "nihonshu",
    "en": "Japanese sake",
    "bn": "জাপানি মদ (সাকে)",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v602",
    "kana": "にもつ",
    "kanji": "荷物",
    "romaji": "nimotsu",
    "en": "luggage/baggage",
    "bn": "মালপত্র/বোঝা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v603",
    "kana": "ニュース",
    "kanji": null,
    "romaji": "nyuusu",
    "en": "news",
    "bn": "খবর",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v605",
    "kana": "にん",
    "kanji": "人",
    "romaji": "nin",
    "en": "person (counter)",
    "bn": "জন",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v606",
    "kana": "にんじん",
    "kanji": null,
    "romaji": "ninjin",
    "en": "carrot",
    "bn": "গাজর",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v610",
    "kana": "ね",
    "kanji": null,
    "romaji": "ne",
    "en": "hey/right? (particle)",
    "bn": "তাই না?",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v611",
    "kana": "ねがい",
    "kanji": "願い",
    "romaji": "negai",
    "en": "request/wish",
    "bn": "অনুরোধ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v614",
    "kana": "ねだん",
    "kanji": "値段",
    "romaji": "nedan",
    "en": "price/cost",
    "bn": "দাম",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v615",
    "kana": "ねつ",
    "kanji": "熱",
    "romaji": "netsu",
    "en": "fever/heat",
    "bn": "জ্বর/তাপ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v616",
    "kana": "ねっしん",
    "kanji": "熱心",
    "romaji": "nesshin",
    "en": "zeal/enthusiasm",
    "bn": "নিষ্ঠা/উৎসাহ",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v617",
    "kana": "ねぼう",
    "kanji": "寝坊",
    "romaji": "nebou",
    "en": "oversleeping",
    "bn": "দেরি করে ঘুমানো",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v618",
    "kana": "ねまる",
    "kanji": "寝まる",
    "romaji": "nemaru",
    "en": "to be asleep",
    "bn": "ঘুমানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v619",
    "kana": "ねむい",
    "kanji": "眠い",
    "romaji": "nemui",
    "en": "sleepy",
    "bn": "ঘুম ঘুম অনুভব",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v620",
    "kana": "ねむる",
    "kanji": "眠る",
    "romaji": "nemuru",
    "en": "to sleep",
    "bn": "ঘুমানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v622",
    "kana": "ねん",
    "kanji": "年",
    "romaji": "nen",
    "en": "year",
    "bn": "বছর",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v623",
    "kana": "ねんまつ",
    "kanji": "年末",
    "romaji": "nenmatsu",
    "en": "end of the year",
    "bn": "বছরের শেষ",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v624",
    "kana": "ねんれい",
    "kanji": "年齢",
    "romaji": "nenrei",
    "en": "age",
    "bn": "বয়স",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v625",
    "kana": "の",
    "kanji": null,
    "romaji": "no",
    "en": "possessive particle",
    "bn": "এর/র",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v626",
    "kana": "のう",
    "kanji": "脳",
    "romaji": "nou",
    "en": "brain",
    "bn": "মস্তিষ্ক",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v627",
    "kana": "のうぎょう",
    "kanji": "農業",
    "romaji": "nougyou",
    "en": "agriculture",
    "bn": "কৃষি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v628",
    "kana": "のうりょく",
    "kanji": "能力",
    "romaji": "nouryoku",
    "en": "ability/skill",
    "bn": "দক্ষতা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v629",
    "kana": "のうりん",
    "kanji": "農林",
    "romaji": "nourin",
    "en": "agriculture and forestry",
    "bn": "কৃষি ও বনজ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v630",
    "kana": "ので",
    "kanji": null,
    "romaji": "node",
    "en": "because/since",
    "bn": "যেহেতু",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v631",
    "kana": "のど",
    "kanji": "喉",
    "romaji": "nodo",
    "en": "throat",
    "bn": "গলা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v632",
    "kana": "のこす",
    "kanji": "残す",
    "romaji": "nokosu",
    "en": "to leave (something)",
    "bn": "রেখে যাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v634",
    "kana": "のせる",
    "kanji": "乗せる",
    "romaji": "noseru",
    "en": "to place/put on",
    "bn": "রাখা/তোলা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v635",
    "kana": "のぞく",
    "kanji": "除く",
    "romaji": "nozoku",
    "en": "to exclude/remove",
    "bn": "বাদ দেওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v636",
    "kana": "のぞむ",
    "kanji": "望む",
    "romaji": "nozomu",
    "en": "to hope/expect",
    "bn": "আশা করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v637",
    "kana": "のち",
    "kanji": "後",
    "romaji": "nochi",
    "en": "after/later",
    "bn": "পরে",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v638",
    "kana": "のどか",
    "kanji": "長閑",
    "romaji": "nodoka",
    "en": "quiet/tranquil",
    "bn": "শান্ত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v639",
    "kana": "のみ",
    "kanji": null,
    "romaji": "nomi",
    "en": "only",
    "bn": "শুধুমাত্র",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v642",
    "kana": "のり",
    "kanji": "海苔",
    "romaji": "nori",
    "en": "seaweed/nori",
    "bn": "নোরি (শৈবাল)",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v646",
    "kana": "のろい",
    "kanji": "呪い",
    "romaji": "noroi",
    "en": "curse",
    "bn": "অভিশাপ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v647",
    "kana": "のんびり",
    "kanji": null,
    "romaji": "nonbiri",
    "en": "carefree/at leisure",
    "bn": "আরামে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v648",
    "kana": "ば",
    "kanji": "場",
    "romaji": "ba",
    "en": "place/occasion",
    "bn": "জায়গা/উপলক্ষ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v655",
    "kana": "はく",
    "kanji": "吐く",
    "romaji": "haku",
    "en": "to breathe out/vomit / to vomit",
    "bn": "নিঃশ্বাস ছাড়া/বমি করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v661",
    "kana": "はじめる",
    "kanji": "始める",
    "romaji": "hajimeru",
    "en": "to start (something)",
    "bn": "শুরু করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v664",
    "kana": "はす",
    "kanji": "蓮",
    "romaji": "hasu",
    "en": "lotus",
    "bn": "পদ্ম",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v665",
    "kana": "はずかしい",
    "kanji": "恥ずかしい",
    "romaji": "hazukashii",
    "en": "embarrassed/shy",
    "bn": "লজ্জিত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v666",
    "kana": "パソコン",
    "kanji": null,
    "romaji": "pasokon",
    "en": "PC",
    "bn": "কম্পিউটার",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v667",
    "kana": "はた",
    "kanji": "旗",
    "romaji": "hata",
    "en": "flag",
    "bn": "পতাকা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v668",
    "kana": "はたけ",
    "kanji": "畑",
    "romaji": "hatake",
    "en": "field",
    "bn": "ক্ষেত",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v672",
    "kana": "はちがつ",
    "kanji": "八月",
    "romaji": "hachigatsu",
    "en": "August",
    "bn": "আগস্ট",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v673",
    "kana": "はっきり",
    "kanji": null,
    "romaji": "hakkiri",
    "en": "clearly",
    "bn": "পরিষ্কারভাবে",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v679",
    "kana": "ばしょ",
    "kanji": "場所",
    "romaji": "basho",
    "en": "place",
    "bn": "জায়গা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v680",
    "kana": "はず",
    "kanji": null,
    "romaji": "hazu",
    "en": "expected/should be",
    "bn": "হওয়ার কথা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v681",
    "kana": "はずす",
    "kanji": "外す",
    "romaji": "hazusu",
    "en": "to unfasten/remove",
    "bn": "খোলা/সরানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v682",
    "kana": "はた",
    "kanji": null,
    "romaji": "hata",
    "en": "near/side",
    "bn": "কাছে/পাশে",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v683",
    "kana": "はたく",
    "kanji": "叩く",
    "romaji": "hataku",
    "en": "to dust/clap",
    "bn": "ঝাড়া/হাততালি দেওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v684",
    "kana": "はたらき",
    "kanji": "働き",
    "romaji": "hataraki",
    "en": "work/action",
    "bn": "কাজ/ক্রিয়া",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v685",
    "kana": "はち",
    "kanji": "蜂",
    "romaji": "hachi",
    "en": "bee",
    "bn": "মৌমাছি",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v686",
    "kana": "はっき",
    "kanji": "発揮",
    "romaji": "hakki",
    "en": "exhibition/demonstration",
    "bn": "প্রদর্শন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v687",
    "kana": "はっく",
    "kanji": "発掘",
    "romaji": "hakkutsu",
    "en": "excavation",
    "bn": "খনন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v688",
    "kana": "はっけん",
    "kanji": "発見",
    "romaji": "hakken",
    "en": "discovery",
    "bn": "আবিষ্কার",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v689",
    "kana": "はっこう",
    "kanji": "発行",
    "romaji": "hakkou",
    "en": "issue/publication",
    "bn": "প্রকাশনা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v690",
    "kana": "はっしゃ",
    "kanji": "発射",
    "romaji": "hassha",
    "en": "departure/fire",
    "bn": "যাত্রা/উৎক্ষেপণ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v691",
    "kana": "はっせい",
    "kanji": "発生",
    "romaji": "hassei",
    "en": "occurrence",
    "bn": "ঘটন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v692",
    "kana": "はったつ",
    "kanji": "発達",
    "romaji": "hattatsu",
    "en": "development",
    "bn": "উন্নতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v693",
    "kana": "はってん",
    "kanji": "発展",
    "romaji": "hatten",
    "en": "development/expansion",
    "bn": "বিকাশ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v694",
    "kana": "はっぴょう",
    "kanji": "発表",
    "romaji": "happyou",
    "en": "announcement",
    "bn": "ঘোষণা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v695",
    "kana": "はつ",
    "kanji": "初",
    "romaji": "hatsu",
    "en": "first/new",
    "bn": "প্রথম",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v696",
    "kana": "はつおん",
    "kanji": "発音",
    "romaji": "hatsuon",
    "en": "pronunciation",
    "bn": "উচ্চারণ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v697",
    "kana": "はつめい",
    "kanji": "発明",
    "romaji": "hatsumei",
    "en": "invention",
    "bn": "উদ্ভাবন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v702",
    "kana": "はなれる",
    "kanji": "離れる",
    "romaji": "hanareru",
    "en": "to be separated",
    "bn": "আলাদা হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v704",
    "kana": "はやく",
    "kanji": "早く",
    "romaji": "hayaku",
    "en": "early/quickly",
    "bn": "তাড়াতাড়ি",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v707",
    "kana": "はやる",
    "kanji": "流行る",
    "romaji": "hayaru",
    "en": "to be popular/prevalent",
    "bn": "জনপ্রিয় হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v708",
    "kana": "はら",
    "kanji": "腹",
    "romaji": "hara",
    "en": "stomach/belly",
    "bn": "পেট",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v722",
    "kana": "ひかり",
    "kanji": "光",
    "romaji": "hikari",
    "en": "light",
    "bn": "আলো",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v723",
    "kana": "ひかる",
    "kanji": "光る",
    "romaji": "hikaru",
    "en": "to shine",
    "bn": "উজ্জ্বল হওয়া/জ্বলা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v724",
    "kana": "ひきだし",
    "kanji": "引き出し",
    "romaji": "hikidashi",
    "en": "drawer",
    "bn": "ড্রয়ার",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v725",
    "kana": "ひきざん",
    "kanji": "引き算",
    "romaji": "hikizan",
    "en": "subtraction",
    "bn": "বিয়োগ",
    "category": "numbers",
    "level": "N4"
  },
  {
    "id": "n4v730",
    "kana": "ひざ",
    "kanji": "膝",
    "romaji": "hiza",
    "en": "knee",
    "bn": "হাঁটু",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v731",
    "kana": "びじゅつかん",
    "kanji": "美術館",
    "romaji": "bijutsukan",
    "en": "art museum",
    "bn": "আর্ট মিউজিয়াম",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v732",
    "kana": "ひじょうに",
    "kanji": "非常に",
    "romaji": "hijou ni",
    "en": "extremely/very",
    "bn": "অত্যন্ত",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v734",
    "kana": "びっくり",
    "kanji": null,
    "romaji": "bikkuri",
    "en": "surprised",
    "bn": "অবাক হওয়া",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v735",
    "kana": "ひつよう",
    "kanji": "必要",
    "romaji": "hitsuyou",
    "en": "necessary",
    "bn": "প্রয়োজনীয়",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v736",
    "kana": "ひつじ",
    "kanji": "羊",
    "romaji": "hitsuji",
    "en": "sheep",
    "bn": "ভেড়া",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v737",
    "kana": "ひどい",
    "kanji": null,
    "romaji": "hidoi",
    "en": "terrible/awful",
    "bn": "ভয়াবহ",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v742",
    "kana": "ひみつ",
    "kanji": "秘密",
    "romaji": "himitsu",
    "en": "secret",
    "bn": "গোপন",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v749",
    "kana": "ひるま",
    "kanji": "昼間",
    "romaji": "hiruma",
    "en": "daytime",
    "bn": "দিনের বেলা",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v751",
    "kana": "ひろば",
    "kanji": "広場",
    "romaji": "hiroba",
    "en": "square/plaza",
    "bn": "চত্বর",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v752",
    "kana": "ひまわり",
    "kanji": "向日葵",
    "romaji": "himawari",
    "en": "sunflower",
    "bn": "সূর্যমুখী",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v754",
    "kana": "ふえる",
    "kanji": "増える",
    "romaji": "fueru",
    "en": "to increase",
    "bn": "বৃদ্ধি পাওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v755",
    "kana": "ふかい",
    "kanji": "深い",
    "romaji": "fukai",
    "en": "deep",
    "bn": "গভীর",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v757",
    "kana": "ふくしゅう",
    "kanji": "復習",
    "romaji": "fukushuu",
    "en": "review",
    "bn": "পুনরালোচনা",
    "category": "activities",
    "level": "N4"
  },
  {
    "id": "n4v758",
    "kana": "ふくざつ",
    "kanji": "複雑",
    "romaji": "fukuzatsu",
    "en": "complex",
    "bn": "জটিল",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v759",
    "kana": "ふくろ",
    "kanji": "袋",
    "romaji": "fukuro",
    "en": "bag/sack",
    "bn": "থলি",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v760",
    "kana": "ふしぎ",
    "kanji": "不思議",
    "romaji": "fushigi",
    "en": "mysterious/strange",
    "bn": "অদ্ভুত",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v761",
    "kana": "ふじゅう",
    "kanji": "不自由",
    "romaji": "fujiyuu",
    "en": "inconvenience/disability",
    "bn": "অসুবিধা",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v762",
    "kana": "ふすま",
    "kanji": "襖",
    "romaji": "fusuma",
    "en": "sliding screen",
    "bn": "স্লাইডিং স্ক্রিন",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v763",
    "kana": "ふだん",
    "kanji": "普段",
    "romaji": "fudan",
    "en": "usually",
    "bn": "সাধারণত",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v764",
    "kana": "ふつう",
    "kanji": "普通",
    "romaji": "futsuu",
    "en": "usually/normal",
    "bn": "সাধারণ",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v765",
    "kana": "ぶどう",
    "kanji": "葡萄",
    "romaji": "budou",
    "en": "grapes",
    "bn": "আঙ্গুর",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v766",
    "kana": "ふとる",
    "kanji": "太る",
    "romaji": "futoru",
    "en": "to gain weight",
    "bn": "মোটা হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v767",
    "kana": "ふとん",
    "kanji": "布団",
    "romaji": "futon",
    "en": "futon",
    "bn": "ফুতোন (বিছানা)",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v768",
    "kana": "ふね",
    "kanji": "船",
    "romaji": "fune",
    "en": "ship/boat",
    "bn": "জাহাজ/নৌকা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v769",
    "kana": "ふべき",
    "kanji": "不備",
    "romaji": "fubi",
    "en": "defect/deficiency",
    "bn": "ঘাটতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v770",
    "kana": "ふむ",
    "kanji": "踏む",
    "romaji": "fumu",
    "en": "to step on / to tread on",
    "bn": "পা রাখা / মাড়ানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v771",
    "kana": "ふやす",
    "kanji": "増やす",
    "romaji": "fuyasu",
    "en": "to increase (something)",
    "bn": "বাড়ানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v773",
    "kana": "ふりだす",
    "kanji": "降り出す",
    "romaji": "furidasu",
    "en": "to start raining",
    "bn": "বৃষ্টি শুরু হওয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v774",
    "kana": "ふりかえる",
    "kanji": "振り返る",
    "romaji": "furikaeru",
    "en": "to look back",
    "bn": "পেছনে ফিরে দেখা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v775",
    "kana": "ふる",
    "kanji": "振る",
    "romaji": "furu",
    "en": "to shake/wave",
    "bn": "ঝাঁকানো/হাত নাড়ানো",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v776",
    "kana": "ふるえる",
    "kanji": "震える",
    "romaji": "furueru",
    "en": "to shiver/shake / to quake/tremble",
    "bn": "কাঁপা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v778",
    "kana": "ふわふわ",
    "kanji": null,
    "romaji": "fuwafuwa",
    "en": "fluffy/soft / lightly/softly",
    "bn": "নরম তুলতুলে / নরমভাবে",
    "category": "adjectives",
    "level": "N4"
  },
  {
    "id": "n4v779",
    "kana": "ふんいき",
    "kanji": "雰囲気",
    "romaji": "funiki",
    "en": "atmosphere",
    "bn": "পরিবেশ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v780",
    "kana": "ぶつかる",
    "kanji": "ぶつかる",
    "romaji": "butsukaru",
    "en": "to bump into",
    "bn": "ধাক্কা লাগা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v781",
    "kana": "ぶっか",
    "kanji": "物価",
    "romaji": "bukka",
    "en": "prices (cost of living)",
    "bn": "দ্রব্যমূল্য",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v782",
    "kana": "ぶっしつ",
    "kanji": "物質",
    "romaji": "busshitsu",
    "en": "substance/material",
    "bn": "পদার্থ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v783",
    "kana": "ふて",
    "kanji": "筆",
    "romaji": "fude",
    "en": "writing brush",
    "bn": "তুলি",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v784",
    "kana": "ふと",
    "kanji": null,
    "romaji": "futo",
    "en": "suddenly/incidentally",
    "bn": "হঠাৎ",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v785",
    "kana": "ふね",
    "kanji": "舟",
    "romaji": "fune",
    "en": "small boat/ship",
    "bn": "নৌকা",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v786",
    "kana": "ふみ",
    "kanji": "文",
    "romaji": "fumi",
    "en": "letter/writing",
    "bn": "চিঠি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v788",
    "kana": "ぶらぶら",
    "kanji": null,
    "romaji": "burabura",
    "en": "strolling/loitering",
    "bn": "ঘুরে বেড়ানো",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v789",
    "kana": "ぷらっと",
    "kanji": null,
    "romaji": "puratto",
    "en": "casually",
    "bn": "ক্যাজুয়ালি",
    "category": "adverbs",
    "level": "N4"
  },
  {
    "id": "n4v791",
    "kana": "ふるう",
    "kanji": "振るう",
    "romaji": "furuu",
    "en": "to exert/wield",
    "bn": "প্রয়োগ করা",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v792",
    "kana": "ふるい",
    "kanji": "篩",
    "romaji": "furui",
    "en": "sieve/screen",
    "bn": "চালুনি",
    "category": "objects",
    "level": "N4"
  },
  {
    "id": "n4v794",
    "kana": "ふれる",
    "kanji": "触れる",
    "romaji": "fureru",
    "en": "to touch/feel",
    "bn": "ছোঁয়া",
    "category": "verbs",
    "level": "N4"
  },
  {
    "id": "n4v797",
    "kana": "ぶん",
    "kanji": "文",
    "romaji": "bun",
    "en": "sentence",
    "bn": "বাক্য",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v798",
    "kana": "ぶんか",
    "kanji": "文化",
    "romaji": "bunka",
    "en": "culture",
    "bn": "সংস্কৃতি",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v799",
    "kana": "ぶんがく",
    "kanji": "文学",
    "romaji": "bungaku",
    "en": "literature",
    "bn": "সাহিত্য",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v800",
    "kana": "ぶんぼう",
    "kanji": "文法",
    "romaji": "bunpou",
    "en": "grammar",
    "bn": "ব্যাকরণ",
    "category": "basic",
    "level": "N4"
  },
  {
    "id": "n4v802",
    "kana": "わりあい",
    "kanji": "割合",
    "romaji": "wariai",
    "en": "rate / ratio / percentage",
    "bn": "অনুপাত / হার",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v803",
    "kana": "わりびき",
    "kanji": "割引",
    "romaji": "waribiki",
    "en": "discount",
    "bn": "ছাড়",
    "category": "business",
    "level": "N4"
  },
  {
    "id": "n4v807",
    "kana": "おりる",
    "kanji": "下りる",
    "romaji": "oriru",
    "en": "to go down / descend",
    "bn": "নিচে নামা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v808",
    "kana": "おる",
    "kanji": "居る",
    "romaji": "oru",
    "en": "to be / exist (humble)",
    "bn": "থাকা (বিনম্র)",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v809",
    "kana": "おれる",
    "kanji": "折れる",
    "romaji": "oreru",
    "en": "to break / be folded / to be broken / yield",
    "bn": "ভাঙা / ভাঁজ হওয়া / ভেঙে যাওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v810",
    "kana": "おろす",
    "kanji": "下ろす",
    "romaji": "orosu",
    "en": "to take down / lower",
    "bn": "নিচে নামানো",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v811",
    "kana": "おかげ",
    "kanji": "おかげ",
    "romaji": "okage",
    "en": "thanks to / owing to",
    "bn": "কারণে / দয়ায়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v813",
    "kana": "おき",
    "kanji": "起き",
    "romaji": "oki",
    "en": "waking up",
    "bn": "জেগে ওঠা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v821",
    "kana": "おたく",
    "kanji": "お宅",
    "romaji": "otaku",
    "en": "your house / home (polite)",
    "bn": "আপনার বাড়ি / ঘর",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v829",
    "kana": "おどる",
    "kanji": "踊る",
    "romaji": "odoru",
    "en": "to dance",
    "bn": "নাচ করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v838",
    "kana": "おもな",
    "kanji": "主な",
    "romaji": "omona",
    "en": "main / principal",
    "bn": "প্রধান",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v839",
    "kana": "おもうに",
    "kanji": "思うに",
    "romaji": "omouni",
    "en": "to my mind / I think",
    "bn": "আমি মনে করি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v840",
    "kana": "およぎ",
    "kanji": "泳ぎ",
    "romaji": "oyogi",
    "en": "swimming",
    "bn": "সাঁতার",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v846",
    "kana": "おわる",
    "kanji": "終る",
    "romaji": "owaru",
    "en": "to end",
    "bn": "শেষ হওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v848",
    "kana": "おんせん",
    "kanji": "温泉",
    "romaji": "onsen",
    "en": "hot spring",
    "bn": "উষ্ণ প্রস্রবণ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v849",
    "kana": "おんど",
    "kanji": "温度",
    "romaji": "ondo",
    "en": "temperature",
    "bn": "তাপমাত্রা",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v851",
    "kana": "おんなのひと",
    "kanji": "女の人",
    "romaji": "onnanohito",
    "en": "woman",
    "bn": "নারী / মহিলা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v852",
    "kana": "オートバイ",
    "kanji": null,
    "romaji": "ootobai",
    "en": "motorcycle",
    "bn": "মোটরসাইকেল",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v855",
    "kana": "お金",
    "kanji": "お金",
    "romaji": "okane",
    "en": "money",
    "bn": "টাকা",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v891",
    "kana": "かい",
    "kanji": "回",
    "romaji": "kai",
    "en": "times / frequency",
    "bn": "বার",
    "category": "counter",
    "level": "N4"
  },
  {
    "id": "n4v892",
    "kana": "かい",
    "kanji": "階",
    "romaji": "kai",
    "en": "floor / story",
    "bn": "তলা",
    "category": "counter",
    "level": "N4"
  },
  {
    "id": "n4v901",
    "kana": "かお",
    "kanji": "顔",
    "romaji": "kao",
    "en": "face",
    "bn": "মুখমণ্ডল",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v902",
    "kana": "かかる",
    "kanji": "掛かる",
    "romaji": "kakaru",
    "en": "to take (time, money)",
    "bn": "সময়/টাকা লাগা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v915",
    "kana": "かたかな",
    "kanji": "片仮名",
    "romaji": "katakana",
    "en": "katakana",
    "bn": "কাতাকানা",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v927",
    "kana": "〜から",
    "kanji": null,
    "romaji": "kara",
    "en": "from / because",
    "bn": "থেকে / কারণ",
    "category": "grammar",
    "level": "N4"
  },
  {
    "id": "n4v932",
    "kana": "かれる",
    "kanji": "枯れる",
    "romaji": "kareru",
    "en": "to wither / dry up",
    "bn": "শুকিয়ে যাওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v940",
    "kana": "きけん",
    "kanji": "危険",
    "romaji": "kiken",
    "en": "danger / peril",
    "bn": "বিপদ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v941",
    "kana": "きこえる",
    "kanji": "聞こえる",
    "romaji": "kikoeru",
    "en": "to be audible",
    "bn": "শোনা যাওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v942",
    "kana": "きしゃ",
    "kanji": "汽車",
    "romaji": "kisha",
    "en": "steam train",
    "bn": "বাষ্পচালিত ট্রেন",
    "category": "transport",
    "level": "N4"
  },
  {
    "id": "n4v943",
    "kana": "ぎじゅつ",
    "kanji": "技術",
    "romaji": "gijutsu",
    "en": "technology / skill",
    "bn": "প্রযুক্তি / দক্ষতা",
    "category": "business",
    "level": "N4"
  },
  {
    "id": "n4v944",
    "kana": "きせつ",
    "kanji": "季節",
    "romaji": "kisetsu",
    "en": "season",
    "bn": "ঋতু",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v951",
    "kana": "きぼう",
    "kanji": "希望",
    "romaji": "kibou",
    "en": "hope / wish",
    "bn": "আশা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v960",
    "kana": "きゅうに",
    "kanji": "急に",
    "romaji": "kyuuni",
    "en": "suddenly",
    "bn": "হঠাৎ",
    "category": "adverb",
    "level": "N4"
  },
  {
    "id": "n4v961",
    "kana": "きゅうじつ",
    "kanji": "休日",
    "romaji": "kyuujitsu",
    "en": "holiday",
    "bn": "ছুটির দিন",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v962",
    "kana": "きゅうけい",
    "kanji": "休憩",
    "romaji": "kyuukei",
    "en": "break / rest",
    "bn": "বিরতি",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v963",
    "kana": "きゅうしゅう",
    "kanji": "吸収",
    "romaji": "kyuushuu",
    "en": "absorption",
    "bn": "শোষণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v964",
    "kana": "きゅうじょ",
    "kanji": "救助",
    "romaji": "kyuujo",
    "en": "rescue / aid",
    "bn": "উদ্ধার",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v965",
    "kana": "きゅうに",
    "kanji": "九",
    "romaji": "kyuu",
    "en": "nine",
    "bn": "নয়",
    "category": "number",
    "level": "N4"
  },
  {
    "id": "n4v966",
    "kana": "きゅうりょう",
    "kanji": "給料",
    "romaji": "kyuuryou",
    "en": "salary",
    "bn": "বেতন",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v970",
    "kana": "きょうぎ",
    "kanji": "競技",
    "romaji": "kyougi",
    "en": "match / contest",
    "bn": "প্রতিযোগিতা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v971",
    "kana": "きょうじゅ",
    "kanji": "教授",
    "romaji": "kyouju",
    "en": "professor",
    "bn": "অধ্যাপক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v975",
    "kana": "きょうりょく",
    "kanji": "協力",
    "romaji": "kyouryoku",
    "en": "cooperation",
    "bn": "সহযোগিতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v976",
    "kana": "きょく",
    "kanji": "曲",
    "romaji": "kyoku",
    "en": "song / piece of music",
    "bn": "সুর / গান",
    "category": "art",
    "level": "N4"
  },
  {
    "id": "n4v978",
    "kana": "きらう",
    "kanji": "嫌う",
    "romaji": "kirau",
    "en": "to hate / dislike",
    "bn": "অপছন্দ করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v984",
    "kana": "きをつける",
    "kanji": "気をつける",
    "romaji": "ki wo tsukeru",
    "en": "to be careful",
    "bn": "সতর্ক থাকা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v985",
    "kana": "きん",
    "kanji": "金",
    "romaji": "kin",
    "en": "gold",
    "bn": "সোনা",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v986",
    "kana": "ぎん",
    "kanji": "銀",
    "romaji": "gin",
    "en": "silver",
    "bn": "রুপা",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v987",
    "kana": "きんこう",
    "kanji": "銀行",
    "romaji": "ginkou",
    "en": "bank",
    "bn": "ব্যাংক",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v988",
    "kana": "きんし",
    "kanji": "禁止",
    "romaji": "kinshi",
    "en": "prohibition",
    "bn": "নিষেধ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v990",
    "kana": "きんり",
    "kanji": "金利",
    "romaji": "kinri",
    "en": "interest rate",
    "bn": "সুদের হার",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v993",
    "kana": "く",
    "kanji": "句",
    "romaji": "ku",
    "en": "phrase / haiku",
    "bn": "বাক্যাংশ",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1001",
    "kana": "くちびる",
    "kanji": "唇",
    "romaji": "kuchibiru",
    "en": "lips",
    "bn": "ঠোঁট",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v1004",
    "kana": "くっつく",
    "kanji": "付く",
    "romaji": "kuttsuku",
    "en": "to stick / adhere",
    "bn": "লেগে থাকা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1005",
    "kana": "くっつける",
    "kanji": "入付ける",
    "romaji": "kuttsukeru",
    "en": "to attach / stick",
    "bn": "সংযুক্ত করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1007",
    "kana": "くばる",
    "kanji": "配る",
    "romaji": "kubaru",
    "en": "to distribute / deliver",
    "bn": "বিতরণ করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1009",
    "kana": "くふう",
    "kanji": "工夫",
    "romaji": "kufuu",
    "en": "device / scheme",
    "bn": "উপায়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1014",
    "kana": "くらい",
    "kanji": "位",
    "romaji": "kurai",
    "en": "rank / grade",
    "bn": "পদমর্যাদা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1018",
    "kana": "くるしみ",
    "kanji": "苦しみ",
    "romaji": "kurushimi",
    "en": "suffering / pain",
    "bn": "যন্ত্রণা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1019",
    "kana": "くるしむ",
    "kanji": "苦しむ",
    "romaji": "kurushimu",
    "en": "to suffer / groan",
    "bn": "কষ্ট পাওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1021",
    "kana": "くれる",
    "kanji": "呉れる",
    "romaji": "kureru",
    "en": "to give (to me)",
    "bn": "দেওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1025",
    "kana": "くろう",
    "kanji": "苦労",
    "romaji": "kurou",
    "en": "trouble / hardship",
    "bn": "কষ্ট",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1026",
    "kana": "くわしい",
    "kanji": "詳しい",
    "romaji": "kuwashii",
    "en": "detailed / knowledgeable",
    "bn": "বিস্তারিত",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1027",
    "kana": "くわる",
    "kanji": "加わる",
    "romaji": "kuwaru",
    "en": "to join / be added",
    "bn": "যুক্ত হওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1028",
    "kana": "くわえる",
    "kanji": "加える",
    "romaji": "kuwaeru",
    "en": "to add / include",
    "bn": "যুক্ত করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1030",
    "kana": "ぐん",
    "kanji": "郡",
    "romaji": "gun",
    "en": "district / county",
    "bn": "জেলা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1031",
    "kana": "ぐんじん",
    "kanji": "軍人",
    "romaji": "gunjin",
    "en": "military personnel",
    "bn": "সৈনিক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1032",
    "kana": "ぐんたい",
    "kanji": "軍隊",
    "romaji": "guntai",
    "en": "army / troops",
    "bn": "সেনাবাহিনী",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1034",
    "kana": "け",
    "kanji": "怪",
    "romaji": "ke",
    "en": "suspicious / strange",
    "bn": "সন্দেহজনক",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1035",
    "kana": "けいい",
    "kanji": "敬意",
    "romaji": "keii",
    "en": "respect / honor",
    "bn": "শ্রদ্ধা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1036",
    "kana": "けいえい",
    "kanji": "経営",
    "romaji": "keiei",
    "en": "management",
    "bn": "পরিচালনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1039",
    "kana": "けいき",
    "kanji": "景気",
    "romaji": "keiki",
    "en": "business conditions",
    "bn": "অর্থনৈতিক অবস্থা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1041",
    "kana": "けいこ",
    "kanji": "稽古",
    "romaji": "keiko",
    "en": "practice / training",
    "bn": "অনুশীলন",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1042",
    "kana": "けいご",
    "kanji": "敬語",
    "romaji": "keigo",
    "en": "honorific language",
    "bn": "বিনম্র ভাষা",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1043",
    "kana": "けいさい",
    "kanji": "掲載",
    "romaji": "keisai",
    "en": "publication / post",
    "bn": "প্রকাশনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1045",
    "kana": "けいさん",
    "kanji": "計算",
    "romaji": "keisan",
    "en": "calculation",
    "bn": "গণনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1046",
    "kana": "けいじ",
    "kanji": "掲示",
    "romaji": "keiji",
    "en": "notice / bulletin",
    "bn": "নোটিশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1047",
    "kana": "けいじ",
    "kanji": "刑事",
    "romaji": "keiji",
    "en": "detective",
    "bn": "গোয়েন্দা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1048",
    "kana": "けいぞく",
    "kanji": "継続",
    "romaji": "keizoku",
    "en": "continuation",
    "bn": "ধারাবাহিকতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1049",
    "kana": "けいたい",
    "kanji": "携帯",
    "romaji": "keitai",
    "en": "mobile / portable / mobile phone",
    "bn": "মোবাইল",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1050",
    "kana": "けいたいでんわ",
    "kanji": "携帯電話",
    "romaji": "携帯電話",
    "en": "cell phone",
    "bn": "মোবাইল ফোন",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1051",
    "kana": "けいど",
    "kanji": "軽度",
    "romaji": "keido",
    "en": "light / mild",
    "bn": "সামান্য",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1052",
    "kana": "けいば",
    "kanji": "競馬",
    "romaji": "keiba",
    "en": "horse racing",
    "bn": "ঘোড়দৌড়",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1053",
    "kana": "けいび",
    "kanji": "警備",
    "romaji": "keibi",
    "en": "security",
    "bn": "নিরাপত্তা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1054",
    "kana": "けいふく",
    "kanji": "敬服",
    "romaji": "keifuku",
    "en": "admiration",
    "bn": "প্রশংসা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1055",
    "kana": "けいむしょ",
    "kanji": "刑務所",
    "romaji": "keimusho",
    "en": "prison",
    "bn": "কারাগার",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1056",
    "kana": "けいもう",
    "kanji": "啓蒙",
    "romaji": "keimou",
    "en": "enlightenment",
    "bn": "জ্ঞানോദয়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1057",
    "kana": "けいやく",
    "kanji": "契約",
    "romaji": "keiyaku",
    "en": "contract / agreement",
    "bn": "চুক্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1058",
    "kana": "けいゆ",
    "kanji": "経由",
    "romaji": "keiyu",
    "en": "via / through",
    "bn": "হয়ে",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1059",
    "kana": "けいようし",
    "kanji": "形容詞",
    "romaji": "keiyoushi",
    "en": "adjective",
    "bn": "বিশেষণ",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1060",
    "kana": "けいり",
    "kanji": "経理",
    "romaji": "keiri",
    "en": "accounting",
    "bn": "হিসাবরক্ষণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1061",
    "kana": "けいれき",
    "kanji": "経歴",
    "romaji": "keireki",
    "en": "personal history",
    "bn": "জীবনবৃত্তান্ত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1062",
    "kana": "けが",
    "kanji": "怪我",
    "romaji": "kega",
    "en": "injury",
    "bn": "আঘাত",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1063",
    "kana": "けがす",
    "kanji": "汚す",
    "romaji": "kegasu",
    "en": "to stain / soil",
    "bn": "নোংরা করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1064",
    "kana": "けがれる",
    "kanji": "汚れる",
    "romaji": "kegareru",
    "en": "to be dirty",
    "bn": "নোংরা হওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1067",
    "kana": "けしょう",
    "kanji": "化粧",
    "romaji": "keshou",
    "en": "makeup / cosmetics",
    "bn": "মেকআপ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1069",
    "kana": "けず",
    "kanji": "削",
    "romaji": "kezu",
    "en": "to shave / cut down",
    "bn": "কাটা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1070",
    "kana": "けた",
    "kanji": "桁",
    "romaji": "keta",
    "en": "digit / column",
    "bn": "অঙ্ক",
    "category": "number",
    "level": "N4"
  },
  {
    "id": "n4v1071",
    "kana": "けち",
    "kanji": null,
    "romaji": "kechi",
    "en": "stingy / miser",
    "bn": "কৃপণ",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1072",
    "kana": "けっかん",
    "kanji": "欠陥",
    "romaji": "kekkan",
    "en": "defect / fault",
    "bn": "ত্রুটি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1073",
    "kana": "けっきょく",
    "kanji": "結局",
    "romaji": "kekkyoku",
    "en": "after all / eventually",
    "bn": "অবশেষে",
    "category": "adverb",
    "level": "N4"
  },
  {
    "id": "n4v1075",
    "kana": "けっさく",
    "kanji": "傑作",
    "romaji": "kessaku",
    "en": "masterpiece",
    "bn": "অনবদ্য সৃষ্টি",
    "category": "art",
    "level": "N4"
  },
  {
    "id": "n4v1076",
    "kana": "けっさん",
    "kanji": "決算",
    "romaji": "kessan",
    "en": "settlement of accounts / balance sheet",
    "bn": "হিসাব নিকাশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1078",
    "kana": "けっしょう",
    "kanji": "決勝",
    "romaji": "kesshou",
    "en": "finals (sports)",
    "bn": "ফাইনাল",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1080",
    "kana": "けっせつ",
    "kanji": "結節",
    "romaji": "kessetsu",
    "en": "node / knot",
    "bn": "গ্রন্থি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1081",
    "kana": "けっせん",
    "kanji": "決戦",
    "romaji": "kessen",
    "en": "decisive battle",
    "bn": "চূড়ান্ত যুদ্ধ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1082",
    "kana": "けっそく",
    "kanji": "結束",
    "romaji": "kessoku",
    "en": "unity / solidarity",
    "bn": "একতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1083",
    "kana": "けったい",
    "kanji": null,
    "romaji": "kettai",
    "en": "strange / odd",
    "bn": "অদ্ভুত",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1085",
    "kana": "けってん",
    "kanji": "欠点",
    "romaji": "ketten",
    "en": "fault / shortcoming",
    "bn": "ত্রুটি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1086",
    "kana": "けっとう",
    "kanji": "血統",
    "romaji": "kettou",
    "en": "lineage / pedigree",
    "bn": "বংশধারা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1087",
    "kana": "けつあつ",
    "kanji": "血圧",
    "romaji": "ketsuatsu",
    "en": "blood pressure",
    "bn": "রক্তচাপ",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1088",
    "kana": "けつえき",
    "kanji": "血液",
    "romaji": "ketsueki",
    "en": "blood",
    "bn": "রক্ত",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v1089",
    "kana": "けつえん",
    "kanji": "血縁",
    "romaji": "ketsuen",
    "en": "blood relation",
    "bn": "রক্তের সম্পর্ক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1090",
    "kana": "けつぎ",
    "kanji": "決議",
    "romaji": "ketsugi",
    "en": "resolution / vote",
    "bn": "প্রস্তাব",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1091",
    "kana": "けつごう",
    "kanji": "結合",
    "romaji": "ketsugou",
    "en": "combination / union",
    "bn": "সংযোজন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1093",
    "kana": "けつじょ",
    "kanji": "欠如",
    "romaji": "ketsujo",
    "en": "lack / deficiency",
    "bn": "অভাব",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1094",
    "kana": "けっしん",
    "kanji": "決心",
    "romaji": "kesshin",
    "en": "determination",
    "bn": "সংকল্প",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1095",
    "kana": "けつぜん",
    "kanji": "決然",
    "romaji": "ketsuzen",
    "en": "resolute",
    "bn": "দৃঢ়",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1096",
    "kana": "けつだん",
    "kanji": "決断",
    "romaji": "ketsudan",
    "en": "decision / resolve",
    "bn": "সিদ্ধান্ত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1097",
    "kana": "けつまつ",
    "kanji": "結末",
    "romaji": "ketsumatsu",
    "en": "end / conclusion",
    "bn": "সমাপ্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1098",
    "kana": "けつろん",
    "kanji": "結論",
    "romaji": "ketsuron",
    "en": "conclusion",
    "bn": "উপসংহার",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1099",
    "kana": "けはい",
    "kanji": "気配",
    "romaji": "kehai",
    "en": "sign / indication",
    "bn": "আভাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1100",
    "kana": "けみ",
    "kanji": "検",
    "romaji": "kemi",
    "en": "inspection / exam",
    "bn": "পরীক্ষা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1101",
    "kana": "けみすと",
    "kanji": null,
    "romaji": "kemisuto",
    "en": "chemist",
    "bn": "রসায়নবিদ",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1102",
    "kana": "けむり",
    "kanji": "煙",
    "romaji": "kemuri",
    "en": "smoke",
    "bn": "ধোঁয়া",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1103",
    "kana": "けもの",
    "kanji": "獣",
    "romaji": "kemono",
    "en": "beast / animal",
    "bn": "পশু",
    "category": "animal",
    "level": "N4"
  },
  {
    "id": "n4v1104",
    "kana": "ける",
    "kanji": "蹴る",
    "romaji": "keru",
    "en": "to kick",
    "bn": "লাথি মারা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1105",
    "kana": "げん",
    "kanji": "源",
    "romaji": "gen",
    "en": "source / origin",
    "bn": "উৎস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1106",
    "kana": "げんいん",
    "kanji": "原因",
    "romaji": "gen-in",
    "en": "cause",
    "bn": "কারণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1107",
    "kana": "げんかい",
    "kanji": "限界",
    "romaji": "genkai",
    "en": "limit / boundary",
    "bn": "সীমা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1108",
    "kana": "げんがく",
    "kanji": "減額",
    "romaji": "gengaku",
    "en": "reduction in price",
    "bn": "মূল্য হ্রাস",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v1109",
    "kana": "けんかん",
    "kanji": "玄関",
    "romaji": "genkan",
    "en": "entrance / foyer",
    "bn": "প্রবেশপথ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1111",
    "kana": "げんきん",
    "kanji": "現金",
    "romaji": "genkin",
    "en": "cash",
    "bn": "নগদ টাকা",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v1112",
    "kana": "けんぎ",
    "kanji": "嫌疑",
    "romaji": "kengi",
    "en": "suspicion",
    "bn": "সন্দেহ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1113",
    "kana": "げんきゅう",
    "kanji": "言及",
    "romaji": "genkyuu",
    "en": "mention / reference",
    "bn": "উল্লেখ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1114",
    "kana": "げんきゅう",
    "kanji": "減給",
    "romaji": "genkyuu",
    "en": "pay cut",
    "bn": "বেতন হ্রাস",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v1115",
    "kana": "けんきょ",
    "kanji": "謙虚",
    "romaji": "kenkyo",
    "en": "modest / humble",
    "bn": "বিনয়ী",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1116",
    "kana": "げんきょ",
    "kanji": "検挙",
    "romaji": "genkyo",
    "en": "arrest",
    "bn": "গ্রেফতার",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1118",
    "kana": "けんきゅうじょ",
    "kanji": "研究所",
    "romaji": "kenkyuujo",
    "en": "research institute",
    "bn": "গবেষণাগার",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1119",
    "kana": "げんけい",
    "kanji": "原形",
    "romaji": "genkei",
    "en": "original form",
    "bn": "আসল রূপ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1120",
    "kana": "げんけい",
    "kanji": "減刑",
    "romaji": "genkei",
    "en": "reduction of sentence",
    "bn": "দণ্ড হ্রাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1121",
    "kana": "けんこう",
    "kanji": "健康",
    "romaji": "kenkou",
    "en": "health",
    "bn": "স্বাস্থ্য",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1122",
    "kana": "けんこうしんだん",
    "kanji": "健康診断",
    "romaji": "kenkou shindan",
    "en": "medical checkup",
    "bn": "স্বাস্থ্য পরীক্ষা",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1123",
    "kana": "げんこく",
    "kanji": "原告",
    "romaji": "genkoku",
    "en": "plaintiff / accuser",
    "bn": "বাদী",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1124",
    "kana": "げんご",
    "kanji": "言語",
    "romaji": "gengo",
    "en": "language",
    "bn": "ভাষা",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1125",
    "kana": "けんさ",
    "kanji": "検査",
    "romaji": "kensa",
    "en": "inspection / scan",
    "bn": "পরীক্ষা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1126",
    "kana": "げんざい",
    "kanji": "現在",
    "romaji": "genzai",
    "en": "current / present",
    "bn": "বর্তমান",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v1127",
    "kana": "けんさく",
    "kanji": "検索",
    "romaji": "kensaku",
    "en": "search / lookup",
    "bn": "সন্ধান",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1128",
    "kana": "けんしき",
    "kanji": "見識",
    "romaji": "kenshiki",
    "en": "insight / views",
    "bn": "দৃষ্টিভঙ্গি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1129",
    "kana": "げんじつ",
    "kanji": "現実",
    "romaji": "genjitsu",
    "en": "reality",
    "bn": "বাস্তবতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1130",
    "kana": "けんしゅう",
    "kanji": "研修",
    "romaji": "kenshuu",
    "en": "training / induction",
    "bn": "প্রশিক্ষণ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1131",
    "kana": "げんしゅう",
    "kanji": "減収",
    "romaji": "genshuu",
    "en": "fall in income",
    "bn": "আয় হ্রাস",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v1132",
    "kana": "けんしゅつ",
    "kanji": "検出",
    "romaji": "kenshutsu",
    "en": "detection",
    "bn": "শনাক্তকরণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1133",
    "kana": "げんじゅりょう",
    "kanji": "元受量",
    "romaji": "genjuryou",
    "en": "original amount",
    "bn": "আসল পরিমাণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1134",
    "kana": "けんしょう",
    "kanji": "検証",
    "romaji": "kenshou",
    "en": "verification",
    "bn": "যাচাইকরণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1135",
    "kana": "けんしょう",
    "kanji": "顕彰",
    "romaji": "kenshou",
    "en": "honor / public recognition",
    "bn": "সম্মাননা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1136",
    "kana": "げんしょう",
    "kanji": "現象",
    "romaji": "genshou",
    "en": "phenomenon",
    "bn": "প্রপঞ্চ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1137",
    "kana": "げんしょう",
    "kanji": "減少",
    "romaji": "genshou",
    "en": "decrease / reduction",
    "bn": "হ্রাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1138",
    "kana": "けんじょう",
    "kanji": "謙譲",
    "romaji": "kenjou",
    "en": "humility / modesty",
    "bn": "বিনয়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1139",
    "kana": "けんじょうご",
    "kanji": "謙譲語",
    "romaji": "kenjougo",
    "en": "humble language",
    "bn": "বিনম্র ভাষা",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1140",
    "kana": "けんしん",
    "kanji": "検診",
    "romaji": "kenshin",
    "en": "medical examination",
    "bn": "স্বাস্থ্য পরীক্ষা",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1141",
    "kana": "げんしん",
    "kanji": "原審",
    "romaji": "genshin",
    "en": "original trial",
    "bn": "আসল বিচার",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1142",
    "kana": "けんせい",
    "kanji": "牽制",
    "romaji": "kensei",
    "en": "check / restraint",
    "bn": "নিয়ন্ত্রণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1143",
    "kana": "けんせつ",
    "kanji": "建設",
    "romaji": "kensetsu",
    "en": "construction / establishment",
    "bn": "নির্মাণ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1144",
    "kana": "げんせつ",
    "kanji": "言説",
    "romaji": "gensetsu",
    "en": "discourse / remarks",
    "bn": "বক্তব্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1145",
    "kana": "げんぜん",
    "kanji": "厳然",
    "romaji": "genzen",
    "en": "solemn / majestic",
    "bn": "গম্ভীর",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1146",
    "kana": "けんそん",
    "kanji": "謙遜",
    "romaji": "kenson",
    "en": "humility / modest",
    "bn": "বিনয়",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1147",
    "kana": "げんそく",
    "kanji": "原則",
    "romaji": "gensoku",
    "en": "principle / rule",
    "bn": "নীতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1148",
    "kana": "げんそく",
    "kanji": "減速",
    "romaji": "gensoku",
    "en": "deceleration",
    "bn": "গতি হ্রাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1149",
    "kana": "げんぞう",
    "kanji": "現像",
    "romaji": "genzou",
    "en": "developing (film)",
    "bn": "ডেভেলপ করা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1150",
    "kana": "けんたいい",
    "kanji": "倦怠",
    "romaji": "kentai",
    "en": "fatigue / weariness",
    "bn": "ক্লান্তি",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1151",
    "kana": "けんちく",
    "kanji": "建築",
    "romaji": "kenchiku",
    "en": "architecture",
    "bn": "স্থাপত্য",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1152",
    "kana": "けんちょう",
    "kanji": "県庁",
    "romaji": "kenchou",
    "en": "prefectural office",
    "bn": "প্রাদেশিক অফিস",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1153",
    "kana": "げんてい",
    "kanji": "限定",
    "romaji": "gentei",
    "en": "limitation / strictly limited",
    "bn": "সীমাবদ্ধ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1154",
    "kana": "げんてん",
    "kanji": "原点",
    "romaji": "genten",
    "en": "origin / starting point",
    "bn": "উৎস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1155",
    "kana": "げんてん",
    "kanji": "減点",
    "romaji": "genten",
    "en": "demerit / penalty points",
    "bn": "নম্বর কাটা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1156",
    "kana": "けんど",
    "kanji": "県土",
    "romaji": "kendo",
    "en": "prefecture",
    "bn": "প্রদেশ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1157",
    "kana": "けんとう",
    "kanji": "検討",
    "romaji": "kentou",
    "en": "consideration / review",
    "bn": "বিবেচনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1158",
    "kana": "けんとう",
    "kanji": "見当",
    "romaji": "kentou",
    "en": "estimate / guess",
    "bn": "ধারণা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1159",
    "kana": "げんどうき",
    "kanji": "原動機",
    "romaji": "gendouki",
    "en": "motor / engine",
    "bn": "ইঞ্জিন",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1160",
    "kana": "けんにゅう",
    "kanji": "検入",
    "romaji": "kennyuu",
    "en": "checking in",
    "bn": "প্রবেশ পরীক্ষা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1161",
    "kana": "げんにゅう",
    "kanji": "原乳",
    "romaji": "gennyuu",
    "en": "raw milk",
    "bn": "কাঁচা দুধ",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v1162",
    "kana": "けんねん",
    "kanji": "懸念",
    "romaji": "kennen",
    "en": "concern / anxiety",
    "bn": "উদ্বেগ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1163",
    "kana": "げんば",
    "kanji": "現場",
    "romaji": "genba",
    "en": "actual spot / site",
    "bn": "ঘটনাস্থল",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1164",
    "kana": "げんぱつ",
    "kanji": "原発",
    "romaji": "genpatsu",
    "en": "nuclear power",
    "bn": "পারমাণবিক শক্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1165",
    "kana": "けんぴ",
    "kanji": "検泌",
    "romaji": "kenpi",
    "en": "urinalysis",
    "bn": "মূত্র পরীক্ষা",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1166",
    "kana": "けんふ",
    "kanji": "献付",
    "romaji": "kenfu",
    "en": "donation",
    "bn": "দান",
    "category": "money",
    "level": "N4"
  },
  {
    "id": "n4v1167",
    "kana": "げんぷ",
    "kanji": "減付",
    "romaji": "genpu",
    "en": "reduction",
    "bn": "হ্রাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1168",
    "kana": "げんぶん",
    "kanji": "原文",
    "romaji": "genbun",
    "en": "original text",
    "bn": "আসল পাঠ্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1169",
    "kana": "げんべつ",
    "kanji": "厳別",
    "romaji": "genbetsu",
    "en": "strict distinction",
    "bn": "কঠোর পার্থক্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1170",
    "kana": "けんぽ",
    "kanji": "健保",
    "romaji": "kenpo",
    "en": "health insurance",
    "bn": "স্বাস্থ্যবীমা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1171",
    "kana": "げんぽ",
    "kanji": "減歩",
    "romaji": "genpo",
    "en": "reduction in steps/size",
    "bn": "হ্রাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1172",
    "kana": "けんぽう",
    "kanji": "憲法",
    "romaji": "kenpou",
    "en": "constitution",
    "bn": "সংবিধান",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1173",
    "kana": "げんほう",
    "kanji": "減法",
    "romaji": "genhou",
    "en": "subtraction",
    "bn": "বিয়োগ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1174",
    "kana": "けんぼう",
    "kanji": "健忘",
    "romaji": "kenbou",
    "en": "forgetfulness",
    "bn": "বিস্মরণ",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1175",
    "kana": "けんま",
    "kanji": "研磨",
    "romaji": "kenma",
    "en": "grinding / polishing",
    "bn": "ঘর্ষণ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1176",
    "kana": "げんまい",
    "kanji": "玄米",
    "romaji": "genmai",
    "en": "brown rice",
    "bn": "লাল চাল",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v1177",
    "kana": "げんまく",
    "kanji": "原膜",
    "romaji": "genmaku",
    "en": "original membrane",
    "bn": "আসল পর্দা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1178",
    "kana": "けんみ",
    "kanji": "検味",
    "romaji": "kenmi",
    "en": "tasting / checking flavor",
    "bn": "স্বাদ পরীক্ষা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1179",
    "kana": "げんみ",
    "kanji": "原味",
    "romaji": "genmi",
    "en": "original flavor",
    "bn": "আসল স্বাদ",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v1180",
    "kana": "けんむ",
    "kanji": "兼務",
    "romaji": "kenmu",
    "en": "holding additional post",
    "bn": "অতিরিক্ত দায়িত্ব",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1181",
    "kana": "げんむ",
    "kanji": "厳務",
    "romaji": "genmu",
    "en": "strict service",
    "bn": "কঠোর সেবা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1182",
    "kana": "けんめい",
    "kanji": "賢明",
    "romaji": "kenmei",
    "en": "wise / sensible",
    "bn": "বিজ্ঞ",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1183",
    "kana": "けんめい",
    "kanji": "懸命",
    "romaji": "kenmei",
    "en": "eager / desperate",
    "bn": "একাগ্র",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1184",
    "kana": "げんめい",
    "kanji": "言明",
    "romaji": "genmei",
    "en": "declaration / statement",
    "bn": "ঘোষণা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1185",
    "kana": "げんめい",
    "kanji": "厳命",
    "romaji": "genmei",
    "en": "strict order",
    "bn": "কঠোর আদেশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1186",
    "kana": "けんめん",
    "kanji": "券面",
    "romaji": "kenmen",
    "en": "face of a voucher",
    "bn": "ভাউচারের দিক",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1187",
    "kana": "げんめん",
    "kanji": "減免",
    "romaji": "genmen",
    "en": "reduction and exemption",
    "bn": "হ্রাস ও অব্যাহতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1188",
    "kana": "けんもう",
    "kanji": "原毛",
    "romaji": "kenmou",
    "en": "raw wool",
    "bn": "কাঁচা উল",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1189",
    "kana": "げんもう",
    "kanji": "減耗",
    "romaji": "genmou",
    "en": "wear and tear",
    "bn": "ক্ষয়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1190",
    "kana": "けんもく",
    "kanji": "券目",
    "romaji": "kenmoku",
    "en": "ticket item",
    "bn": "টিকিট আইটেম",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1191",
    "kana": "げんもく",
    "kanji": "原目",
    "romaji": "genmoku",
    "en": "original item",
    "bn": "আসল আইটেম",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1192",
    "kana": "けんもん",
    "kanji": "検問",
    "romaji": "kenmon",
    "en": "inspection / check",
    "bn": "তদন্ত",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1193",
    "kana": "けんや",
    "kanji": "圏野",
    "romaji": "kenya",
    "en": "sphere / field",
    "bn": "ক্ষেত্র",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1194",
    "kana": "げんや",
    "kanji": "原野",
    "romaji": "genya",
    "en": "wilderness / wasteland",
    "bn": "মরুভূমি",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1195",
    "kana": "けんやく",
    "kanji": "倹約",
    "romaji": "kenyaku",
    "en": "thrift / economy",
    "bn": "মিতব্যয়িতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1196",
    "kana": "げんやく",
    "kanji": "減薬",
    "romaji": "genyaku",
    "en": "medicine reduction",
    "bn": "ওষুধ হ্রাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1197",
    "kana": "けんゆ",
    "kanji": "検油",
    "romaji": "kenyu",
    "en": "oil checking",
    "bn": "তেল পরীক্ষা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1198",
    "kana": "げんゆ",
    "kanji": "原油",
    "romaji": "genyu",
    "en": "crude oil",
    "bn": "অপরিশোধিত তেল",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1199",
    "kana": "けんゆう",
    "kanji": "賢友",
    "romaji": "kenyuu",
    "en": "wise friend",
    "bn": "বিজ্ঞ বন্ধু",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1200",
    "kana": "げんゆう",
    "kanji": "現有",
    "romaji": "genyuu",
    "en": "current possession",
    "bn": "বর্তমান দখল",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1201",
    "kana": "けんらん",
    "kanji": "絢爛",
    "romaji": "kenran",
    "en": "gorgeous / brilliant",
    "bn": "চমৎকার",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1202",
    "kana": "げんり",
    "kanji": "原理",
    "romaji": "genri",
    "en": "principle / theory",
    "bn": "নীতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1203",
    "kana": "けんり",
    "kanji": "権利",
    "romaji": "kenri",
    "en": "right / privilege",
    "bn": "অধিকার",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1204",
    "kana": "げんりょう",
    "kanji": "原料",
    "romaji": "genryou",
    "en": "raw materials",
    "bn": "কাঁচামাল",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1205",
    "kana": "げんるい",
    "kanji": "言類",
    "romaji": "genrui",
    "en": "types of speech",
    "bn": "কথা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1206",
    "kana": "けんるい",
    "kanji": "券類",
    "romaji": "kenrui",
    "en": "tickets / coupons",
    "bn": "টিকিট",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1207",
    "kana": "げんろう",
    "kanji": "元老",
    "romaji": "genrou",
    "en": "elder statesman",
    "bn": "প্রবীণ রাজনীতিবিদ",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1208",
    "kana": "げんわ",
    "kanji": "原和",
    "romaji": "genwa",
    "en": "original peace",
    "bn": "শান্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1210",
    "kana": "〜こ",
    "kanji": "〜個",
    "romaji": "-ko",
    "en": "counter for small objects",
    "bn": "ছোট জিনিসের সংখ্যা",
    "category": "counter",
    "level": "N4"
  },
  {
    "id": "n4v1211",
    "kana": "こい",
    "kanji": "恋",
    "romaji": "koi",
    "en": "love",
    "bn": "ভালোবাসা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1212",
    "kana": "こい",
    "kanji": "濃い",
    "romaji": "koi",
    "en": "thick / deep color",
    "bn": "গাঢ়",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1213",
    "kana": "こい",
    "kanji": "故意",
    "romaji": "koi",
    "en": "intention / purpose",
    "bn": "উদ্দেশ্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1214",
    "kana": "ごい",
    "kanji": "語彙",
    "romaji": "goi",
    "en": "vocabulary",
    "bn": "শব্দভাণ্ডার",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1215",
    "kana": "こいぬ",
    "kanji": "子犬",
    "romaji": "koinu",
    "en": "puppy",
    "bn": "কুকুরছানা",
    "category": "animal",
    "level": "N4"
  },
  {
    "id": "n4v1216",
    "kana": "こう",
    "kanji": "校",
    "romaji": "kou",
    "en": "school / check",
    "bn": "স্কুল",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1217",
    "kana": "ごう",
    "kanji": "号",
    "romaji": "gou",
    "en": "number / issue",
    "bn": "নম্বর",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1218",
    "kana": "こうい",
    "kanji": "行為",
    "romaji": "koui",
    "en": "act / conduct",
    "bn": "কাজ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1219",
    "kana": "こうい",
    "kanji": "好意",
    "romaji": "koui",
    "en": "goodwill / favor",
    "bn": "সদিচ্ছা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1221",
    "kana": "こうえん",
    "kanji": "講演",
    "romaji": "kouen",
    "en": "lecture / speech",
    "bn": "বক্তৃতা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1222",
    "kana": "こうか",
    "kanji": "効果",
    "romaji": "kouka",
    "en": "effect / influence",
    "bn": "প্রভাব",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1223",
    "kana": "こうか",
    "kanji": "高価",
    "romaji": "kouka",
    "en": "expensive / high price",
    "bn": "দামি",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1224",
    "kana": "こうかい",
    "kanji": "公開",
    "romaji": "koukai",
    "en": "public opening",
    "bn": "প্রকাশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1225",
    "kana": "こうかい",
    "kanji": "後悔",
    "romaji": "koukai",
    "en": "regret",
    "bn": "আক্ষেপ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1226",
    "kana": "こうかい",
    "kanji": "航海",
    "romaji": "koukai",
    "en": "voyage / sail",
    "bn": "জলযাত্রা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1227",
    "kana": "こうかく",
    "kanji": "合格",
    "romaji": "goukaku",
    "en": "passing / success",
    "bn": "সাফল্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1228",
    "kana": "こうかん",
    "kanji": "交換",
    "romaji": "koukan",
    "en": "exchange / trade",
    "bn": "বিনিময়",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1229",
    "kana": "こうき",
    "kanji": "後期",
    "romaji": "kouki",
    "en": "late period",
    "bn": "শেষ সময়",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v1230",
    "kana": "ごうき",
    "kanji": "豪気",
    "romaji": "gouki",
    "en": "stouthearted",
    "bn": "সাহসী",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1232",
    "kana": "こうぎ",
    "kanji": "抗議",
    "romaji": "kougi",
    "en": "protest / objection",
    "bn": "প্রতিবাদ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1233",
    "kana": "こうきゅう",
    "kanji": "高級",
    "romaji": "koukyuu",
    "en": "high class / luxury",
    "bn": "বিলাসবহুল",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1234",
    "kana": "こうきょ",
    "kanji": "皇居",
    "romaji": "koukyo",
    "en": "Imperial Palace",
    "bn": "রাজপ্রাসাদ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1235",
    "kana": "こうきょう",
    "kanji": "公共",
    "romaji": "koukyou",
    "en": "public / community",
    "bn": "জনসাধারণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1237",
    "kana": "こうくう",
    "kanji": "航空",
    "romaji": "koukuu",
    "en": "aviation / flying",
    "bn": "বিমানচালনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1238",
    "kana": "こうくうびん",
    "kanji": "航空便",
    "romaji": "koukuubin",
    "en": "airmail",
    "bn": "এয়ারমেইল",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1239",
    "kana": "こうけい",
    "kanji": "光景",
    "romaji": "koukei",
    "en": "scene / sight",
    "bn": "দৃশ্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1240",
    "kana": "ごうけい",
    "kanji": "合計",
    "romaji": "goukei",
    "en": "total / sum",
    "bn": "মোট",
    "category": "number",
    "level": "N4"
  },
  {
    "id": "n4v1241",
    "kana": "こうげき",
    "kanji": "攻撃",
    "romaji": "kougeki",
    "en": "attack / strike",
    "bn": "আক্রমণ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1242",
    "kana": "こうし",
    "kanji": "格子",
    "romaji": "koushi",
    "en": "lattice / grating",
    "bn": "জালি",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1243",
    "kana": "こうし",
    "kanji": "講師",
    "romaji": "koushi",
    "en": "lecturer",
    "bn": "বক্তা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1244",
    "kana": "こうじ",
    "kanji": "工事",
    "romaji": "kouji",
    "en": "construction work",
    "bn": "নির্মাণ কাজ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1245",
    "kana": "こうしき",
    "kanji": "公式",
    "romaji": "koushiki",
    "en": "official / formula",
    "bn": "আধিকারিক",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1246",
    "kana": "こうじょう",
    "kanji": "工場",
    "romaji": "koujou",
    "en": "factory",
    "bn": "কারখানা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1247",
    "kana": "こうじょう",
    "kanji": "向上",
    "romaji": "koujou",
    "en": "improvement / elevation",
    "bn": "উন্নতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1248",
    "kana": "こうしん",
    "kanji": "更新",
    "romaji": "koushin",
    "en": "update / renewal",
    "bn": "হালনাগাদ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1249",
    "kana": "こうしん",
    "kanji": "行進",
    "romaji": "koushin",
    "en": "march / parade",
    "bn": "পদযাত্রা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1250",
    "kana": "こうすい",
    "kanji": "香水",
    "romaji": "kousui",
    "en": "perfume",
    "bn": "সুগন্ধি",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1251",
    "kana": "こうずい",
    "kanji": "洪水",
    "romaji": "kouzui",
    "en": "flood",
    "bn": "বন্যা",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1252",
    "kana": "こうせい",
    "kanji": "構成",
    "romaji": "kousei",
    "en": "organization / composition",
    "bn": "গঠন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1253",
    "kana": "ごうせい",
    "kanji": "合成",
    "romaji": "gousei",
    "en": "synthesis / composition",
    "bn": "সংশ্লেষণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1254",
    "kana": "こうぜん",
    "kanji": "公然",
    "romaji": "kouzen",
    "en": "open / public",
    "bn": "প্রকাশ্য",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1255",
    "kana": "こうそう",
    "kanji": "抗争",
    "romaji": "kousou",
    "en": "strife / conflict",
    "bn": "দ্বন্দ্ব",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1256",
    "kana": "こうそう",
    "kanji": "構想",
    "romaji": "kousou",
    "en": "plan / concept",
    "bn": "পরিকল্পনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1257",
    "kana": "こうぞう",
    "kanji": "構造",
    "romaji": "kouzou",
    "en": "structure / construction",
    "bn": "গঠনশৈলী",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1258",
    "kana": "こうだい",
    "kanji": "広大",
    "romaji": "koudai",
    "en": "huge / vast",
    "bn": "বিশাল",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1259",
    "kana": "こうたい",
    "kanji": "交代 / 交替",
    "romaji": "koutai",
    "en": "alternation / change",
    "bn": "পরিবর্তন",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1260",
    "kana": "こうだん",
    "kanji": "講談",
    "romaji": "koudan",
    "en": "storytelling",
    "bn": "গল্প বলা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1261",
    "kana": "こうち",
    "kanji": "耕地",
    "romaji": "kouchi",
    "en": "arable land",
    "bn": "চাষযোগ্য জমি",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1263",
    "kana": "こうつい",
    "kanji": "好対",
    "romaji": "koutsui",
    "en": "good pair",
    "bn": "ভালো জোড়া",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1264",
    "kana": "こうつう",
    "kanji": "交通",
    "romaji": "koutsuu",
    "en": "traffic / transportation",
    "bn": "যাতায়াত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1265",
    "kana": "こうてい",
    "kanji": "肯定",
    "romaji": "koutei",
    "en": "affirmation",
    "bn": "স্বীকৃতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1266",
    "kana": "こうてい",
    "kanji": "行程",
    "romaji": "koutei",
    "en": "journey / distance",
    "bn": "যাত্রা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1267",
    "kana": "こうてい",
    "kanji": "校庭",
    "romaji": "koutei",
    "en": "campus / schoolyard",
    "bn": "স্কুলের মাঠ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1268",
    "kana": "こうてつ",
    "kanji": "鋼鉄",
    "romaji": "koutetsu",
    "en": "steel",
    "bn": "ইস্পাত",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1269",
    "kana": "こうどう",
    "kanji": "行動",
    "romaji": "koudou",
    "en": "action / conduct",
    "bn": "আচরণ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1270",
    "kana": "こうどう",
    "kanji": "講堂",
    "romaji": "koudou",
    "en": "auditorium",
    "bn": "মিলনায়তন",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1271",
    "kana": "ごうどう",
    "kanji": "合同",
    "romaji": "goudou",
    "en": "combination / union",
    "bn": "একত্রীকরণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1272",
    "kana": "こうにゅう",
    "kanji": "購入",
    "romaji": "kounyuu",
    "en": "purchase",
    "bn": "ক্রয়",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1273",
    "kana": "こうねん",
    "kanji": "後年",
    "romaji": "kounen",
    "en": "later years",
    "bn": "পরবর্তী বছরগুলো",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v1274",
    "kana": "こうはい",
    "kanji": "後輩",
    "romaji": "kouhai",
    "en": "junior",
    "bn": "জুনিয়র",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1276",
    "kana": "こうふく",
    "kanji": "幸福",
    "romaji": "koufuku",
    "en": "happiness",
    "bn": "সুখ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1277",
    "kana": "こうふく",
    "kanji": "降伏",
    "romaji": "koufuku",
    "en": "surrender",
    "bn": "আত্মসমর্পণ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1278",
    "kana": "こうぶつ",
    "kanji": "鉱物",
    "romaji": "koubutsu",
    "en": "mineral",
    "bn": "খনিজ",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1279",
    "kana": "こうへい",
    "kanji": "公平",
    "romaji": "kouhei",
    "en": "fairness / justice",
    "bn": "নিরপেক্ষতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1280",
    "kana": "こうほう",
    "kanji": "後方",
    "romaji": "kouhou",
    "en": "rear / back",
    "bn": "পেছনের দিক",
    "category": "direction",
    "level": "N4"
  },
  {
    "id": "n4v1281",
    "kana": "こうほう",
    "kanji": "公報",
    "romaji": "kouhou",
    "en": "official bulletin",
    "bn": "অফিসিয়াল বুলেটিন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1282",
    "kana": "こうほう",
    "kanji": "広報",
    "romaji": "kouhou",
    "en": "public relations",
    "bn": "জনসংযোগ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1283",
    "kana": "こうみんかん",
    "kanji": "公民館",
    "romaji": "kouminkan",
    "en": "public hall / community center",
    "bn": "কমিউনিটি সেন্টার",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1285",
    "kana": "こうめい",
    "kanji": "公明",
    "romaji": "koumei",
    "en": "just / fair",
    "bn": "ন্যায়বিচারক",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1286",
    "kana": "こうもん",
    "kanji": "校門",
    "romaji": "koumon",
    "en": "school gate",
    "bn": "স্কুলের গেট",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1287",
    "kana": "こうやく",
    "kanji": "公約",
    "romaji": "kouyaku",
    "en": "public pledge",
    "bn": "প্রতিশ্রুতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1288",
    "kana": "こうよく",
    "kanji": "好欲",
    "romaji": "kouyoku",
    "en": "greed",
    "bn": "লোভ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1289",
    "kana": "こうら",
    "kanji": "甲羅",
    "romaji": "koura",
    "en": "shell / carapace",
    "bn": "খোলস",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1290",
    "kana": "こうり",
    "kanji": "公利",
    "romaji": "kouri",
    "en": "public interest",
    "bn": "জনকল্যাণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1291",
    "kana": "こうりつ",
    "kanji": "公立",
    "romaji": "kouritsu",
    "en": "public (institution)",
    "bn": "সরকারি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1292",
    "kana": "こうりつ",
    "kanji": "効率",
    "romaji": "kouritsu",
    "en": "efficiency",
    "bn": "দক্ষতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1293",
    "kana": "こうりゅう",
    "kanji": "交流",
    "romaji": "kouryuu",
    "en": "exchange / interaction",
    "bn": "বিনিময়",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1294",
    "kana": "こうりょ",
    "kanji": "考慮",
    "romaji": "kouryo",
    "en": "consideration",
    "bn": "বিবেচনা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1295",
    "kana": "ごおり",
    "kanji": "合理",
    "romaji": "gouri",
    "en": "rationality",
    "bn": "যৌক্তিকতা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1296",
    "kana": "こうわ",
    "kanji": "講話",
    "romaji": "kouwa",
    "en": "lecture / talk",
    "bn": "বক্তৃতা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1297",
    "kana": "こうわ",
    "kanji": "好話",
    "romaji": "kouwa",
    "en": "nice story",
    "bn": "সুন্দর গল্প",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1298",
    "kana": "こきゅう",
    "kanji": "呼吸",
    "romaji": "kokyuu",
    "en": "breathing / respiration",
    "bn": "শ্বাস-প্রশ্বাস / নিঃশ্বাস",
    "category": "health",
    "level": "N4"
  },
  {
    "id": "n4v1299",
    "kana": "こきょう",
    "kanji": "故郷",
    "romaji": "kokyou",
    "en": "hometown / birthplace",
    "bn": "জন্মস্থান",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1300",
    "kana": "こくおん",
    "kanji": "刻音",
    "romaji": "kokuon",
    "en": "carved sound",
    "bn": "শব্দ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1301",
    "kana": "こくがい",
    "kanji": "国外",
    "romaji": "kokugai",
    "en": "outside the country",
    "bn": "বিদেশের বাইরে",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1303",
    "kana": "こくさいか",
    "kanji": "国際化",
    "romaji": "kokusaika",
    "en": "internationalization",
    "bn": "আন্তর্জাতিকীকরণ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1304",
    "kana": "こくじ",
    "kanji": "告示",
    "romaji": "kokuji",
    "en": "public notice",
    "bn": "জনবিজ্ঞপ্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1305",
    "kana": "こくじ",
    "kanji": "告時",
    "romaji": "kokuji",
    "en": "announcing time",
    "bn": "সময় ঘোষণা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1306",
    "kana": "こくしゅ",
    "kanji": "国酒",
    "romaji": "kokushu",
    "en": "national sake",
    "bn": "জাতীয় মদ",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v1307",
    "kana": "ごくじょう",
    "kanji": "極上",
    "romaji": "gokujou",
    "en": "first-rate / finest",
    "bn": "সেরা",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1308",
    "kana": "こくせい",
    "kanji": "国政",
    "romaji": "kokusei",
    "en": "national government",
    "bn": "জাতীয় সরকার",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1309",
    "kana": "こくせい",
    "kanji": "国勢",
    "romaji": "kokusei",
    "en": "census / national state",
    "bn": "আদমশুমারি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1310",
    "kana": "こくぜい",
    "kanji": "国税",
    "romaji": "kokuzei",
    "en": "national tax",
    "bn": "জাতীয় কর",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1311",
    "kana": "こくせき",
    "kanji": "国籍",
    "romaji": "kokuseki",
    "en": "nationality",
    "bn": "জাতীয়তা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1312",
    "kana": "こくそう",
    "kanji": "国葬",
    "romaji": "kokusou",
    "en": "state funeral",
    "bn": "রাষ্ট্রীয় সমাধি",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1313",
    "kana": "こくぞう",
    "kanji": "国造",
    "romaji": "kokuzou",
    "en": "nation building",
    "bn": "জাতি গঠন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1314",
    "kana": "こくたい",
    "kanji": "国体",
    "romaji": "kokutai",
    "en": "national structure / national essence",
    "bn": "জাতীয় কাঠামো / সারাংশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1315",
    "kana": "こくど",
    "kanji": "国土",
    "romaji": "kokudo",
    "en": "national territory",
    "bn": "জাতীয় ভূখণ্ড",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1316",
    "kana": "こくない",
    "kanji": "国内",
    "romaji": "kokunai",
    "en": "domestic / internal",
    "bn": "অভ্যন্তরীণ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1317",
    "kana": "こくなん",
    "kanji": "国難",
    "romaji": "kokunan",
    "en": "national crisis / national peril",
    "bn": "জাতীয় সংকট / বিপদ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1318",
    "kana": "こくひ",
    "kanji": "国費",
    "romaji": "kokuhi",
    "en": "national expenditure",
    "bn": "জাতীয় ব্যয়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1319",
    "kana": "こくふ",
    "kanji": "国富",
    "romaji": "kokufu",
    "en": "national wealth",
    "bn": "জাতীয় সম্পদ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1320",
    "kana": "こくふく",
    "kanji": "克服",
    "romaji": "kokufuku",
    "en": "conquest / overcome",
    "bn": "বিজয়",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1321",
    "kana": "こくぶん",
    "kanji": "国文",
    "romaji": "kokubun",
    "en": "national literature",
    "bn": "জাতীয় সাহিত্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1322",
    "kana": "こくべつ",
    "kanji": "告別",
    "romaji": "kokubetsu",
    "en": "farewell",
    "bn": "বিদায়",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1323",
    "kana": "こくほう",
    "kanji": "国宝",
    "romaji": "kokuhou",
    "en": "national treasure",
    "bn": "জাতীয় রত্ন",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1324",
    "kana": "こくぼう",
    "kanji": "国防",
    "romaji": "kokubou",
    "en": "national defense",
    "bn": "জাতীয় প্রতিরক্ষা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1325",
    "kana": "こくみん",
    "kanji": "国民",
    "romaji": "kokumin",
    "en": "national / people",
    "bn": "জনগণ",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1326",
    "kana": "こくむ",
    "kanji": "国務",
    "romaji": "kokumu",
    "en": "national affairs / state affairs",
    "bn": "জাতীয় বিষয়াবলী / বিষয়াবলী",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1327",
    "kana": "こくめい",
    "kanji": "国名",
    "romaji": "kokumei",
    "en": "country name",
    "bn": "দেশের নাম",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1328",
    "kana": "こくめい",
    "kanji": "克明",
    "romaji": "kokumei",
    "en": "detailed / conscientious / conscientious / detailed",
    "bn": "বিস্তারিত",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1329",
    "kana": "こくゆう",
    "kanji": "国有",
    "romaji": "kokuyuu",
    "en": "national ownership",
    "bn": "জাতীয় মালিকানা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1330",
    "kana": "こくよう",
    "kanji": "国用",
    "romaji": "kokuyou",
    "en": "national use",
    "bn": "জাতীয় ব্যবহার",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1331",
    "kana": "こくりつ",
    "kanji": "国立",
    "romaji": "kokuritsu",
    "en": "national (e.g. library) / national (inst.)",
    "bn": "জাতীয় / জাতীয়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1332",
    "kana": "こくりつこうえん",
    "kanji": "国立公園",
    "romaji": "kokuritsu kouen",
    "en": "national park",
    "bn": "জাতীয় উদ্যান",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1333",
    "kana": "ごくりょく",
    "kanji": "国力",
    "romaji": "gokuryoku",
    "en": "national power",
    "bn": "জাতীয় শক্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1334",
    "kana": "こくれん",
    "kanji": "国連",
    "romaji": "kokuren",
    "en": "United Nations / UN",
    "bn": "জাতিসংঘ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1335",
    "kana": "ここ",
    "kanji": "個個",
    "romaji": "koko",
    "en": "one by one / individual / individual / one by one",
    "bn": "প্রত্যেক / ব্যক্তিগত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1336",
    "kana": "ごこ",
    "kanji": "後五",
    "romaji": "goko",
    "en": "after 5 / after five",
    "bn": "৫ টার পর / পাঁচটার পর",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v1337",
    "kana": "こご",
    "kanji": "古語",
    "romaji": "kogo",
    "en": "archaic word",
    "bn": "প্রাচীন শব্দ",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1338",
    "kana": "こう",
    "kanji": "乞う",
    "romaji": "kou",
    "en": "to beg / request",
    "bn": "ভিক্ষা করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1340",
    "kana": "こく",
    "kanji": "酷",
    "romaji": "koku",
    "en": "severe / cruel",
    "bn": "নিষ্ঠুর",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1341",
    "kana": "こく",
    "kanji": "告",
    "romaji": "koku",
    "en": "revelation",
    "bn": "প্রকাশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1342",
    "kana": "こぐ",
    "kanji": "漕ぐ",
    "romaji": "kogu",
    "en": "to row / pedal",
    "bn": "বৈঠা চালানো",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1343",
    "kana": "こくう",
    "kanji": "虚空",
    "romaji": "kokuu",
    "en": "empty space",
    "bn": "শূন্যস্থান",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1344",
    "kana": "こくう",
    "kanji": "穀雨",
    "romaji": "kokuu",
    "en": "grain rain",
    "bn": "বৃষ্টি",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1345",
    "kana": "こくう",
    "kanji": "国運",
    "romaji": "kokuun",
    "en": "national fortune",
    "bn": "জাতীয় ভাগ্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1346",
    "kana": "こくえい",
    "kanji": "国営",
    "romaji": "kokuei",
    "en": "state-run",
    "bn": "রাষ্ট্রীয় পরিচালিত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1347",
    "kana": "こくえい",
    "kanji": "国影",
    "romaji": "kokuei",
    "en": "national shadow",
    "bn": "ছায়া",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1348",
    "kana": "こくえん",
    "kanji": "黒鉛",
    "romaji": "kokuen",
    "en": "graphite",
    "bn": "গ্রাফাইট",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1349",
    "kana": "こくえん",
    "kanji": "国縁",
    "romaji": "kokuen",
    "en": "national fate",
    "bn": "ভাগ্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1350",
    "kana": "こくえん",
    "kanji": "国宴",
    "romaji": "kokuen",
    "en": "national banquet",
    "bn": "ভোজ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1351",
    "kana": "ごくおう",
    "kanji": "国王",
    "romaji": "gokuou",
    "en": "king",
    "bn": "রাজা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1352",
    "kana": "こくお",
    "kanji": "国汚",
    "romaji": "kokuo",
    "en": "national stain",
    "bn": "কলঙ্ক",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1353",
    "kana": "こくぎ",
    "kanji": "国技",
    "romaji": "kokugi",
    "en": "national sport",
    "bn": "জাতীয় খেলা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1354",
    "kana": "こくぎ",
    "kanji": "国議",
    "romaji": "kokugi",
    "en": "national council",
    "bn": "জাতীয় পরিষদ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1355",
    "kana": "こくき",
    "kanji": "国旗",
    "romaji": "kokuki",
    "en": "national flag",
    "bn": "জাতীয় পতাকা",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1356",
    "kana": "こくぎ",
    "kanji": "国義",
    "romaji": "kokugi",
    "en": "national righteousness",
    "bn": "ন্যায়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1357",
    "kana": "ごくき",
    "kanji": "極期",
    "romaji": "gokuki",
    "en": "climax / peak period",
    "bn": "চূড়ান্ত সময়",
    "category": "time",
    "level": "N4"
  },
  {
    "id": "n4v1358",
    "kana": "こくぐ",
    "kanji": "国具",
    "romaji": "kokugu",
    "en": "national tool",
    "bn": "যন্ত্রপাতি",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1359",
    "kana": "こぐし",
    "kanji": "小串",
    "romaji": "kogushi",
    "en": "small skewer",
    "bn": "শিক",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1360",
    "kana": "こくし",
    "kanji": "国史",
    "romaji": "kokushi",
    "en": "national history",
    "bn": "জাতীয় ইতিহাস",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1361",
    "kana": "こくしつ",
    "kanji": "国質",
    "romaji": "kokushitsu",
    "en": "national quality",
    "bn": "মান",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1362",
    "kana": "こくしゃ",
    "kanji": "国者",
    "romaji": "kokusha",
    "en": "patriot",
    "bn": "দেশপ্রেমিক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1363",
    "kana": "こくしゅ",
    "kanji": "国主",
    "romaji": "kokushu",
    "en": "ruler of a country",
    "bn": "শাসক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1364",
    "kana": "こくしょ",
    "kanji": "国書",
    "romaji": "kokusho",
    "en": "credentials / national literature",
    "bn": "জাতীয় সাহিত্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1365",
    "kana": "ごくしょ",
    "kanji": "極暑",
    "romaji": "gokusho",
    "en": "extreme heat",
    "bn": "প্রচণ্ড গরম",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1366",
    "kana": "こくじょ",
    "kanji": "国助",
    "romaji": "kokujo",
    "en": "national aid",
    "bn": "সাহায্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1367",
    "kana": "こくしん",
    "kanji": "国心",
    "romaji": "kokushin",
    "en": "national heart",
    "bn": "হৃদয়",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1368",
    "kana": "ごくしん",
    "kanji": "極親",
    "romaji": "gokushin",
    "en": "closest relative",
    "bn": "নিকট আত্মীয়",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1369",
    "kana": "ごくじわ",
    "kanji": "極皺",
    "romaji": "gokujiwa",
    "en": "very wrinkled",
    "bn": "কুঁচকানো",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1370",
    "kana": "こくすい",
    "kanji": "国粋",
    "romaji": "kokusui",
    "en": "national characteristics",
    "bn": "বৈশিষ্ট্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1371",
    "kana": "こくすう",
    "kanji": "国数",
    "romaji": "kokusuu",
    "en": "national numbers",
    "bn": "সংখ্যা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1372",
    "kana": "こくせい",
    "kanji": "国声",
    "romaji": "kokusei",
    "en": "national voice",
    "bn": "কণ্ঠস্বর",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1373",
    "kana": "こくそ",
    "kanji": "告訴",
    "romaji": "kokuso",
    "en": "complaint / accusation",
    "bn": "অভিযোগ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1374",
    "kana": "こくそ",
    "kanji": "国祖",
    "romaji": "kokuso",
    "en": "founder of a nation",
    "bn": "প্রতিষ্ঠাতা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1375",
    "kana": "こくそう",
    "kanji": "穀倉",
    "romaji": "kokusou",
    "en": "granary",
    "bn": "গোলাঘর",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1376",
    "kana": "こくぞく",
    "kanji": "国賊",
    "romaji": "kokuzoku",
    "en": "traitor",
    "bn": "দেশদ্রোহী",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1378",
    "kana": "ごくたい",
    "kanji": "極太",
    "romaji": "gokutai",
    "en": "very thick",
    "bn": "খুব মোটা",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1379",
    "kana": "こくだん",
    "kanji": "国断",
    "romaji": "kokudan",
    "en": "national decision",
    "bn": "সিদ্ধান্ত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1380",
    "kana": "こくち",
    "kanji": "告知",
    "romaji": "kokuchi",
    "en": "notice / announcement",
    "bn": "ঘোষণা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1381",
    "kana": "こくち",
    "kanji": "国知",
    "romaji": "kokuchi",
    "en": "national knowledge",
    "bn": "জ্ঞান",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1382",
    "kana": "こくつ",
    "kanji": "告通",
    "romaji": "kokutsu",
    "en": "notification",
    "bn": "বিজ্ঞপ্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1383",
    "kana": "こくてい",
    "kanji": "国定",
    "romaji": "kokutei",
    "en": "state-prescribed",
    "bn": "নির্ধারিত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1384",
    "kana": "こくてつ",
    "kanji": "国鉄",
    "romaji": "kokutetsu",
    "en": "national railway",
    "bn": "জাতীয় রেলপথ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1385",
    "kana": "こくど",
    "kanji": "刻度",
    "romaji": "kokudo",
    "en": "scale / graduation",
    "bn": "পরিমাপক",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1386",
    "kana": "こくとう",
    "kanji": "黒糖",
    "romaji": "kokutou",
    "en": "brown sugar",
    "bn": "লাল চিনি",
    "category": "food",
    "level": "N4"
  },
  {
    "id": "n4v1387",
    "kana": "こくどう",
    "kanji": "国道",
    "romaji": "kokudou",
    "en": "national highway",
    "bn": "জাতীয় মহাসড়ক",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1388",
    "kana": "こくどく",
    "kanji": "国読",
    "romaji": "kokudoku",
    "en": "national reading",
    "bn": "পড়া",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1390",
    "kana": "こくねい",
    "kanji": "国寧",
    "romaji": "kokunei",
    "en": "national peace",
    "bn": "শান্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1391",
    "kana": "こくは",
    "kanji": "国旗",
    "romaji": "kokuha",
    "en": "national flag",
    "bn": "পতাকা",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1392",
    "kana": "こくは",
    "kanji": "告白",
    "romaji": "kokuhaku",
    "en": "confession",
    "bn": "স্বীকারোক্তি",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1393",
    "kana": "こくばん",
    "kanji": "黒板",
    "romaji": "kokuban",
    "en": "blackboard",
    "bn": "ব্ল্যাকবোর্ড",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1394",
    "kana": "こくび",
    "kanji": "国美",
    "romaji": "kokubi",
    "en": "national beauty",
    "bn": "সৌন্দর্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1395",
    "kana": "こくひ",
    "kanji": "谷比",
    "romaji": "kokuhi",
    "en": "valley ratio",
    "bn": "অনুপাত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1396",
    "kana": "こくふ",
    "kanji": "告付",
    "romaji": "kokufu",
    "en": "notice",
    "bn": "নোটিশ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1398",
    "kana": "こくへい",
    "kanji": "国平",
    "romaji": "kokuhei",
    "en": "national peace",
    "bn": "শান্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1401",
    "kana": "こくみ",
    "kanji": "国味",
    "romaji": "kokumi",
    "en": "national taste",
    "bn": "স্বাদ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1403",
    "kana": "こくみんせい",
    "kanji": "国民性",
    "romaji": "kokuminsei",
    "en": "national character",
    "bn": "চরিত্র",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1407",
    "kana": "こくもん",
    "kanji": "国門",
    "romaji": "kokumon",
    "en": "national gate",
    "bn": "ফটক",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1408",
    "kana": "こくや",
    "kanji": "国野",
    "romaji": "kokuya",
    "en": "national field",
    "bn": "মাঠ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1409",
    "kana": "こくゆ",
    "kanji": "国輸",
    "romaji": "kokuyu",
    "en": "national transport",
    "bn": "পরিবহন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1412",
    "kana": "こくら",
    "kanji": "小倉",
    "romaji": "kokura",
    "en": "small granary / Kokura (place)",
    "bn": "গোলাঘর",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1413",
    "kana": "こくり",
    "kanji": "国利",
    "romaji": "kokuri",
    "en": "national interest",
    "bn": "স্বার্থ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1415",
    "kana": "こくりん",
    "kanji": "国隣",
    "romaji": "kokurin",
    "en": "neighboring country",
    "bn": "প্রতিবেশী",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1416",
    "kana": "こくりょく",
    "kanji": "国力",
    "romaji": "kokuryoku",
    "en": "national power",
    "bn": "শক্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1418",
    "kana": "こくろ",
    "kanji": "国路",
    "romaji": "kokuro",
    "en": "national road",
    "bn": "রাস্তা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1419",
    "kana": "こくわ",
    "kanji": "国話",
    "romaji": "kokuwa",
    "en": "national talk",
    "bn": "আলাপ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1420",
    "kana": "こくん",
    "kanji": "国運",
    "romaji": "kokun",
    "en": "national fate",
    "bn": "ভাগ্য",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1421",
    "kana": "こげ",
    "kanji": "焦げ",
    "romaji": "koge",
    "en": "burning / scorching",
    "bn": "পোড়া",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1422",
    "kana": "こげちゃ",
    "kanji": "焦げ茶",
    "romaji": "kogecha",
    "en": "dark brown",
    "bn": "গাঢ় বাদামী",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1423",
    "kana": "こげる",
    "kanji": "焦げる",
    "romaji": "kogeru",
    "en": "to burn / scorch",
    "bn": "পুড়ে যাওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1427",
    "kana": "こご",
    "kanji": "口語",
    "romaji": "kougo",
    "en": "spoken language",
    "bn": "ভাষা",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1429",
    "kana": "こごえ",
    "kanji": "小声",
    "romaji": "kogoe",
    "en": "low voice / whisper",
    "bn": "নিচু কণ্ঠ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1430",
    "kana": "こごえる",
    "kanji": "凍える",
    "romaji": "kogoeru",
    "en": "to freeze",
    "bn": "জমে যাওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1432",
    "kana": "こころあたり",
    "kanji": "心当たり",
    "romaji": "kokoroatari",
    "en": "having some idea",
    "bn": "ধারণা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1433",
    "kana": "こころえ",
    "kanji": "心得",
    "romaji": "kokoroe",
    "en": "knowledge / rules",
    "bn": "জ্ঞান",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1434",
    "kana": "こころえる",
    "kanji": "心得点",
    "romaji": "kokoroeru",
    "en": "to know / understand",
    "bn": "বোঝা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1435",
    "kana": "こころがけ",
    "kanji": "心がけ",
    "romaji": "kokorogake",
    "en": "attitude / attention",
    "bn": "মনোযোগ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1436",
    "kana": "こころがける",
    "kanji": "心がける",
    "romaji": "kokorogakeru",
    "en": "to bear in mind",
    "bn": "মনে রাখা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1437",
    "kana": "こころざし",
    "kanji": "志",
    "romaji": "kokorozashi",
    "en": "will / intention",
    "bn": "ইচ্ছা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1438",
    "kana": "こころざす",
    "kanji": "志す",
    "romaji": "kokorozasu",
    "en": "to aim at",
    "bn": "লক্ষ্য করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1439",
    "kana": "こころざし",
    "kanji": "心指し",
    "romaji": "kokorozashi",
    "en": "ambition",
    "bn": "উচ্চাকাঙ্ক্ষা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1440",
    "kana": "こころ強い",
    "kanji": "心強い",
    "romaji": "kokorozuyoi",
    "en": "reassuring / heartening",
    "bn": "আশ্বাসদায়ক",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1441",
    "kana": "こころぼそい",
    "kanji": "心細い",
    "romaji": "kokorobosoi",
    "en": "helpless / lonely",
    "bn": "অসহায়",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1442",
    "kana": "こころみ",
    "kanji": "試み",
    "romaji": "kokoromi",
    "en": "trial / attempt",
    "bn": "চেষ্টা",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1443",
    "kana": "こころみる",
    "kanji": "試みる",
    "romaji": "kokoromiru",
    "en": "to try / attempt",
    "bn": "চেষ্টা করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1444",
    "kana": "こころもち",
    "kanji": "心持ち",
    "romaji": "kokoromochi",
    "en": "feeling / state of mind",
    "bn": "অনুভূতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1445",
    "kana": "こころゆく",
    "kanji": "心行く",
    "romaji": "kokoroyuku",
    "en": "to one's heart's content",
    "bn": "মন ভরে",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1446",
    "kana": "こざ",
    "kanji": "御座",
    "romaji": "koza",
    "en": "mat",
    "bn": "পাটি",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1447",
    "kana": "こさい",
    "kanji": "湖彩",
    "romaji": "kosai",
    "en": "lake colors",
    "bn": "রঙ",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1448",
    "kana": "こさく",
    "kanji": "小作",
    "romaji": "kosaku",
    "en": "tenant farming",
    "bn": "চাষ",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1449",
    "kana": "こさげ",
    "kanji": "小下げ",
    "romaji": "kosage",
    "en": "small drop",
    "bn": "পতন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1450",
    "kana": "こざかい",
    "kanji": "小境",
    "romaji": "kozakai",
    "en": "small boundary",
    "bn": "সীমানা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1451",
    "kana": "こざっぱり",
    "kanji": "小っぱり",
    "romaji": "kozappari",
    "en": "neat / tidy",
    "bn": "পরিপাটি",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1452",
    "kana": "こざめ",
    "kanji": "小雨",
    "romaji": "kozame",
    "en": "light rain / drizzle",
    "bn": "ঝিরঝিরে বৃষ্টি",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1453",
    "kana": "こざる",
    "kanji": "小猿",
    "romaji": "kozaru",
    "en": "baby monkey",
    "bn": "বানরের বাচ্চা",
    "category": "animal",
    "level": "N4"
  },
  {
    "id": "n4v1455",
    "kana": "こしかけ",
    "kanji": "腰掛け",
    "romaji": "koshikake",
    "en": "seat / chair",
    "bn": "আসন",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1456",
    "kana": "こしかける",
    "kanji": "腰掛ける",
    "romaji": "koshikakeru",
    "en": "to sit down",
    "bn": "বসা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1457",
    "kana": "こしき",
    "kanji": "古式",
    "romaji": "koshiki",
    "en": "ancient style",
    "bn": "প্রাচীন রীতি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1458",
    "kana": "こしつ",
    "kanji": "個室",
    "romaji": "koshitsu",
    "en": "private room",
    "bn": "ব্যক্তিগত কক্ষ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1459",
    "kana": "こしつ",
    "kanji": "固執",
    "romaji": "koshitsu",
    "en": "persistence / stubbornness",
    "bn": "একগুঁয়েমি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1460",
    "kana": "こしぬけ",
    "kanji": "腰抜け",
    "romaji": "koshinuke",
    "en": "coward",
    "bn": "কাপুরুষ",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1461",
    "kana": "こしらえ",
    "kanji": "拵え",
    "romaji": "koshirae",
    "en": "preparation / making",
    "bn": "প্রস্তুতি",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1462",
    "kana": "こしらえる",
    "kanji": "拵える",
    "romaji": "koshiraeru",
    "en": "to make / prepare",
    "bn": "তৈরি করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1463",
    "kana": "こしん",
    "kanji": "個人",
    "romaji": "koshin",
    "en": "individual",
    "bn": "ব্যক্তি",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1464",
    "kana": "こす",
    "kanji": "超す",
    "romaji": "kosu",
    "en": "to cross / pass",
    "bn": "অতিক্রম করা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1465",
    "kana": "こす",
    "kanji": "越す",
    "romaji": "kosu",
    "en": "to go across",
    "bn": "পার হওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1466",
    "kana": "こすい",
    "kanji": "湖水",
    "romaji": "kosui",
    "en": "lake water",
    "bn": "হ্রদের জল",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1467",
    "kana": "こすう",
    "kanji": "個数",
    "romaji": "kosuu",
    "en": "number of items",
    "bn": "সংখ্যা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1468",
    "kana": "こする",
    "kanji": "擦る",
    "romaji": "kosuru",
    "en": "to rub / scrub",
    "bn": "ঘষা",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1469",
    "kana": "こぜに",
    "kanji": "小銭",
    "romaji": "kozeni",
    "en": "small change / coins",
    "bn": "খুচরো পয়সা",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1470",
    "kana": "こそ",
    "kanji": "古曾",
    "romaji": "koso",
    "en": "emphasis particle",
    "bn": "জোর দেওয়া",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1471",
    "kana": "こそあど",
    "kanji": "何其彼此",
    "romaji": "kosoado",
    "en": "demonstrative words",
    "bn": "নির্দেশক শব্দ",
    "category": "language",
    "level": "N4"
  },
  {
    "id": "n4v1472",
    "kana": "こそだて",
    "kanji": "子育て",
    "romaji": "kosodate",
    "en": "child rearing",
    "bn": "সন্তান লালন",
    "category": "activity",
    "level": "N4"
  },
  {
    "id": "n4v1473",
    "kana": "こそだち",
    "kanji": "子育ち",
    "romaji": "kosodachi",
    "en": "growing up child",
    "bn": "সন্তান বেড়ে ওঠা",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1474",
    "kana": "こそこそ",
    "kanji": "隠れ隠れ",
    "romaji": "kosokoso",
    "en": "secretly / sneakily",
    "bn": "লুকিয়ে",
    "category": "adverb",
    "level": "N4"
  },
  {
    "id": "n4v1475",
    "kana": "こぞって",
    "kanji": "挙って",
    "romaji": "kozotte",
    "en": "all together / unanimously",
    "bn": "একযোগে",
    "category": "adverb",
    "level": "N4"
  },
  {
    "id": "n4v1476",
    "kana": "こぞう",
    "kanji": "小僧",
    "romaji": "kozou",
    "en": "young monk / boy",
    "bn": "বালক",
    "category": "people",
    "level": "N4"
  },
  {
    "id": "n4v1477",
    "kana": "こたい",
    "kanji": "固体",
    "romaji": "kotai",
    "en": "solid (body)",
    "bn": "কঠিন",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1480",
    "kana": "ごたごた",
    "kanji": "混雑",
    "romaji": "gotagota",
    "en": "confusion / trouble",
    "bn": "ঝামেলা",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1481",
    "kana": "こたつ",
    "kanji": "火燵",
    "romaji": "kotatsu",
    "en": "heated table",
    "bn": "উত্তপ্ত টেবিল",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1482",
    "kana": "こだち",
    "kanji": "木立",
    "romaji": "kodachi",
    "en": "grove of trees",
    "bn": "বন",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1483",
    "kana": "こだわる",
    "kanji": "拘る",
    "romaji": "kodawaru",
    "en": "to be fussy about",
    "bn": "খুঁতখুঁতে হওয়া",
    "category": "verb",
    "level": "N4"
  },
  {
    "id": "n4v1484",
    "kana": "こたん",
    "kanji": "枯淡",
    "romaji": "kotan",
    "en": "simple and elegant",
    "bn": "সাধারণ",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1485",
    "kana": "こち",
    "kanji": "東風",
    "romaji": "kochi",
    "en": "east wind",
    "bn": "পূবালী বাতাস",
    "category": "nature",
    "level": "N4"
  },
  {
    "id": "n4v1486",
    "kana": "こちら",
    "kanji": "此方",
    "romaji": "kochira",
    "en": "this way / here",
    "bn": "এই দিকে",
    "category": "direction",
    "level": "N4"
  },
  {
    "id": "n4v1487",
    "kana": "こちょう",
    "kanji": "胡蝶",
    "romaji": "kochou",
    "en": "butterfly",
    "bn": "প্রজাপতি",
    "category": "animal",
    "level": "N4"
  },
  {
    "id": "n4v1488",
    "kana": "こちょう",
    "kanji": "誇張",
    "romaji": "kochou",
    "en": "exaggeration",
    "bn": "অত্যুক্তি",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1489",
    "kana": "こちこち",
    "kanji": "刻刻",
    "romaji": "kochikochi",
    "en": "tick-tock / stiff",
    "bn": "টিক টিক",
    "category": "adverb",
    "level": "N4"
  },
  {
    "id": "n4v1490",
    "kana": "こっか",
    "kanji": "国家",
    "romaji": "kokka",
    "en": "state / nation",
    "bn": "রাষ্ট্র",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1491",
    "kana": "こっか",
    "kanji": "国歌",
    "romaji": "kokka",
    "en": "national anthem",
    "bn": "জাতীয় সঙ্গীত",
    "category": "abstract",
    "level": "N4"
  },
  {
    "id": "n4v1492",
    "kana": "こっかい",
    "kanji": "国会",
    "romaji": "kokkai",
    "en": "National Diet / Parliament",
    "bn": "সংসদ",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1493",
    "kana": "こっかく",
    "kanji": "骨格",
    "romaji": "kokkaku",
    "en": "skeleton / structure",
    "bn": "কঙ্কাল",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v1494",
    "kana": "こっき",
    "kanji": "国旗",
    "romaji": "kokki",
    "en": "national flag",
    "bn": "জাতীয় পতাকা",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "n4v1495",
    "kana": "こっきょう",
    "kanji": "国境",
    "romaji": "kokkyou",
    "en": "national border",
    "bn": "সীমানা",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1496",
    "kana": "こっけい",
    "kanji": "滑稽",
    "romaji": "kokkei",
    "en": "funny / humorous",
    "bn": "হাস্যকর",
    "category": "adjective",
    "level": "N4"
  },
  {
    "id": "n4v1497",
    "kana": "こっこ",
    "kanji": "国庫",
    "romaji": "kokko",
    "en": "national treasury",
    "bn": "কোষাগার",
    "category": "place",
    "level": "N4"
  },
  {
    "id": "n4v1498",
    "kana": "こっさき",
    "kanji": "骨先",
    "romaji": "kossaki",
    "en": "bone tip",
    "bn": "হাড়ের ডগা",
    "category": "body",
    "level": "N4"
  },
  {
    "id": "n4v1499",
    "kana": "こっそり",
    "kanji": "隠れ",
    "romaji": "kossori",
    "en": "stealthily / quietly",
    "bn": "চুপিসারে",
    "category": "adverb",
    "level": "N4"
  },
  {
    "id": "n4v1500",
    "kana": "こっとう",
    "kanji": "骨董",
    "romaji": "kottou",
    "en": "antique",
    "bn": "প্রাচীন বস্তু",
    "category": "object",
    "level": "N4"
  },
  {
    "id": "dv003",
    "kana": "ぴんく",
    "kanji": null,
    "romaji": "pinku",
    "en": "pink",
    "bn": "গোলাপী",
    "category": "colors"
  },
  {
    "id": "dv004",
    "kana": "はいいろ",
    "kanji": "灰色",
    "romaji": "haiiro",
    "en": "gray",
    "bn": "ধূসর",
    "category": "colors"
  },
  {
    "id": "dv005",
    "kana": "ちゃいろ",
    "kanji": "茶色",
    "romaji": "chairo",
    "en": "brown",
    "bn": "বাদামী",
    "category": "colors"
  },
  {
    "id": "dv006",
    "kana": "むらさき",
    "kanji": "紫色",
    "romaji": "murasaki",
    "en": "purple",
    "bn": "বেগুনী",
    "category": "colors"
  },
  {
    "id": "dv008",
    "kana": "おれんじ",
    "kanji": null,
    "romaji": "orenji",
    "en": "orange",
    "bn": "কমলা",
    "category": "colors"
  },
  {
    "id": "dv009",
    "kana": "きんいろ",
    "kanji": "金色",
    "romaji": "kiniro",
    "en": "gold",
    "bn": "সোনালী",
    "category": "colors"
  },
  {
    "id": "dv010",
    "kana": "ぎんいろ",
    "kanji": "銀色",
    "romaji": "giniro",
    "en": "silver",
    "bn": "রূপালী",
    "category": "colors"
  },
  {
    "id": "dv011",
    "kana": "そ",
    "kanji": "象",
    "romaji": "zou",
    "en": "elephant",
    "bn": "হাতি",
    "category": "nature"
  },
  {
    "id": "dv012",
    "kana": "らいおん",
    "kanji": "ライオン",
    "romaji": "raion",
    "en": "lion",
    "bn": "সিংহ",
    "category": "nature"
  },
  {
    "id": "dv013",
    "kana": "とら",
    "kanji": "虎",
    "romaji": "tora",
    "en": "tiger",
    "bn": "বাঘ",
    "category": "nature"
  },
  {
    "id": "dv014",
    "kana": "きりん",
    "kanji": "麒麟",
    "romaji": "kirin",
    "en": "giraffe",
    "bn": "জিরাফ",
    "category": "nature"
  },
  {
    "id": "dv015",
    "kana": "さる",
    "kanji": "猿",
    "romaji": "saru",
    "en": "monkey",
    "bn": "বানর",
    "category": "nature"
  },
  {
    "id": "dv016",
    "kana": "にじ",
    "kanji": "虹",
    "romaji": "niji",
    "en": "rainbow",
    "bn": "রংধনু",
    "category": "nature"
  },
  {
    "id": "dv017",
    "kana": "かみなり",
    "kanji": "雷",
    "romaji": "kaminari",
    "en": "thunder / lightning",
    "bn": "বজ্রপাত",
    "category": "nature"
  },
  {
    "id": "dv018",
    "kana": "きり",
    "kanji": "霧",
    "romaji": "kiri",
    "en": "fog / mist",
    "bn": "কুয়াশা",
    "category": "nature"
  },
  {
    "id": "dv019",
    "kana": "ほし",
    "kanji": "星",
    "romaji": "hoshi",
    "en": "star",
    "bn": "তারা",
    "category": "nature"
  },
  {
    "id": "dv020",
    "kana": "つき",
    "kanji": "月",
    "romaji": "tsuki",
    "en": "moon",
    "bn": "চাঁদ",
    "category": "nature"
  },
  {
    "id": "dv022",
    "kana": "でんしれんじ",
    "kanji": "電子レンジ",
    "romaji": "denshirenji",
    "en": "microwave",
    "bn": "মাইক্রোওয়েভ",
    "category": "objects"
  },
  {
    "id": "dv023",
    "kana": "そうじき",
    "kanji": "掃除機",
    "romaji": "soujiki",
    "en": "vacuum cleaner",
    "bn": "ভ্যাকুয়াম ক্লিনার",
    "category": "objects"
  },
  {
    "id": "dv024",
    "kana": "ぱそこん",
    "kanji": "パソコン",
    "romaji": "pasokon",
    "en": "PC / laptop / computer",
    "bn": "কম্পিউটার",
    "category": "objects"
  },
  {
    "id": "dv025",
    "kana": "すまほ",
    "kanji": "スマホ",
    "romaji": "sumaho",
    "en": "smartphone",
    "bn": "স্মার্টফোন",
    "category": "objects"
  },
  {
    "id": "dv026",
    "kana": "じゅうでんき",
    "kanji": "充電器",
    "romaji": "juudenki",
    "en": "charger",
    "bn": "চার্জার",
    "category": "objects"
  },
  {
    "id": "dv027",
    "kana": "りもこん",
    "kanji": "リモコン",
    "romaji": "rimokon",
    "en": "remote control",
    "bn": "রিমোট",
    "category": "objects"
  },
  {
    "id": "dv028",
    "kana": "せんぷうき",
    "kanji": "扇風機",
    "romaji": "senpuuki",
    "en": "electric fan",
    "bn": "ফ্যান",
    "category": "objects"
  },
  {
    "id": "dv029",
    "kana": "えあこん",
    "kanji": "エアコン",
    "romaji": "eakon",
    "en": "air conditioner",
    "bn": "এসি",
    "category": "objects"
  },
  {
    "id": "dv030",
    "kana": "せんたくき",
    "kanji": "洗濯機",
    "romaji": "sentakuki",
    "en": "washing machine",
    "bn": "ওয়াশিং মেশিন",
    "category": "objects"
  },
  {
    "id": "dv031",
    "kana": "はをみがく",
    "kanji": "歯を磨く",
    "romaji": "ha o migaku",
    "en": "to brush teeth",
    "bn": "দাঁত মাজা",
    "category": "verbs"
  },
  {
    "id": "dv032",
    "kana": "かおをあらう",
    "kanji": "顔を洗う",
    "romaji": "kao o arau",
    "en": "to wash face",
    "bn": "মুখ ধোয়া",
    "category": "verbs"
  },
  {
    "id": "dv033",
    "kana": "おふろにはいる",
    "kanji": "お風呂に入る",
    "romaji": "ofuro ni hairu",
    "en": "to take a bath",
    "bn": "গোসল করা",
    "category": "verbs"
  },
  {
    "id": "dv034",
    "kana": "りょうりする",
    "kanji": "料理する",
    "romaji": "ryouri suru",
    "en": "to cook",
    "bn": "রান্না করা",
    "category": "verbs"
  },
  {
    "id": "dv035",
    "kana": "じゅんびする",
    "kanji": "準備する",
    "romaji": "junbi suru",
    "en": "to prepare",
    "bn": "প্রস্তুত করা",
    "category": "verbs"
  },
  {
    "kana": "あか",
    "kanji": "赤",
    "romaji": "aka",
    "en": "red",
    "bn": "লাল",
    "level": "",
    "category": "colors"
  },
  {
    "kana": "あお",
    "kanji": "青",
    "romaji": "ao",
    "en": "blue",
    "bn": "নীল",
    "level": "",
    "category": "colors"
  },
  {
    "kana": "むらさき",
    "kanji": "紫",
    "romaji": "murasaki",
    "en": "purple",
    "bn": "বেগুনি",
    "level": "",
    "category": "colors"
  },
  {
    "kana": "ぴんく",
    "kanji": "ピンク",
    "romaji": "pinku",
    "en": "pink",
    "bn": "গোলাপী",
    "level": "",
    "category": "colors"
  },
  {
    "kana": "おれんじ",
    "kanji": "オレンジ",
    "romaji": "orenji",
    "en": "orange",
    "bn": "কমলা",
    "level": "",
    "category": "colors"
  },
  {
    "kana": "ぞう",
    "kanji": "象",
    "romaji": "zou",
    "en": "elephant",
    "bn": "হাতি",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "へび",
    "kanji": "蛇",
    "romaji": "hebi",
    "en": "snake",
    "bn": "সাপ",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "うま",
    "kanji": "馬",
    "romaji": "uma",
    "en": "horse",
    "bn": "ঘোড়া",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "うし",
    "kanji": "牛",
    "romaji": "ushi",
    "en": "cow",
    "bn": "গরু",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "ぶた",
    "kanji": "豚",
    "romaji": "buta",
    "en": "pig",
    "bn": "শূকর",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "やぎ",
    "kanji": "山羊",
    "romaji": "yagi",
    "en": "goat",
    "bn": "ছাগল",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "うさぎ",
    "kanji": "兎",
    "romaji": "usagi",
    "en": "rabbit",
    "bn": "খরগোশ",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "ねずみ",
    "kanji": "鼠",
    "romaji": "nezumi",
    "en": "mouse",
    "bn": "ইঁদুর",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "ちょうちょ",
    "kanji": "蝶々",
    "romaji": "choucho",
    "en": "butterfly",
    "bn": "প্রজাপতি",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "くも",
    "kanji": "蜘蛛",
    "romaji": "kumo",
    "en": "spider",
    "bn": "মাকড়সা",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "あり",
    "kanji": "蟻",
    "romaji": "ari",
    "en": "ant",
    "bn": "পিঁপড়া",
    "level": "",
    "category": "animals"
  },
  {
    "kana": "りんご",
    "kanji": "林檎",
    "romaji": "ringo",
    "en": "apple",
    "bn": "আপেল",
    "level": "",
    "category": "food"
  },
  {
    "kana": "ばなな",
    "kanji": "バナナ",
    "romaji": "banana",
    "en": "banana",
    "bn": "কলা",
    "level": "",
    "category": "food"
  },
  {
    "kana": "みかん",
    "kanji": "蜜柑",
    "romaji": "mikan",
    "en": "mandarin orange",
    "bn": "কমলা",
    "level": "",
    "category": "food"
  },
  {
    "kana": "いちご",
    "kanji": "苺",
    "romaji": "ichigo",
    "en": "strawberry",
    "bn": "স্ট্রবেরি",
    "level": "",
    "category": "food"
  },
  {
    "kana": "すいか",
    "kanji": "西瓜",
    "romaji": "suika",
    "en": "watermelon",
    "bn": "তরমুজ",
    "level": "",
    "category": "food"
  },
  {
    "kana": "もも",
    "kanji": "桃",
    "romaji": "momo",
    "en": "peach",
    "bn": "পিচ",
    "level": "",
    "category": "food"
  },
  {
    "kana": "なし",
    "kanji": "梨",
    "romaji": "nashi",
    "en": "pear",
    "bn": "নাশপাতি",
    "level": "",
    "category": "food"
  },
  {
    "kana": "じゃがいも",
    "kanji": "馬鈴薯",
    "romaji": "jagaimo",
    "en": "potato",
    "bn": "আলু",
    "level": "",
    "category": "food"
  },
  {
    "kana": "たまねぎ",
    "kanji": "玉葱",
    "romaji": "tamanegi",
    "en": "onion",
    "bn": "পেঁয়াজ",
    "level": "",
    "category": "food"
  },
  {
    "kana": "きゃべつ",
    "kanji": "キャベツ",
    "romaji": "kyabetsu",
    "en": "cabbage",
    "bn": "বাঁধাকপি",
    "level": "",
    "category": "food"
  },
  {
    "kana": "ほうれんそう",
    "kanji": "ほうれん草",
    "romaji": "hourensou",
    "en": "spinach",
    "bn": "পালং শাক",
    "level": "",
    "category": "food"
  },
  {
    "kana": "にんにく",
    "kanji": "大蒜",
    "romaji": "ninniku",
    "en": "garlic",
    "bn": "রসুন",
    "level": "",
    "category": "food"
  },
  {
    "kana": "しょうが",
    "kanji": "生姜",
    "romaji": "shouga",
    "en": "ginger",
    "bn": "আদা",
    "level": "",
    "category": "food"
  },
  {
    "kana": "とまと",
    "kanji": "トマト",
    "romaji": "tomato",
    "en": "tomato",
    "bn": "টমেটো",
    "level": "",
    "category": "food"
  },
  {
    "kana": "てれび",
    "kanji": "テレビ",
    "romaji": "terebi",
    "en": "television",
    "bn": "টেলিভিশন",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "そふぁー",
    "kanji": "ソファー",
    "romaji": "sofaa",
    "en": "sofa",
    "bn": "সোফা",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "べっど",
    "kanji": "ベッド",
    "romaji": "beddo",
    "en": "bed",
    "bn": "বিছানা",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "まくら",
    "kanji": "枕",
    "romaji": "makura",
    "en": "pillow",
    "bn": "বালিশ",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "もうふ",
    "kanji": "毛布",
    "romaji": "moufu",
    "en": "blanket",
    "bn": "কম্বল",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "とけい",
    "kanji": "時計",
    "romaji": "tokei",
    "en": "clock/watch",
    "bn": "ঘড়ি",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "でんわ",
    "kanji": "電話",
    "romaji": "denwa",
    "en": "telephone",
    "bn": "টেলিফোন",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "どあ",
    "kanji": "ドア",
    "romaji": "doa",
    "en": "door",
    "bn": "দরজা",
    "level": "",
    "category": "objects"
  },
  {
    "kana": "かんごし",
    "kanji": "看護師",
    "romaji": "kangoshi",
    "en": "nurse",
    "bn": "নার্স",
    "level": "",
    "category": "people"
  },
  {
    "kana": "えんじにあ",
    "kanji": "エンジニア",
    "romaji": "enjinia",
    "en": "engineer",
    "bn": "ইঞ্জিনিয়ার",
    "level": "",
    "category": "people"
  },
  {
    "kana": "かしゅ",
    "kanji": "歌手",
    "romaji": "kashu",
    "en": "singer",
    "bn": "গায়ক",
    "level": "",
    "category": "people"
  },
  {
    "kana": "がか",
    "kanji": "画家",
    "romaji": "gaka",
    "en": "painter/artist",
    "bn": "চিত্রশিল্পী",
    "level": "",
    "category": "people"
  },
  {
    "kana": "べんごし",
    "kanji": "弁護士",
    "romaji": "bengoshi",
    "en": "lawyer",
    "bn": "আইনজীবী",
    "level": "",
    "category": "people"
  },
  {
    "kana": "しょうぼうし",
    "kanji": "消防士",
    "romaji": "shouboushi",
    "en": "firefighter",
    "bn": "দমকলকর্মী",
    "level": "",
    "category": "people"
  },
  {
    "kana": "りょうりにん",
    "kanji": "料理人",
    "romaji": "ryourinin",
    "en": "cook/chef",
    "bn": "বাবুর্চি",
    "level": "",
    "category": "people"
  },
  {
    "kana": "うんてんしゅ",
    "kanji": "運転手",
    "romaji": "untenshu",
    "en": "driver",
    "bn": "চালক",
    "level": "",
    "category": "people"
  },
  {
    "kana": "て",
    "kanji": "手",
    "romaji": "te",
    "en": "hand",
    "bn": "হাত",
    "level": "",
    "category": "body"
  },
  {
    "kana": "ゆび",
    "kanji": "指",
    "romaji": "yubi",
    "en": "finger",
    "bn": "আঙ্গুল",
    "level": "",
    "category": "body"
  },
  {
    "kana": "じしん",
    "kanji": "地震",
    "romaji": "jishin",
    "en": "earthquake",
    "bn": "ভূমিকম্প",
    "level": "",
    "category": "nature"
  },
  {
    "kana": "たいふう",
    "kanji": "台風",
    "romaji": "taifuu",
    "en": "typhoon",
    "bn": "টাইফুন",
    "level": "",
    "category": "nature"
  },
  {
    "kana": "たいよう",
    "kanji": "太陽",
    "romaji": "taiyou",
    "en": "sun",
    "bn": "সূর্য",
    "level": "",
    "category": "nature"
  },
  {
    "id": "new_v001",
    "kanji": "野菜",
    "kana": "やさい",
    "romaji": "yasai",
    "en": "vegetables",
    "bn": "শাকসবজি",
    "category": "food",
    "level": ""
  },
  {
    "id": "new_v002",
    "kanji": "傘",
    "kana": "かさ",
    "romaji": "kasa",
    "en": "umbrella",
    "bn": "ছাতা",
    "category": "objects",
    "level": ""
  },
  {
    "id": "new_v003",
    "kanji": "植物",
    "kana": "しょくぶつ",
    "romaji": "shokubutsu",
    "en": "plants",
    "bn": "গাছপালা",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v004",
    "kanji": "惑星",
    "kana": "わくせい",
    "en": "planet",
    "bn": "গ্রহ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v005",
    "kanji": "衛星",
    "kana": "えいせい",
    "en": "satellite",
    "bn": "উপগ্রহ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v006",
    "kanji": "犯罪",
    "kana": "はんざい",
    "en": "crime",
    "bn": "অপরাধ",
    "category": "people",
    "level": ""
  },
  {
    "id": "new_v007",
    "kanji": "殺害",
    "kana": "さつがい",
    "en": "killing / murder",
    "bn": "হত্যা",
    "category": "people",
    "level": ""
  },
  {
    "id": "new_v008",
    "kanji": "プロ",
    "kana": "ぷろ",
    "en": "pro / professional",
    "bn": "পেশাদার",
    "category": "digital",
    "level": ""
  },
  {
    "id": "new_v009",
    "kanji": "初心者",
    "kana": "しょしんしゃ",
    "en": "beginner / noob",
    "bn": "নতুন",
    "category": "people",
    "level": ""
  },
  {
    "id": "new_v010",
    "kanji": "禁止",
    "kana": "きんし",
    "en": "banned / forbidden",
    "bn": "নিষিদ্ধ",
    "category": "others",
    "level": ""
  },
  {
    "id": "new_v011",
    "kanji": "殺す",
    "kana": "ころす",
    "en": "to kill",
    "bn": "হত্যা করা",
    "category": "verbs",
    "level": ""
  },
  {
    "id": "new_v012",
    "kanji": "これ",
    "kana": "これ",
    "romaji": "kore",
    "en": "this",
    "bn": "এটা",
    "category": "others",
    "level": ""
  },
  {
    "id": "new_v013",
    "kanji": "それ",
    "kana": "それ",
    "romaji": "sore",
    "en": "that",
    "bn": "ওটা",
    "category": "others",
    "level": ""
  },
  {
    "id": "new_v014",
    "kanji": "あれ",
    "kana": "あれ",
    "romaji": "are",
    "en": "that (over there)",
    "bn": "ঐটা",
    "category": "others",
    "level": ""
  },
  {
    "id": "new_v015",
    "kanji": "なんてこった",
    "kana": "なんてこった",
    "romaji": "nante kotta",
    "en": "WTF / Oh my god",
    "bn": "ওহ খোদা",
    "category": "expressions",
    "level": ""
  },
  {
    "id": "new_v016",
    "kanji": "バッグ",
    "kana": "ばっぐ",
    "romaji": "baggu",
    "en": "bag",
    "bn": "ব্যাগ",
    "category": "objects",
    "level": ""
  },
  {
    "id": "new_v017",
    "kanji": "太陽",
    "kana": "たいよう",
    "romaji": "taiyou",
    "en": "sun",
    "bn": "সূর্য",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v018",
    "kanji": "月",
    "kana": "つき",
    "romaji": "tsuki",
    "en": "moon",
    "bn": "চাঁদ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v019",
    "kanji": "星",
    "kana": "ほし",
    "romaji": "hoshi",
    "en": "star",
    "bn": "তারা",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v020",
    "kanji": "地面",
    "kana": "じめん",
    "romaji": "jimen",
    "en": "ground",
    "bn": "মাটি",
    "category": "nature",
    "level": ""
  },
  {
    "id": "new_v021",
    "kanji": "警察",
    "kana": "けいさつ",
    "romaji": "keisatsu",
    "en": "police",
    "bn": "পুলিশ",
    "category": "people",
    "level": ""
  },
  {
    "id": "new_v022",
    "kanji": "泥棒",
    "kana": "どろぼう",
    "romaji": "dorobou",
    "en": "thief",
    "bn": "চোর",
    "category": "people",
    "level": ""
  },
  {
    "id": "new_v023",
    "kanji": "武器",
    "kana": "ぶき",
    "romaji": "buki",
    "en": "weapon",
    "bn": "অস্ত্র",
    "category": "objects",
    "level": ""
  },
  {
    "id": "new_v024",
    "kanji": "平和",
    "kana": "へいわ",
    "romaji": "heiwa",
    "en": "peace",
    "bn": "শান্তি",
    "category": "emotions",
    "level": ""
  },
  {
    "id": "new_v025",
    "kanji": "戦い",
    "kana": "たたかい",
    "romaji": "tatakai",
    "en": "battle / fight",
    "bn": "যুদ্ধ",
    "category": "verbs",
    "level": ""
  },
  {
    "id": "real_a001",
    "kanji": "猫",
    "kana": "ねこ",
    "romaji": "neko",
    "en": "cat",
    "bn": "বিড়াল",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a002",
    "kanji": "犬",
    "kana": "いぬ",
    "romaji": "inu",
    "en": "dog",
    "bn": "কুকুর",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a003",
    "kanji": "鳥",
    "kana": "とり",
    "romaji": "tori",
    "en": "bird",
    "bn": "পাখি",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a004",
    "kanji": "魚",
    "kana": "さかな",
    "romaji": "sakana",
    "en": "fish",
    "bn": "মাছ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a005",
    "kanji": "象",
    "kana": "ぞう",
    "romaji": "zou",
    "en": "elephant",
    "bn": "হাতি",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a006",
    "kanji": "猿",
    "kana": "さる",
    "romaji": "saru",
    "en": "monkey",
    "bn": "বানর",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a007",
    "kanji": "馬",
    "kana": "うま",
    "romaji": "uma",
    "en": "horse",
    "bn": "ঘোড়া",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a008",
    "kanji": "牛",
    "kana": "うし",
    "romaji": "ushi",
    "en": "cow",
    "bn": "গরু",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a009",
    "kanji": "虎",
    "kana": "とら",
    "romaji": "tora",
    "en": "tiger",
    "bn": "বাঘ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_a010",
    "kanji": "熊",
    "kana": "くま",
    "romaji": "kuma",
    "en": "bear",
    "bn": "ভল্লুক",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_b001",
    "kanji": "目",
    "kana": "め",
    "romaji": "me",
    "en": "eye",
    "bn": "চোখ",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b002",
    "kanji": "耳",
    "kana": "みみ",
    "romaji": "mimi",
    "en": "ear",
    "bn": "কান",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b003",
    "kanji": "鼻",
    "kana": "はな",
    "romaji": "hana",
    "en": "nose",
    "bn": "নাক",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b004",
    "kanji": "口",
    "kana": "くち",
    "romaji": "kuchi",
    "en": "mouth",
    "bn": "মুখ",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b005",
    "kanji": "手",
    "kana": "て",
    "romaji": "te",
    "en": "hand",
    "bn": "হাত",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b006",
    "kanji": "足",
    "kana": "あし",
    "romaji": "ashi",
    "en": "foot / leg",
    "bn": "পা",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b007",
    "kanji": "頭",
    "kana": "あたま",
    "romaji": "atama",
    "en": "head",
    "bn": "মাথা",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b008",
    "kanji": "心",
    "kana": "こころ",
    "romaji": "kokoro",
    "en": "heart / spirit",
    "bn": "মন",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b009",
    "kanji": "指",
    "kana": "ゆび",
    "romaji": "yubi",
    "en": "finger",
    "bn": "আঙুল",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_b010",
    "kanji": "髪",
    "kana": "かみ",
    "romaji": "kami",
    "en": "hair",
    "bn": "চুল",
    "category": "body",
    "level": ""
  },
  {
    "id": "real_n001",
    "kanji": "山",
    "kana": "やま",
    "romaji": "yama",
    "en": "mountain",
    "bn": "পাহাড়",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n002",
    "kanji": "川",
    "kana": "かわ",
    "romaji": "kawa",
    "en": "river",
    "bn": "নদী",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n003",
    "kanji": "海",
    "kana": "うみ",
    "romaji": "umi",
    "en": "sea",
    "bn": "সমুদ্র",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n004",
    "kanji": "空",
    "kana": "そら",
    "romaji": "sora",
    "en": "sky",
    "bn": "আকাশ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n005",
    "kanji": "雨",
    "kana": "あめ",
    "romaji": "ame",
    "en": "rain",
    "bn": "বৃষ্টি",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n006",
    "kanji": "雪",
    "kana": "ゆき",
    "romaji": "yuki",
    "en": "snow",
    "bn": "বরফ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n007",
    "kanji": "雲",
    "kana": "くも",
    "romaji": "kumo",
    "en": "cloud",
    "bn": "মেঘ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n008",
    "kanji": "風",
    "kana": "かぜ",
    "romaji": "kaze",
    "en": "wind",
    "bn": "বাতাস",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n009",
    "kanji": "光",
    "kana": "ひかり",
    "romaji": "hikari",
    "en": "light",
    "bn": "আলো",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_n010",
    "kanji": "星空",
    "kana": "ほしぞら",
    "romaji": "hoshizora",
    "en": "starry sky",
    "bn": "তারকা খচিত আকাশ",
    "category": "nature",
    "level": ""
  },
  {
    "id": "real_t001",
    "kanji": "電話",
    "kana": "でんわ",
    "romaji": "denwa",
    "en": "telephone",
    "bn": "টেলিফোন",
    "category": "digital",
    "level": ""
  },
  {
    "id": "real_t002",
    "kanji": "電気",
    "kana": "でんき",
    "romaji": "denki",
    "en": "electricity",
    "bn": "বিদ্যুত",
    "category": "digital",
    "level": ""
  },
  {
    "id": "real_t003",
    "kanji": "電子",
    "kana": "でんし",
    "romaji": "denshi",
    "en": "electronic",
    "bn": "ইলেকট্রনিক",
    "category": "digital",
    "level": ""
  },
  {
    "id": "real_t004",
    "kanji": "情報",
    "kana": "じょうほう",
    "romaji": "jouhou",
    "en": "information",
    "bn": "তথ্য",
    "category": "digital",
    "level": ""
  },
  {
    "id": "real_t005",
    "kanji": "通信",
    "kana": "つうしん",
    "romaji": "tsuushin",
    "en": "communication",
    "bn": "যোগাযোগ",
    "category": "digital",
    "level": ""
  },
  {
    "id": "real_t006",
    "kanji": "機械",
    "kana": "きかい",
    "romaji": "kikai",
    "en": "machine",
    "bn": "যন্ত্র",
    "category": "digital",
    "level": ""
  },
  {
    "id": "real_t007",
    "kanji": "未来",
    "kana": "みらい",
    "romaji": "mirai",
    "en": "future",
    "bn": "ভবিষ্যৎ",
    "category": "time",
    "level": ""
  },
  {
    "id": "real_t008",
    "kanji": "歴史",
    "kana": "れきし",
    "romaji": "rekishi",
    "en": "history",
    "bn": "ইতিহাস",
    "category": "time",
    "level": ""
  },
  { id: "v2001", kanji: "自然", kana: "しぜん", romaji: "shizen", en: "nature", bn: "প্রকৃতি", category: "nature", level: "N4" },
  { id: "v2002", kanji: "環境", kana: "かんきょう", romaji: "kankyou", en: "environment", bn: "পরিবেশ", category: "nature", level: "N4" },
  { id: "v2003", kanji: "平和", kana: "へいわ", romaji: "heiwa", en: "peace", bn: "শান্তি", category: "abstract", level: "N4" },
  { id: "v2004", kanji: "自由", kana: "じゆう", romaji: "jiyuu", en: "freedom", bn: "স্বাধীনতা", category: "abstract", level: "N4" },
  { id: "v2005", kanji: "関係", kana: "かんけい", romaji: "kankei", en: "relationship", bn: "সম্পর্ক", category: "abstract", level: "N4" },
  { id: "v2006", kanji: "結果", kana: "けっか", romaji: "kekka", en: "result", bn: "ফলাফল", category: "abstract", level: "N4" },
  { id: "v2007", kanji: "理由", kana: "りゆう", romaji: "riyuu", en: "reason", bn: "কারণ", category: "abstract", level: "N4" },
  { id: "v2008", kanji: "方法", kana: "ほうほう", romaji: "houhou", en: "method/way", bn: "পদ্ধতি", category: "abstract", level: "N4" },
  { id: "v2009", kanji: "計画", kana: "けいかく", romaji: "keikaku", en: "plan", bn: "পরিকল্পনা", category: "abstract", level: "N4" },
  { id: "v2010", kanji: "成功", kana: "せいこう", romaji: "seikou", en: "success", bn: "সাফল্য", category: "abstract", level: "N4" },
  { id: "v2011", kanji: "失敗", kana: "しっぱい", romaji: "shippai", en: "failure", bn: "ব্যর্থতা", category: "abstract", level: "N4" },
  { id: "v2012", kanji: "準備", kana: "じゅんび", romaji: "junbi", en: "preparation", bn: "প্রস্তুতি", category: "abstract", level: "N4" },
  { id: "v2013", kanji: "説明", kana: "せつめい", romaji: "setsumei", en: "explanation", bn: "ব্যাখ্যা", category: "abstract", level: "N4" },
  { id: "v2014", kanji: "注意", kana: "ちゅうい", romaji: "chuui", en: "caution/attention", bn: "সাবধানতা", category: "abstract", level: "N4" },
  { id: "v2015", kanji: "反対", kana: "はんたい", romaji: "hantai", en: "opposite/opposition", bn: "বিপরীত", category: "abstract", level: "N4" },
  { id: "v2016", kanji: "賛成", kana: "さんせい", romaji: "sansei", en: "agreement/approval", bn: "অনুমোদন", category: "abstract", level: "N4" },
  { id: "v2017", kanji: "意味", kana: "いみ", romaji: "imi", en: "meaning", bn: "অর্থ", category: "abstract", level: "N4" },
  { id: "v2018", kanji: "目的", kana: "もくてき", romaji: "mokuteki", en: "purpose", bn: "উদ্দেশ্য", category: "abstract", level: "N3" },
  { id: "v2019", kanji: "未来", kana: "みらい", romaji: "mirai", en: "future", bn: "ভবিষ্যৎ", category: "time", level: "N3" },
  { id: "v2020", kanji: "過去", kana: "かこ", romaji: "kako", en: "past", bn: "অতীত", category: "time", level: "N3" },
  { id: "v2021", kanji: "現在", kana: "げんざい", romaji: "genzai", en: "present (now)", bn: "বর্তমান", category: "time", level: "N3" },
  { id: "v2022", kanji: "季節", kana: "きせつ", romaji: "kisetsu", en: "season", bn: "ঋতু", category: "time", level: "N4" },
  { id: "v2023", kanji: "世界", kana: "せかい", romaji: "sekai", en: "world", bn: "পৃথিবী", category: "place", level: "N4" },
  { id: "v2024", kanji: "社会", kana: "しゃかい", romaji: "shakai", en: "society", bn: "সমাজ", category: "place", level: "N4" },
  { id: "v2025", kanji: "経済", kana: "けいざい", romaji: "keizai", en: "economy", bn: "অর্থনীতি", category: "place", level: "N3" },
  { id: "v2026", kanji: "政治", kana: "せいじ", romaji: "seiji", en: "politics", bn: "রাজনীতি", category: "place", level: "N3" },
  { id: "v2027", kanji: "法律", kana: "ほうりつ", romaji: "houritsu", en: "law", bn: "আইন", category: "place", level: "N3" },
  { id: "v2028", kanji: "教育", kana: "きょういく", romaji: "kyouiku", en: "education", bn: "শিক্ষা", category: "place", level: "N3" },
  { id: "v2029", kanji: "文化", kana: "ぶんか", romaji: "bunka", en: "culture", bn: "সংস্কৃতি", category: "place", level: "N4" },
  { id: "v2030", kanji: "芸術", kana: "げいじゅつ", romaji: "geijutsu", en: "art", bn: "শিল্প", category: "place", level: "N3" },
  { id: "v2031", kanji: "技術", kana: "ぎじゅつ", romaji: "gijutsu", en: "technology", bn: "প্রযুক্তি", category: "place", level: "N3" },
  { id: "v2032", kanji: "健康", kana: "けんこう", romaji: "kenkou", en: "health", bn: "স্বাস্থ্য", category: "body", level: "N4" },
  { id: "v2033", kanji: "病院", kana: "びょういん", romaji: "byouin", en: "hospital", bn: "হাসপাতাল", category: "place", level: "N5" },
  { id: "v2034", kanji: "薬", kana: "くすり", romaji: "kusuri", en: "medicine", bn: "ওষুধ", category: "objects", level: "N5" },
  { id: "v2035", kanji: "元気", kana: "げんき", romaji: "genki", en: "healthy/energetic", bn: "সুস্থ", category: "adjectives", level: "N5" },
  { id: "v2036", kanji: "病気", kana: "びょうき", romaji: "byouki", en: "illness/sick", bn: "অসুখ", category: "adjectives", level: "N5" },
  { id: "v2037", kanji: "疲れる", kana: "つかれる", romaji: "tsukareru", en: "to get tired", bn: "ক্লান্ত হওয়া", category: "verbs", level: "N5" },
  { id: "v2038", kanji: "休む", kana: "やすむ", romaji: "yasumu", en: "to rest", bn: "বিশ্রাম নেওয়া", category: "verbs", level: "N5" },
  { id: "v2039", kanji: "運動", kana: "うんどう", romaji: "undou", en: "exercise", bn: "ব্যায়াম", category: "abstract", level: "N4" },
  { id: "v2040", kanji: "スポーツ", kana: "supootsu", romaji: "supootsu", en: "sports", bn: "খেলাধুলা", category: "abstract", level: "N5" },
  { id: "v2041", kanji: "趣味", kana: "しゅみ", romaji: "shumi", en: "hobby", bn: "শখ", category: "abstract", level: "N4" },
  { id: "v2042", kanji: "音楽", kana: "おんがく", romaji: "ongaku", en: "music", bn: "গান", category: "objects", level: "N5" },
  { id: "v2043", kanji: "読書", kana: "どくしょ", romaji: "dokusho", en: "reading books", bn: "বই পড়া", category: "abstract", level: "N4" },
  { id: "v2044", kanji: "旅行", kana: "りょこう", romaji: "ryokou", en: "travel", bn: "ভ্রমণ", category: "abstract", level: "N4" },
  { id: "v2045", kanji: "料理", kana: "りょうり", romaji: "ryouri", en: "cooking", bn: "রান্না", category: "abstract", level: "N5" },
  { id: "v2046", kanji: "美味しい", kana: "おいしい", romaji: "oishii", en: "delicious", bn: "সুস্বাদু", category: "adjectives", level: "N5" },
  { id: "v2047", kanji: "不味い", kana: "まずい", romaji: "mazui", en: "tastes bad", bn: "বেস্বাদ", category: "adjectives", level: "N5" },
  { id: "v2048", kanji: "甘い", kana: "あまい", romaji: "amai", en: "sweet", bn: "মিষ্টি", category: "adjectives", level: "N5" },
  { id: "v2049", kanji: "辛い", kana: "からい", romaji: "karai", en: "spicy", bn: "ঝাল", category: "adjectives", level: "N5" },
  { id: "v2050", kanji: "塩辛い", kana: "しおからい", romaji: "shiokarai", en: "salty", bn: "নোনতা", category: "adjectives", level: "N5" },
  { id: "v2051", kanji: "苦い", kana: "にがい", romaji: "nigai", en: "bitter", bn: "তিতা", category: "adjectives", level: "N5" },
  { id: "v2052", kanji: "酸っぱい", kana: "すっぱい", romaji: "suppai", en: "sour", bn: "টক", category: "adjectives", level: "N5" },
  { id: "v2053", kanji: "買い物", kana: "かいもの", romaji: "kaimono", en: "shopping", bn: "কেনাকাটা", category: "abstract", level: "N5" },
  { id: "v2054", kanji: "店", kana: "みせ", romaji: "mise", en: "shop/store", bn: "দোকান", category: "place", level: "N5" },
  { id: "v2055", kanji: "値段", kana: "ねだん", romaji: "nedan", en: "price", bn: "দাম", category: "objects", level: "N4" },
  { id: "v2056", kanji: "お金", kana: "おかね", romaji: "okane", en: "money", bn: "টাকা", category: "objects", level: "N5" },
  { id: "v2057", kanji: "財布", kana: "さいふ", romaji: "saifu", en: "wallet", bn: "মানিব্যাগ", category: "objects", level: "N5" },
  { id: "v2058", kanji: "銀行", kana: "ぎんこう", romaji: "ginkou", en: "bank", bn: "ব্যাংক", category: "place", level: "N5" },
  { id: "v2059", kanji: "会社", kana: "かいしゃ", romaji: "kaisha", en: "company", bn: "কোম্পানি", category: "place", level: "N5" },
  { id: "v2060", kanji: "仕事", kana: "しごと", romaji: "shigoto", en: "work", bn: "কাজ", category: "abstract", level: "N5" },
  { id: "v2061", kanji: "会議", kana: "かいぎ", romaji: "kaigi", en: "meeting", bn: "মিটিং", category: "abstract", level: "N4" },
  { id: "v2062", kanji: "電話", kana: "でんわ", romaji: "denwa", en: "telephone", bn: "ফোন", category: "objects", level: "N5" },
  { id: "v2063", kanji: "手紙", kana: "てがみ", romaji: "tegami", en: "letter", bn: "চিঠি", category: "objects", level: "N5" },
  { id: "v2064", kanji: "切手", kana: "きって", romaji: "kitte", en: "stamp", bn: "ডাকটিকিট", category: "objects", level: "N5" },
  { id: "v2065", kanji: "封筒", kana: "ふうとう", romaji: "fuutou", en: "envelope", bn: "খাম", category: "objects", level: "N5" },
  { id: "v2066", kanji: "郵便局", kana: "ゆうびんきょく", romaji: "yuubinkyoku", en: "post office", bn: "ডাকঘর", category: "place", level: "N5" },
  { id: "v2067", kanji: "友達", kana: "ともだち", romaji: "tomodachi", en: "friend", bn: "বন্ধু", category: "people", level: "N5" },
  { id: "v2068", kanji: "恋人", kana: "こいびと", romaji: "koibito", en: "lover/partner", bn: "প্রেমিক/প্রেমিকা", category: "people", level: "N4" },
  { id: "v2069", kanji: "家族", kana: "かぞく", romaji: "kazoku", en: "family", bn: "পরিবার", category: "family", level: "N5" },
  { id: "v2070", kanji: "両親", kana: "りょうしん", romaji: "ryoushin", en: "parents", bn: "বাবা-মা", category: "family", level: "N4" },
  { id: "v2071", kanji: "兄弟", kana: "きょうだい", romaji: "kyoudai", en: "siblings", bn: "ভাইবোন", category: "family", level: "N5" },
  { id: "v2072", kanji: "子供", kana: "こども", romaji: "kodomo", en: "child", bn: "শিশু", category: "family", level: "N5" },
  { id: "v2073", kanji: "大人", kana: "おとな", romaji: "otona", en: "adult", bn: "প্রাপ্তবয়স্ক", category: "people", level: "N5" },
  { id: "v2074", kanji: "先生", kana: "せんせい", romaji: "sensei", en: "teacher", bn: "শিক্ষক", category: "people", level: "N5" },
  { id: "v2075", kanji: "学生", kana: "がくせい", romaji: "gakusei", en: "student", bn: "ছাত্র", category: "people", level: "N5" },
  { id: "v2076", kanji: "学校", kana: "がっこう", romaji: "gakkou", en: "school", bn: "স্কুল", category: "place", level: "N5" },
  { id: "v2077", kanji: "教室", kana: "きょうしつ", romaji: "kyoushitsu", en: "classroom", bn: "শ্রেণীকক্ষ", category: "place", level: "N5" },
  { id: "v2078", kanji: "宿題", kana: "しゅくだい", romaji: "shukudai", en: "homework", bn: "বাড়ির কাজ", category: "abstract", level: "N5" },
  { id: "v2079", kanji: "試験", kana: "しけん", romaji: "shiken", en: "exam", bn: "পরীক্ষা", category: "abstract", level: "N5" },
  { id: "v2080", kanji: "意味", kana: "いみ", romaji: "imi", en: "meaning", bn: "অর্থ", category: "abstract", level: "N5" }
];